var wr = Object.defineProperty;
var Or = (e, t, n) => t in e ? wr(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var po = (e, t, n) => Or(e, typeof t != "symbol" ? t + "" : t, n);
/**
* @vue/shared v3.5.24
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
// @__NO_SIDE_EFFECTS__
function tt(e) {
  const t = /* @__PURE__ */ Object.create(null);
  for (const n of e.split(",")) t[n] = 1;
  return (n) => n in t;
}
const z = process.env.NODE_ENV !== "production" ? Object.freeze({}) : {}, At = process.env.NODE_ENV !== "production" ? Object.freeze([]) : [], se = () => {
}, ii = () => !1, un = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // uppercase letter
(e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97), Mn = (e) => e.startsWith("onUpdate:"), ne = Object.assign, Ko = (e, t) => {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}, Dr = Object.prototype.hasOwnProperty, K = (e, t) => Dr.call(e, t), C = Array.isArray, yt = (e) => fn(e) === "[object Map]", Gn = (e) => fn(e) === "[object Set]", gs = (e) => fn(e) === "[object Date]", k = (e) => typeof e == "function", Q = (e) => typeof e == "string", ke = (e) => typeof e == "symbol", W = (e) => e !== null && typeof e == "object", Uo = (e) => (W(e) || k(e)) && k(e.then) && k(e.catch), ri = Object.prototype.toString, fn = (e) => ri.call(e), Bo = (e) => fn(e).slice(8, -1), li = (e) => fn(e) === "[object Object]", Wo = (e) => Q(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e, Qt = /* @__PURE__ */ tt(
  // the leading comma is intentional so empty string "" is also included
  ",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"
), Sr = /* @__PURE__ */ tt(
  "bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo"
), Jn = (e) => {
  const t = /* @__PURE__ */ Object.create(null);
  return (n) => t[n] || (t[n] = e(n));
}, Vr = /-\w/g, $e = Jn(
  (e) => e.replace(Vr, (t) => t.slice(1).toUpperCase())
), Cr = /\B([A-Z])/g, dt = Jn(
  (e) => e.replace(Cr, "-$1").toLowerCase()
), Yn = Jn((e) => e.charAt(0).toUpperCase() + e.slice(1)), vt = Jn(
  (e) => e ? `on${Yn(e)}` : ""
), ut = (e, t) => !Object.is(e, t), It = (e, ...t) => {
  for (let n = 0; n < e.length; n++)
    e[n](...t);
}, An = (e, t, n, o = !1) => {
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: !1,
    writable: o,
    value: n
  });
}, qo = (e) => {
  const t = parseFloat(e);
  return isNaN(t) ? e : t;
};
let ms;
const dn = () => ms || (ms = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function Zn(e) {
  if (C(e)) {
    const t = {};
    for (let n = 0; n < e.length; n++) {
      const o = e[n], s = Q(o) ? kr(o) : Zn(o);
      if (s)
        for (const i in s)
          t[i] = s[i];
    }
    return t;
  } else if (Q(e) || W(e))
    return e;
}
const $r = /;(?![^(]*\))/g, Tr = /:([^]+)/, Ir = /\/\*[^]*?\*\//g;
function kr(e) {
  const t = {};
  return e.replace(Ir, "").split($r).forEach((n) => {
    if (n) {
      const o = n.split(Tr);
      o.length > 1 && (t[o[0].trim()] = o[1].trim());
    }
  }), t;
}
function Lt(e) {
  let t = "";
  if (Q(e))
    t = e;
  else if (C(e))
    for (let n = 0; n < e.length; n++) {
      const o = Lt(e[n]);
      o && (t += o + " ");
    }
  else if (W(e))
    for (const n in e)
      e[n] && (t += n + " ");
  return t.trim();
}
const Mr = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot", Ar = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view", Pr = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics", jr = /* @__PURE__ */ tt(Mr), Rr = /* @__PURE__ */ tt(Ar), Fr = /* @__PURE__ */ tt(Pr), Lr = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly", Hr = /* @__PURE__ */ tt(Lr);
function ci(e) {
  return !!e || e === "";
}
function Kr(e, t) {
  if (e.length !== t.length) return !1;
  let n = !0;
  for (let o = 0; n && o < e.length; o++)
    n = Qn(e[o], t[o]);
  return n;
}
function Qn(e, t) {
  if (e === t) return !0;
  let n = gs(e), o = gs(t);
  if (n || o)
    return n && o ? e.getTime() === t.getTime() : !1;
  if (n = ke(e), o = ke(t), n || o)
    return e === t;
  if (n = C(e), o = C(t), n || o)
    return n && o ? Kr(e, t) : !1;
  if (n = W(e), o = W(t), n || o) {
    if (!n || !o)
      return !1;
    const s = Object.keys(e).length, i = Object.keys(t).length;
    if (s !== i)
      return !1;
    for (const r in e) {
      const l = e.hasOwnProperty(r), c = t.hasOwnProperty(r);
      if (l && !c || !l && c || !Qn(e[r], t[r]))
        return !1;
    }
  }
  return String(e) === String(t);
}
function ai(e, t) {
  return e.findIndex((n) => Qn(n, t));
}
const ui = (e) => !!(e && e.__v_isRef === !0), Z = (e) => Q(e) ? e : e == null ? "" : C(e) || W(e) && (e.toString === ri || !k(e.toString)) ? ui(e) ? Z(e.value) : JSON.stringify(e, fi, 2) : String(e), fi = (e, t) => ui(t) ? fi(e, t.value) : yt(t) ? {
  [`Map(${t.size})`]: [...t.entries()].reduce(
    (n, [o, s], i) => (n[ho(o, i) + " =>"] = s, n),
    {}
  )
} : Gn(t) ? {
  [`Set(${t.size})`]: [...t.values()].map((n) => ho(n))
} : ke(t) ? ho(t) : W(t) && !C(t) && !li(t) ? String(t) : t, ho = (e, t = "") => {
  var n;
  return (
    // Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    ke(e) ? `Symbol(${(n = e.description) != null ? n : t})` : e
  );
};
/**
* @vue/reactivity v3.5.24
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function Me(e, ...t) {
  console.warn(`[Vue warn] ${e}`, ...t);
}
let ye;
class Ur {
  constructor(t = !1) {
    this.detached = t, this._active = !0, this._on = 0, this.effects = [], this.cleanups = [], this._isPaused = !1, this.parent = ye, !t && ye && (this.index = (ye.scopes || (ye.scopes = [])).push(
      this
    ) - 1);
  }
  get active() {
    return this._active;
  }
  pause() {
    if (this._active) {
      this._isPaused = !0;
      let t, n;
      if (this.scopes)
        for (t = 0, n = this.scopes.length; t < n; t++)
          this.scopes[t].pause();
      for (t = 0, n = this.effects.length; t < n; t++)
        this.effects[t].pause();
    }
  }
  /**
   * Resumes the effect scope, including all child scopes and effects.
   */
  resume() {
    if (this._active && this._isPaused) {
      this._isPaused = !1;
      let t, n;
      if (this.scopes)
        for (t = 0, n = this.scopes.length; t < n; t++)
          this.scopes[t].resume();
      for (t = 0, n = this.effects.length; t < n; t++)
        this.effects[t].resume();
    }
  }
  run(t) {
    if (this._active) {
      const n = ye;
      try {
        return ye = this, t();
      } finally {
        ye = n;
      }
    } else process.env.NODE_ENV !== "production" && Me("cannot run an inactive effect scope.");
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  on() {
    ++this._on === 1 && (this.prevScope = ye, ye = this);
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  off() {
    this._on > 0 && --this._on === 0 && (ye = this.prevScope, this.prevScope = void 0);
  }
  stop(t) {
    if (this._active) {
      this._active = !1;
      let n, o;
      for (n = 0, o = this.effects.length; n < o; n++)
        this.effects[n].stop();
      for (this.effects.length = 0, n = 0, o = this.cleanups.length; n < o; n++)
        this.cleanups[n]();
      if (this.cleanups.length = 0, this.scopes) {
        for (n = 0, o = this.scopes.length; n < o; n++)
          this.scopes[n].stop(!0);
        this.scopes.length = 0;
      }
      if (!this.detached && this.parent && !t) {
        const s = this.parent.scopes.pop();
        s && s !== this && (this.parent.scopes[this.index] = s, s.index = this.index);
      }
      this.parent = void 0;
    }
  }
}
function Br() {
  return ye;
}
let q;
const go = /* @__PURE__ */ new WeakSet();
class di {
  constructor(t) {
    this.fn = t, this.deps = void 0, this.depsTail = void 0, this.flags = 5, this.next = void 0, this.cleanup = void 0, this.scheduler = void 0, ye && ye.active && ye.effects.push(this);
  }
  pause() {
    this.flags |= 64;
  }
  resume() {
    this.flags & 64 && (this.flags &= -65, go.has(this) && (go.delete(this), this.trigger()));
  }
  /**
   * @internal
   */
  notify() {
    this.flags & 2 && !(this.flags & 32) || this.flags & 8 || hi(this);
  }
  run() {
    if (!(this.flags & 1))
      return this.fn();
    this.flags |= 2, vs(this), gi(this);
    const t = q, n = Te;
    q = this, Te = !0;
    try {
      return this.fn();
    } finally {
      process.env.NODE_ENV !== "production" && q !== this && Me(
        "Active effect was not restored correctly - this is likely a Vue internal bug."
      ), mi(this), q = t, Te = n, this.flags &= -3;
    }
  }
  stop() {
    if (this.flags & 1) {
      for (let t = this.deps; t; t = t.nextDep)
        Jo(t);
      this.deps = this.depsTail = void 0, vs(this), this.onStop && this.onStop(), this.flags &= -2;
    }
  }
  trigger() {
    this.flags & 64 ? go.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
  }
  /**
   * @internal
   */
  runIfDirty() {
    Oo(this) && this.run();
  }
  get dirty() {
    return Oo(this);
  }
}
let pi = 0, Xt, en;
function hi(e, t = !1) {
  if (e.flags |= 8, t) {
    e.next = en, en = e;
    return;
  }
  e.next = Xt, Xt = e;
}
function zo() {
  pi++;
}
function Go() {
  if (--pi > 0)
    return;
  if (en) {
    let t = en;
    for (en = void 0; t; ) {
      const n = t.next;
      t.next = void 0, t.flags &= -9, t = n;
    }
  }
  let e;
  for (; Xt; ) {
    let t = Xt;
    for (Xt = void 0; t; ) {
      const n = t.next;
      if (t.next = void 0, t.flags &= -9, t.flags & 1)
        try {
          t.trigger();
        } catch (o) {
          e || (e = o);
        }
      t = n;
    }
  }
  if (e) throw e;
}
function gi(e) {
  for (let t = e.deps; t; t = t.nextDep)
    t.version = -1, t.prevActiveLink = t.dep.activeLink, t.dep.activeLink = t;
}
function mi(e) {
  let t, n = e.depsTail, o = n;
  for (; o; ) {
    const s = o.prevDep;
    o.version === -1 ? (o === n && (n = s), Jo(o), Wr(o)) : t = o, o.dep.activeLink = o.prevActiveLink, o.prevActiveLink = void 0, o = s;
  }
  e.deps = t, e.depsTail = n;
}
function Oo(e) {
  for (let t = e.deps; t; t = t.nextDep)
    if (t.dep.version !== t.version || t.dep.computed && (vi(t.dep.computed) || t.dep.version !== t.version))
      return !0;
  return !!e._dirty;
}
function vi(e) {
  if (e.flags & 4 && !(e.flags & 16) || (e.flags &= -17, e.globalVersion === sn) || (e.globalVersion = sn, !e.isSSR && e.flags & 128 && (!e.deps && !e._dirty || !Oo(e))))
    return;
  e.flags |= 2;
  const t = e.dep, n = q, o = Te;
  q = e, Te = !0;
  try {
    gi(e);
    const s = e.fn(e._value);
    (t.version === 0 || ut(s, e._value)) && (e.flags |= 128, e._value = s, t.version++);
  } catch (s) {
    throw t.version++, s;
  } finally {
    q = n, Te = o, mi(e), e.flags &= -3;
  }
}
function Jo(e, t = !1) {
  const { dep: n, prevSub: o, nextSub: s } = e;
  if (o && (o.nextSub = s, e.prevSub = void 0), s && (s.prevSub = o, e.nextSub = void 0), process.env.NODE_ENV !== "production" && n.subsHead === e && (n.subsHead = s), n.subs === e && (n.subs = o, !o && n.computed)) {
    n.computed.flags &= -5;
    for (let i = n.computed.deps; i; i = i.nextDep)
      Jo(i, !0);
  }
  !t && !--n.sc && n.map && n.map.delete(n.key);
}
function Wr(e) {
  const { prevDep: t, nextDep: n } = e;
  t && (t.nextDep = n, e.prevDep = void 0), n && (n.prevDep = t, e.nextDep = void 0);
}
let Te = !0;
const _i = [];
function Ae() {
  _i.push(Te), Te = !1;
}
function Pe() {
  const e = _i.pop();
  Te = e === void 0 ? !0 : e;
}
function vs(e) {
  const { cleanup: t } = e;
  if (e.cleanup = void 0, t) {
    const n = q;
    q = void 0;
    try {
      t();
    } finally {
      q = n;
    }
  }
}
let sn = 0;
class qr {
  constructor(t, n) {
    this.sub = t, this.dep = n, this.version = n.version, this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
  }
}
class Yo {
  // TODO isolatedDeclarations "__v_skip"
  constructor(t) {
    this.computed = t, this.version = 0, this.activeLink = void 0, this.subs = void 0, this.map = void 0, this.key = void 0, this.sc = 0, this.__v_skip = !0, process.env.NODE_ENV !== "production" && (this.subsHead = void 0);
  }
  track(t) {
    if (!q || !Te || q === this.computed)
      return;
    let n = this.activeLink;
    if (n === void 0 || n.sub !== q)
      n = this.activeLink = new qr(q, this), q.deps ? (n.prevDep = q.depsTail, q.depsTail.nextDep = n, q.depsTail = n) : q.deps = q.depsTail = n, bi(n);
    else if (n.version === -1 && (n.version = this.version, n.nextDep)) {
      const o = n.nextDep;
      o.prevDep = n.prevDep, n.prevDep && (n.prevDep.nextDep = o), n.prevDep = q.depsTail, n.nextDep = void 0, q.depsTail.nextDep = n, q.depsTail = n, q.deps === n && (q.deps = o);
    }
    return process.env.NODE_ENV !== "production" && q.onTrack && q.onTrack(
      ne(
        {
          effect: q
        },
        t
      )
    ), n;
  }
  trigger(t) {
    this.version++, sn++, this.notify(t);
  }
  notify(t) {
    zo();
    try {
      if (process.env.NODE_ENV !== "production")
        for (let n = this.subsHead; n; n = n.nextSub)
          n.sub.onTrigger && !(n.sub.flags & 8) && n.sub.onTrigger(
            ne(
              {
                effect: n.sub
              },
              t
            )
          );
      for (let n = this.subs; n; n = n.prevSub)
        n.sub.notify() && n.sub.dep.notify();
    } finally {
      Go();
    }
  }
}
function bi(e) {
  if (e.dep.sc++, e.sub.flags & 4) {
    const t = e.dep.computed;
    if (t && !e.dep.subs) {
      t.flags |= 20;
      for (let o = t.deps; o; o = o.nextDep)
        bi(o);
    }
    const n = e.dep.subs;
    n !== e && (e.prevSub = n, n && (n.nextSub = e)), process.env.NODE_ENV !== "production" && e.dep.subsHead === void 0 && (e.dep.subsHead = e), e.dep.subs = e;
  }
}
const Do = /* @__PURE__ */ new WeakMap(), Et = Symbol(
  process.env.NODE_ENV !== "production" ? "Object iterate" : ""
), So = Symbol(
  process.env.NODE_ENV !== "production" ? "Map keys iterate" : ""
), rn = Symbol(
  process.env.NODE_ENV !== "production" ? "Array iterate" : ""
);
function oe(e, t, n) {
  if (Te && q) {
    let o = Do.get(e);
    o || Do.set(e, o = /* @__PURE__ */ new Map());
    let s = o.get(n);
    s || (o.set(n, s = new Yo()), s.map = o, s.key = n), process.env.NODE_ENV !== "production" ? s.track({
      target: e,
      type: t,
      key: n
    }) : s.track();
  }
}
function Ue(e, t, n, o, s, i) {
  const r = Do.get(e);
  if (!r) {
    sn++;
    return;
  }
  const l = (c) => {
    c && (process.env.NODE_ENV !== "production" ? c.trigger({
      target: e,
      type: t,
      key: n,
      newValue: o,
      oldValue: s,
      oldTarget: i
    }) : c.trigger());
  };
  if (zo(), t === "clear")
    r.forEach(l);
  else {
    const c = C(e), p = c && Wo(n);
    if (c && n === "length") {
      const u = Number(o);
      r.forEach((f, g) => {
        (g === "length" || g === rn || !ke(g) && g >= u) && l(f);
      });
    } else
      switch ((n !== void 0 || r.has(void 0)) && l(r.get(n)), p && l(r.get(rn)), t) {
        case "add":
          c ? p && l(r.get("length")) : (l(r.get(Et)), yt(e) && l(r.get(So)));
          break;
        case "delete":
          c || (l(r.get(Et)), yt(e) && l(r.get(So)));
          break;
        case "set":
          yt(e) && l(r.get(Et));
          break;
      }
  }
  Go();
}
function Vt(e) {
  const t = P(e);
  return t === e ? t : (oe(t, "iterate", rn), ge(e) ? t : t.map(le));
}
function Xn(e) {
  return oe(e = P(e), "iterate", rn), e;
}
const zr = {
  __proto__: null,
  [Symbol.iterator]() {
    return mo(this, Symbol.iterator, le);
  },
  concat(...e) {
    return Vt(this).concat(
      ...e.map((t) => C(t) ? Vt(t) : t)
    );
  },
  entries() {
    return mo(this, "entries", (e) => (e[1] = le(e[1]), e));
  },
  every(e, t) {
    return Je(this, "every", e, t, void 0, arguments);
  },
  filter(e, t) {
    return Je(this, "filter", e, t, (n) => n.map(le), arguments);
  },
  find(e, t) {
    return Je(this, "find", e, t, le, arguments);
  },
  findIndex(e, t) {
    return Je(this, "findIndex", e, t, void 0, arguments);
  },
  findLast(e, t) {
    return Je(this, "findLast", e, t, le, arguments);
  },
  findLastIndex(e, t) {
    return Je(this, "findLastIndex", e, t, void 0, arguments);
  },
  // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
  forEach(e, t) {
    return Je(this, "forEach", e, t, void 0, arguments);
  },
  includes(...e) {
    return vo(this, "includes", e);
  },
  indexOf(...e) {
    return vo(this, "indexOf", e);
  },
  join(e) {
    return Vt(this).join(e);
  },
  // keys() iterator only reads `length`, no optimization required
  lastIndexOf(...e) {
    return vo(this, "lastIndexOf", e);
  },
  map(e, t) {
    return Je(this, "map", e, t, void 0, arguments);
  },
  pop() {
    return zt(this, "pop");
  },
  push(...e) {
    return zt(this, "push", e);
  },
  reduce(e, ...t) {
    return _s(this, "reduce", e, t);
  },
  reduceRight(e, ...t) {
    return _s(this, "reduceRight", e, t);
  },
  shift() {
    return zt(this, "shift");
  },
  // slice could use ARRAY_ITERATE but also seems to beg for range tracking
  some(e, t) {
    return Je(this, "some", e, t, void 0, arguments);
  },
  splice(...e) {
    return zt(this, "splice", e);
  },
  toReversed() {
    return Vt(this).toReversed();
  },
  toSorted(e) {
    return Vt(this).toSorted(e);
  },
  toSpliced(...e) {
    return Vt(this).toSpliced(...e);
  },
  unshift(...e) {
    return zt(this, "unshift", e);
  },
  values() {
    return mo(this, "values", le);
  }
};
function mo(e, t, n) {
  const o = Xn(e), s = o[t]();
  return o !== e && !ge(e) && (s._next = s.next, s.next = () => {
    const i = s._next();
    return i.done || (i.value = n(i.value)), i;
  }), s;
}
const Gr = Array.prototype;
function Je(e, t, n, o, s, i) {
  const r = Xn(e), l = r !== e && !ge(e), c = r[t];
  if (c !== Gr[t]) {
    const f = c.apply(e, i);
    return l ? le(f) : f;
  }
  let p = n;
  r !== e && (l ? p = function(f, g) {
    return n.call(this, le(f), g, e);
  } : n.length > 2 && (p = function(f, g) {
    return n.call(this, f, g, e);
  }));
  const u = c.call(r, p, o);
  return l && s ? s(u) : u;
}
function _s(e, t, n, o) {
  const s = Xn(e);
  let i = n;
  return s !== e && (ge(e) ? n.length > 3 && (i = function(r, l, c) {
    return n.call(this, r, l, c, e);
  }) : i = function(r, l, c) {
    return n.call(this, r, le(l), c, e);
  }), s[t](i, ...o);
}
function vo(e, t, n) {
  const o = P(e);
  oe(o, "iterate", rn);
  const s = o[t](...n);
  return (s === -1 || s === !1) && Pn(n[0]) ? (n[0] = P(n[0]), o[t](...n)) : s;
}
function zt(e, t, n = []) {
  Ae(), zo();
  const o = P(e)[t].apply(e, n);
  return Go(), Pe(), o;
}
const Jr = /* @__PURE__ */ tt("__proto__,__v_isRef,__isVue"), yi = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(ke)
);
function Yr(e) {
  ke(e) || (e = String(e));
  const t = P(this);
  return oe(t, "has", e), t.hasOwnProperty(e);
}
class Ei {
  constructor(t = !1, n = !1) {
    this._isReadonly = t, this._isShallow = n;
  }
  get(t, n, o) {
    if (n === "__v_skip") return t.__v_skip;
    const s = this._isReadonly, i = this._isShallow;
    if (n === "__v_isReactive")
      return !s;
    if (n === "__v_isReadonly")
      return s;
    if (n === "__v_isShallow")
      return i;
    if (n === "__v_raw")
      return o === (s ? i ? Si : Di : i ? Oi : wi).get(t) || // receiver is not the reactive proxy, but has the same prototype
      // this means the receiver is a user proxy of the reactive proxy
      Object.getPrototypeOf(t) === Object.getPrototypeOf(o) ? t : void 0;
    const r = C(t);
    if (!s) {
      let c;
      if (r && (c = zr[n]))
        return c;
      if (n === "hasOwnProperty")
        return Yr;
    }
    const l = Reflect.get(
      t,
      n,
      // if this is a proxy wrapping a ref, return methods using the raw ref
      // as receiver so that we don't have to call `toRaw` on the ref in all
      // its class methods
      te(t) ? t : o
    );
    if ((ke(n) ? yi.has(n) : Jr(n)) || (s || oe(t, "get", n), i))
      return l;
    if (te(l)) {
      const c = r && Wo(n) ? l : l.value;
      return s && W(c) ? Co(c) : c;
    }
    return W(l) ? s ? Co(l) : to(l) : l;
  }
}
class Ni extends Ei {
  constructor(t = !1) {
    super(!1, t);
  }
  set(t, n, o, s) {
    let i = t[n];
    if (!this._isShallow) {
      const c = qe(i);
      if (!ge(o) && !qe(o) && (i = P(i), o = P(o)), !C(t) && te(i) && !te(o))
        return c ? (process.env.NODE_ENV !== "production" && Me(
          `Set operation on key "${String(n)}" failed: target is readonly.`,
          t[n]
        ), !0) : (i.value = o, !0);
    }
    const r = C(t) && Wo(n) ? Number(n) < t.length : K(t, n), l = Reflect.set(
      t,
      n,
      o,
      te(t) ? t : s
    );
    return t === P(s) && (r ? ut(o, i) && Ue(t, "set", n, o, i) : Ue(t, "add", n, o)), l;
  }
  deleteProperty(t, n) {
    const o = K(t, n), s = t[n], i = Reflect.deleteProperty(t, n);
    return i && o && Ue(t, "delete", n, void 0, s), i;
  }
  has(t, n) {
    const o = Reflect.has(t, n);
    return (!ke(n) || !yi.has(n)) && oe(t, "has", n), o;
  }
  ownKeys(t) {
    return oe(
      t,
      "iterate",
      C(t) ? "length" : Et
    ), Reflect.ownKeys(t);
  }
}
class xi extends Ei {
  constructor(t = !1) {
    super(!0, t);
  }
  set(t, n) {
    return process.env.NODE_ENV !== "production" && Me(
      `Set operation on key "${String(n)}" failed: target is readonly.`,
      t
    ), !0;
  }
  deleteProperty(t, n) {
    return process.env.NODE_ENV !== "production" && Me(
      `Delete operation on key "${String(n)}" failed: target is readonly.`,
      t
    ), !0;
  }
}
const Zr = /* @__PURE__ */ new Ni(), Qr = /* @__PURE__ */ new xi(), Xr = /* @__PURE__ */ new Ni(!0), el = /* @__PURE__ */ new xi(!0), Vo = (e) => e, En = (e) => Reflect.getPrototypeOf(e);
function tl(e, t, n) {
  return function(...o) {
    const s = this.__v_raw, i = P(s), r = yt(i), l = e === "entries" || e === Symbol.iterator && r, c = e === "keys" && r, p = s[e](...o), u = n ? Vo : t ? jn : le;
    return !t && oe(
      i,
      "iterate",
      c ? So : Et
    ), {
      // iterator protocol
      next() {
        const { value: f, done: g } = p.next();
        return g ? { value: f, done: g } : {
          value: l ? [u(f[0]), u(f[1])] : u(f),
          done: g
        };
      },
      // iterable protocol
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
function Nn(e) {
  return function(...t) {
    if (process.env.NODE_ENV !== "production") {
      const n = t[0] ? `on key "${t[0]}" ` : "";
      Me(
        `${Yn(e)} operation ${n}failed: target is readonly.`,
        P(this)
      );
    }
    return e === "delete" ? !1 : e === "clear" ? void 0 : this;
  };
}
function nl(e, t) {
  const n = {
    get(s) {
      const i = this.__v_raw, r = P(i), l = P(s);
      e || (ut(s, l) && oe(r, "get", s), oe(r, "get", l));
      const { has: c } = En(r), p = t ? Vo : e ? jn : le;
      if (c.call(r, s))
        return p(i.get(s));
      if (c.call(r, l))
        return p(i.get(l));
      i !== r && i.get(s);
    },
    get size() {
      const s = this.__v_raw;
      return !e && oe(P(s), "iterate", Et), s.size;
    },
    has(s) {
      const i = this.__v_raw, r = P(i), l = P(s);
      return e || (ut(s, l) && oe(r, "has", s), oe(r, "has", l)), s === l ? i.has(s) : i.has(s) || i.has(l);
    },
    forEach(s, i) {
      const r = this, l = r.__v_raw, c = P(l), p = t ? Vo : e ? jn : le;
      return !e && oe(c, "iterate", Et), l.forEach((u, f) => s.call(i, p(u), p(f), r));
    }
  };
  return ne(
    n,
    e ? {
      add: Nn("add"),
      set: Nn("set"),
      delete: Nn("delete"),
      clear: Nn("clear")
    } : {
      add(s) {
        !t && !ge(s) && !qe(s) && (s = P(s));
        const i = P(this);
        return En(i).has.call(i, s) || (i.add(s), Ue(i, "add", s, s)), this;
      },
      set(s, i) {
        !t && !ge(i) && !qe(i) && (i = P(i));
        const r = P(this), { has: l, get: c } = En(r);
        let p = l.call(r, s);
        p ? process.env.NODE_ENV !== "production" && bs(r, l, s) : (s = P(s), p = l.call(r, s));
        const u = c.call(r, s);
        return r.set(s, i), p ? ut(i, u) && Ue(r, "set", s, i, u) : Ue(r, "add", s, i), this;
      },
      delete(s) {
        const i = P(this), { has: r, get: l } = En(i);
        let c = r.call(i, s);
        c ? process.env.NODE_ENV !== "production" && bs(i, r, s) : (s = P(s), c = r.call(i, s));
        const p = l ? l.call(i, s) : void 0, u = i.delete(s);
        return c && Ue(i, "delete", s, void 0, p), u;
      },
      clear() {
        const s = P(this), i = s.size !== 0, r = process.env.NODE_ENV !== "production" ? yt(s) ? new Map(s) : new Set(s) : void 0, l = s.clear();
        return i && Ue(
          s,
          "clear",
          void 0,
          void 0,
          r
        ), l;
      }
    }
  ), [
    "keys",
    "values",
    "entries",
    Symbol.iterator
  ].forEach((s) => {
    n[s] = tl(s, e, t);
  }), n;
}
function eo(e, t) {
  const n = nl(e, t);
  return (o, s, i) => s === "__v_isReactive" ? !e : s === "__v_isReadonly" ? e : s === "__v_raw" ? o : Reflect.get(
    K(n, s) && s in o ? n : o,
    s,
    i
  );
}
const ol = {
  get: /* @__PURE__ */ eo(!1, !1)
}, sl = {
  get: /* @__PURE__ */ eo(!1, !0)
}, il = {
  get: /* @__PURE__ */ eo(!0, !1)
}, rl = {
  get: /* @__PURE__ */ eo(!0, !0)
};
function bs(e, t, n) {
  const o = P(n);
  if (o !== n && t.call(e, o)) {
    const s = Bo(e);
    Me(
      `Reactive ${s} contains both the raw and reactive versions of the same object${s === "Map" ? " as keys" : ""}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`
    );
  }
}
const wi = /* @__PURE__ */ new WeakMap(), Oi = /* @__PURE__ */ new WeakMap(), Di = /* @__PURE__ */ new WeakMap(), Si = /* @__PURE__ */ new WeakMap();
function ll(e) {
  switch (e) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function cl(e) {
  return e.__v_skip || !Object.isExtensible(e) ? 0 : ll(Bo(e));
}
function to(e) {
  return qe(e) ? e : no(
    e,
    !1,
    Zr,
    ol,
    wi
  );
}
function al(e) {
  return no(
    e,
    !1,
    Xr,
    sl,
    Oi
  );
}
function Co(e) {
  return no(
    e,
    !0,
    Qr,
    il,
    Di
  );
}
function Be(e) {
  return no(
    e,
    !0,
    el,
    rl,
    Si
  );
}
function no(e, t, n, o, s) {
  if (!W(e))
    return process.env.NODE_ENV !== "production" && Me(
      `value cannot be made ${t ? "readonly" : "reactive"}: ${String(
        e
      )}`
    ), e;
  if (e.__v_raw && !(t && e.__v_isReactive))
    return e;
  const i = cl(e);
  if (i === 0)
    return e;
  const r = s.get(e);
  if (r)
    return r;
  const l = new Proxy(
    e,
    i === 2 ? o : n
  );
  return s.set(e, l), l;
}
function Nt(e) {
  return qe(e) ? Nt(e.__v_raw) : !!(e && e.__v_isReactive);
}
function qe(e) {
  return !!(e && e.__v_isReadonly);
}
function ge(e) {
  return !!(e && e.__v_isShallow);
}
function Pn(e) {
  return e ? !!e.__v_raw : !1;
}
function P(e) {
  const t = e && e.__v_raw;
  return t ? P(t) : e;
}
function ul(e) {
  return !K(e, "__v_skip") && Object.isExtensible(e) && An(e, "__v_skip", !0), e;
}
const le = (e) => W(e) ? to(e) : e, jn = (e) => W(e) ? Co(e) : e;
function te(e) {
  return e ? e.__v_isRef === !0 : !1;
}
function at(e) {
  return fl(e, !1);
}
function fl(e, t) {
  return te(e) ? e : new dl(e, t);
}
class dl {
  constructor(t, n) {
    this.dep = new Yo(), this.__v_isRef = !0, this.__v_isShallow = !1, this._rawValue = n ? t : P(t), this._value = n ? t : le(t), this.__v_isShallow = n;
  }
  get value() {
    return process.env.NODE_ENV !== "production" ? this.dep.track({
      target: this,
      type: "get",
      key: "value"
    }) : this.dep.track(), this._value;
  }
  set value(t) {
    const n = this._rawValue, o = this.__v_isShallow || ge(t) || qe(t);
    t = o ? t : P(t), ut(t, n) && (this._rawValue = t, this._value = o ? t : le(t), process.env.NODE_ENV !== "production" ? this.dep.trigger({
      target: this,
      type: "set",
      key: "value",
      newValue: t,
      oldValue: n
    }) : this.dep.trigger());
  }
}
function U(e) {
  return te(e) ? e.value : e;
}
const pl = {
  get: (e, t, n) => t === "__v_raw" ? e : U(Reflect.get(e, t, n)),
  set: (e, t, n, o) => {
    const s = e[t];
    return te(s) && !te(n) ? (s.value = n, !0) : Reflect.set(e, t, n, o);
  }
};
function Vi(e) {
  return Nt(e) ? e : new Proxy(e, pl);
}
class hl {
  constructor(t, n, o) {
    this.fn = t, this.setter = n, this._value = void 0, this.dep = new Yo(this), this.__v_isRef = !0, this.deps = void 0, this.depsTail = void 0, this.flags = 16, this.globalVersion = sn - 1, this.next = void 0, this.effect = this, this.__v_isReadonly = !n, this.isSSR = o;
  }
  /**
   * @internal
   */
  notify() {
    if (this.flags |= 16, !(this.flags & 8) && // avoid infinite self recursion
    q !== this)
      return hi(this, !0), !0;
    process.env.NODE_ENV;
  }
  get value() {
    const t = process.env.NODE_ENV !== "production" ? this.dep.track({
      target: this,
      type: "get",
      key: "value"
    }) : this.dep.track();
    return vi(this), t && (t.version = this.dep.version), this._value;
  }
  set value(t) {
    this.setter ? this.setter(t) : process.env.NODE_ENV !== "production" && Me("Write operation failed: computed value is readonly");
  }
}
function gl(e, t, n = !1) {
  let o, s;
  k(e) ? o = e : (o = e.get, s = e.set);
  const i = new hl(o, s, n);
  return process.env.NODE_ENV, i;
}
const xn = {}, Rn = /* @__PURE__ */ new WeakMap();
let _t;
function ml(e, t = !1, n = _t) {
  if (n) {
    let o = Rn.get(n);
    o || Rn.set(n, o = []), o.push(e);
  } else process.env.NODE_ENV !== "production" && !t && Me(
    "onWatcherCleanup() was called when there was no active watcher to associate with."
  );
}
function vl(e, t, n = z) {
  const { immediate: o, deep: s, once: i, scheduler: r, augmentJob: l, call: c } = n, p = (T) => {
    (n.onWarn || Me)(
      "Invalid watch source: ",
      T,
      "A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types."
    );
  }, u = (T) => s ? T : ge(T) || s === !1 || s === 0 ? Qe(T, 1) : Qe(T);
  let f, g, w, M, S = !1, V = !1;
  if (te(e) ? (g = () => e.value, S = ge(e)) : Nt(e) ? (g = () => u(e), S = !0) : C(e) ? (V = !0, S = e.some((T) => Nt(T) || ge(T)), g = () => e.map((T) => {
    if (te(T))
      return T.value;
    if (Nt(T))
      return u(T);
    if (k(T))
      return c ? c(T, 2) : T();
    process.env.NODE_ENV !== "production" && p(T);
  })) : k(e) ? t ? g = c ? () => c(e, 2) : e : g = () => {
    if (w) {
      Ae();
      try {
        w();
      } finally {
        Pe();
      }
    }
    const T = _t;
    _t = f;
    try {
      return c ? c(e, 3, [M]) : e(M);
    } finally {
      _t = T;
    }
  } : (g = se, process.env.NODE_ENV !== "production" && p(e)), t && s) {
    const T = g, re = s === !0 ? 1 / 0 : s;
    g = () => Qe(T(), re);
  }
  const G = Br(), R = () => {
    f.stop(), G && G.active && Ko(G.effects, f);
  };
  if (i && t) {
    const T = t;
    t = (...re) => {
      T(...re), R();
    };
  }
  let j = V ? new Array(e.length).fill(xn) : xn;
  const fe = (T) => {
    if (!(!(f.flags & 1) || !f.dirty && !T))
      if (t) {
        const re = f.run();
        if (s || S || (V ? re.some((Oe, ae) => ut(Oe, j[ae])) : ut(re, j))) {
          w && w();
          const Oe = _t;
          _t = f;
          try {
            const ae = [
              re,
              // pass undefined as the old value when it's changed for the first time
              j === xn ? void 0 : V && j[0] === xn ? [] : j,
              M
            ];
            j = re, c ? c(t, 3, ae) : (
              // @ts-expect-error
              t(...ae)
            );
          } finally {
            _t = Oe;
          }
        }
      } else
        f.run();
  };
  return l && l(fe), f = new di(g), f.scheduler = r ? () => r(fe, !1) : fe, M = (T) => ml(T, !1, f), w = f.onStop = () => {
    const T = Rn.get(f);
    if (T) {
      if (c)
        c(T, 4);
      else
        for (const re of T) re();
      Rn.delete(f);
    }
  }, process.env.NODE_ENV !== "production" && (f.onTrack = n.onTrack, f.onTrigger = n.onTrigger), t ? o ? fe(!0) : j = f.run() : r ? r(fe.bind(null, !0), !0) : f.run(), R.pause = f.pause.bind(f), R.resume = f.resume.bind(f), R.stop = R, R;
}
function Qe(e, t = 1 / 0, n) {
  if (t <= 0 || !W(e) || e.__v_skip || (n = n || /* @__PURE__ */ new Map(), (n.get(e) || 0) >= t))
    return e;
  if (n.set(e, t), t--, te(e))
    Qe(e.value, t, n);
  else if (C(e))
    for (let o = 0; o < e.length; o++)
      Qe(e[o], t, n);
  else if (Gn(e) || yt(e))
    e.forEach((o) => {
      Qe(o, t, n);
    });
  else if (li(e)) {
    for (const o in e)
      Qe(e[o], t, n);
    for (const o of Object.getOwnPropertySymbols(e))
      Object.prototype.propertyIsEnumerable.call(e, o) && Qe(e[o], t, n);
  }
  return e;
}
/**
* @vue/runtime-core v3.5.24
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
const xt = [];
function On(e) {
  xt.push(e);
}
function Dn() {
  xt.pop();
}
let _o = !1;
function x(e, ...t) {
  if (_o) return;
  _o = !0, Ae();
  const n = xt.length ? xt[xt.length - 1].component : null, o = n && n.appContext.config.warnHandler, s = _l();
  if (o)
    Kt(
      o,
      n,
      11,
      [
        // eslint-disable-next-line no-restricted-syntax
        e + t.map((i) => {
          var r, l;
          return (l = (r = i.toString) == null ? void 0 : r.call(i)) != null ? l : JSON.stringify(i);
        }).join(""),
        n && n.proxy,
        s.map(
          ({ vnode: i }) => `at <${lo(n, i.type)}>`
        ).join(`
`),
        s
      ]
    );
  else {
    const i = [`[Vue warn]: ${e}`, ...t];
    s.length && i.push(`
`, ...bl(s)), console.warn(...i);
  }
  Pe(), _o = !1;
}
function _l() {
  let e = xt[xt.length - 1];
  if (!e)
    return [];
  const t = [];
  for (; e; ) {
    const n = t[0];
    n && n.vnode === e ? n.recurseCount++ : t.push({
      vnode: e,
      recurseCount: 0
    });
    const o = e.component && e.component.parent;
    e = o && o.vnode;
  }
  return t;
}
function bl(e) {
  const t = [];
  return e.forEach((n, o) => {
    t.push(...o === 0 ? [] : [`
`], ...yl(n));
  }), t;
}
function yl({ vnode: e, recurseCount: t }) {
  const n = t > 0 ? `... (${t} recursive calls)` : "", o = e.component ? e.component.parent == null : !1, s = ` at <${lo(
    e.component,
    e.type,
    o
  )}`, i = ">" + n;
  return e.props ? [s, ...El(e.props), i] : [s + i];
}
function El(e) {
  const t = [], n = Object.keys(e);
  return n.slice(0, 3).forEach((o) => {
    t.push(...Ci(o, e[o]));
  }), n.length > 3 && t.push(" ..."), t;
}
function Ci(e, t, n) {
  return Q(t) ? (t = JSON.stringify(t), n ? t : [`${e}=${t}`]) : typeof t == "number" || typeof t == "boolean" || t == null ? n ? t : [`${e}=${t}`] : te(t) ? (t = Ci(e, P(t.value), !0), n ? t : [`${e}=Ref<`, t, ">"]) : k(t) ? [`${e}=fn${t.name ? `<${t.name}>` : ""}`] : (t = P(t), n ? t : [`${e}=`, t]);
}
const Zo = {
  sp: "serverPrefetch hook",
  bc: "beforeCreate hook",
  c: "created hook",
  bm: "beforeMount hook",
  m: "mounted hook",
  bu: "beforeUpdate hook",
  u: "updated",
  bum: "beforeUnmount hook",
  um: "unmounted hook",
  a: "activated hook",
  da: "deactivated hook",
  ec: "errorCaptured hook",
  rtc: "renderTracked hook",
  rtg: "renderTriggered hook",
  0: "setup function",
  1: "render function",
  2: "watcher getter",
  3: "watcher callback",
  4: "watcher cleanup function",
  5: "native event handler",
  6: "component event handler",
  7: "vnode hook",
  8: "directive hook",
  9: "transition hook",
  10: "app errorHandler",
  11: "app warnHandler",
  12: "ref function",
  13: "async component loader",
  14: "scheduler flush",
  15: "component update",
  16: "app unmount cleanup function"
};
function Kt(e, t, n, o) {
  try {
    return o ? e(...o) : e();
  } catch (s) {
    pn(s, t, n);
  }
}
function ze(e, t, n, o) {
  if (k(e)) {
    const s = Kt(e, t, n, o);
    return s && Uo(s) && s.catch((i) => {
      pn(i, t, n);
    }), s;
  }
  if (C(e)) {
    const s = [];
    for (let i = 0; i < e.length; i++)
      s.push(ze(e[i], t, n, o));
    return s;
  } else process.env.NODE_ENV !== "production" && x(
    `Invalid value type passed to callWithAsyncErrorHandling(): ${typeof e}`
  );
}
function pn(e, t, n, o = !0) {
  const s = t ? t.vnode : null, { errorHandler: i, throwUnhandledErrorInProduction: r } = t && t.appContext.config || z;
  if (t) {
    let l = t.parent;
    const c = t.proxy, p = process.env.NODE_ENV !== "production" ? Zo[n] : `https://vuejs.org/error-reference/#runtime-${n}`;
    for (; l; ) {
      const u = l.ec;
      if (u) {
        for (let f = 0; f < u.length; f++)
          if (u[f](e, c, p) === !1)
            return;
      }
      l = l.parent;
    }
    if (i) {
      Ae(), Kt(i, null, 10, [
        e,
        c,
        p
      ]), Pe();
      return;
    }
  }
  Nl(e, n, s, o, r);
}
function Nl(e, t, n, o = !0, s = !1) {
  if (process.env.NODE_ENV !== "production") {
    const i = Zo[t];
    if (n && On(n), x(`Unhandled error${i ? ` during execution of ${i}` : ""}`), n && Dn(), o)
      throw e;
    console.error(e);
  } else {
    if (s)
      throw e;
    console.error(e);
  }
}
const he = [];
let Ke = -1;
const Pt = [];
let lt = null, kt = 0;
const $i = /* @__PURE__ */ Promise.resolve();
let Fn = null;
const xl = 100;
function wl(e) {
  const t = Fn || $i;
  return e ? t.then(this ? e.bind(this) : e) : t;
}
function Ol(e) {
  let t = Ke + 1, n = he.length;
  for (; t < n; ) {
    const o = t + n >>> 1, s = he[o], i = ln(s);
    i < e || i === e && s.flags & 2 ? t = o + 1 : n = o;
  }
  return t;
}
function oo(e) {
  if (!(e.flags & 1)) {
    const t = ln(e), n = he[he.length - 1];
    !n || // fast path when the job id is larger than the tail
    !(e.flags & 2) && t >= ln(n) ? he.push(e) : he.splice(Ol(t), 0, e), e.flags |= 1, Ti();
  }
}
function Ti() {
  Fn || (Fn = $i.then(Mi));
}
function Ii(e) {
  C(e) ? Pt.push(...e) : lt && e.id === -1 ? lt.splice(kt + 1, 0, e) : e.flags & 1 || (Pt.push(e), e.flags |= 1), Ti();
}
function ys(e, t, n = Ke + 1) {
  for (process.env.NODE_ENV !== "production" && (t = t || /* @__PURE__ */ new Map()); n < he.length; n++) {
    const o = he[n];
    if (o && o.flags & 2) {
      if (e && o.id !== e.uid || process.env.NODE_ENV !== "production" && Qo(t, o))
        continue;
      he.splice(n, 1), n--, o.flags & 4 && (o.flags &= -2), o(), o.flags & 4 || (o.flags &= -2);
    }
  }
}
function ki(e) {
  if (Pt.length) {
    const t = [...new Set(Pt)].sort(
      (n, o) => ln(n) - ln(o)
    );
    if (Pt.length = 0, lt) {
      lt.push(...t);
      return;
    }
    for (lt = t, process.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map()), kt = 0; kt < lt.length; kt++) {
      const n = lt[kt];
      process.env.NODE_ENV !== "production" && Qo(e, n) || (n.flags & 4 && (n.flags &= -2), n.flags & 8 || n(), n.flags &= -2);
    }
    lt = null, kt = 0;
  }
}
const ln = (e) => e.id == null ? e.flags & 2 ? -1 : 1 / 0 : e.id;
function Mi(e) {
  process.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map());
  const t = process.env.NODE_ENV !== "production" ? (n) => Qo(e, n) : se;
  try {
    for (Ke = 0; Ke < he.length; Ke++) {
      const n = he[Ke];
      if (n && !(n.flags & 8)) {
        if (process.env.NODE_ENV !== "production" && t(n))
          continue;
        n.flags & 4 && (n.flags &= -2), Kt(
          n,
          n.i,
          n.i ? 15 : 14
        ), n.flags & 4 || (n.flags &= -2);
      }
    }
  } finally {
    for (; Ke < he.length; Ke++) {
      const n = he[Ke];
      n && (n.flags &= -2);
    }
    Ke = -1, he.length = 0, ki(e), Fn = null, (he.length || Pt.length) && Mi(e);
  }
}
function Qo(e, t) {
  const n = e.get(t) || 0;
  if (n > xl) {
    const o = t.i, s = o && vr(o.type);
    return pn(
      `Maximum recursive updates exceeded${s ? ` in component <${s}>` : ""}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`,
      null,
      10
    ), !0;
  }
  return e.set(t, n + 1), !1;
}
let We = !1;
const Sn = /* @__PURE__ */ new Map();
process.env.NODE_ENV !== "production" && (dn().__VUE_HMR_RUNTIME__ = {
  createRecord: bo(Ai),
  rerender: bo(Vl),
  reload: bo(Cl)
});
const Ot = /* @__PURE__ */ new Map();
function Dl(e) {
  const t = e.type.__hmrId;
  let n = Ot.get(t);
  n || (Ai(t, e.type), n = Ot.get(t)), n.instances.add(e);
}
function Sl(e) {
  Ot.get(e.type.__hmrId).instances.delete(e);
}
function Ai(e, t) {
  return Ot.has(e) ? !1 : (Ot.set(e, {
    initialDef: Ln(t),
    instances: /* @__PURE__ */ new Set()
  }), !0);
}
function Ln(e) {
  return _r(e) ? e.__vccOpts : e;
}
function Vl(e, t) {
  const n = Ot.get(e);
  n && (n.initialDef.render = t, [...n.instances].forEach((o) => {
    t && (o.render = t, Ln(o.type).render = t), o.renderCache = [], We = !0, o.job.flags & 8 || o.update(), We = !1;
  }));
}
function Cl(e, t) {
  const n = Ot.get(e);
  if (!n) return;
  t = Ln(t), Es(n.initialDef, t);
  const o = [...n.instances];
  for (let s = 0; s < o.length; s++) {
    const i = o[s], r = Ln(i.type);
    let l = Sn.get(r);
    l || (r !== n.initialDef && Es(r, t), Sn.set(r, l = /* @__PURE__ */ new Set())), l.add(i), i.appContext.propsCache.delete(i.type), i.appContext.emitsCache.delete(i.type), i.appContext.optionsCache.delete(i.type), i.ceReload ? (l.add(i), i.ceReload(t.styles), l.delete(i)) : i.parent ? oo(() => {
      i.job.flags & 8 || (We = !0, i.parent.update(), We = !1, l.delete(i));
    }) : i.appContext.reload ? i.appContext.reload() : typeof window < "u" ? window.location.reload() : console.warn(
      "[HMR] Root or manually mounted instance modified. Full reload required."
    ), i.root.ce && i !== i.root && i.root.ce._removeChildStyle(r);
  }
  Ii(() => {
    Sn.clear();
  });
}
function Es(e, t) {
  ne(e, t);
  for (const n in e)
    n !== "__file" && !(n in t) && delete e[n];
}
function bo(e) {
  return (t, n) => {
    try {
      return e(t, n);
    } catch (o) {
      console.error(o), console.warn(
        "[HMR] Something went wrong during Vue component hot-reload. Full reload required."
      );
    }
  };
}
let Ce, Yt = [], $o = !1;
function hn(e, ...t) {
  Ce ? Ce.emit(e, ...t) : $o || Yt.push({ event: e, args: t });
}
function Xo(e, t) {
  var n, o;
  Ce = e, Ce ? (Ce.enabled = !0, Yt.forEach(({ event: s, args: i }) => Ce.emit(s, ...i)), Yt = []) : /* handle late devtools injection - only do this if we are in an actual */ /* browser environment to avoid the timer handle stalling test runner exit */ /* (#4815) */ typeof window < "u" && // some envs mock window but not fully
  window.HTMLElement && // also exclude jsdom
  // eslint-disable-next-line no-restricted-syntax
  !((o = (n = window.navigator) == null ? void 0 : n.userAgent) != null && o.includes("jsdom")) ? ((t.__VUE_DEVTOOLS_HOOK_REPLAY__ = t.__VUE_DEVTOOLS_HOOK_REPLAY__ || []).push((i) => {
    Xo(i, t);
  }), setTimeout(() => {
    Ce || (t.__VUE_DEVTOOLS_HOOK_REPLAY__ = null, $o = !0, Yt = []);
  }, 3e3)) : ($o = !0, Yt = []);
}
function $l(e, t) {
  hn("app:init", e, t, {
    Fragment: ue,
    Text: gn,
    Comment: Ee,
    Static: nn
  });
}
function Tl(e) {
  hn("app:unmount", e);
}
const Il = /* @__PURE__ */ es(
  "component:added"
  /* COMPONENT_ADDED */
), Pi = /* @__PURE__ */ es(
  "component:updated"
  /* COMPONENT_UPDATED */
), kl = /* @__PURE__ */ es(
  "component:removed"
  /* COMPONENT_REMOVED */
), Ml = (e) => {
  Ce && typeof Ce.cleanupBuffer == "function" && // remove the component if it wasn't buffered
  !Ce.cleanupBuffer(e) && kl(e);
};
// @__NO_SIDE_EFFECTS__
function es(e) {
  return (t) => {
    hn(
      e,
      t.appContext.app,
      t.uid,
      t.parent ? t.parent.uid : void 0,
      t
    );
  };
}
const Al = /* @__PURE__ */ ji(
  "perf:start"
  /* PERFORMANCE_START */
), Pl = /* @__PURE__ */ ji(
  "perf:end"
  /* PERFORMANCE_END */
);
function ji(e) {
  return (t, n, o) => {
    hn(e, t.appContext.app, t.uid, t, n, o);
  };
}
function jl(e, t, n) {
  hn(
    "component:emit",
    e.appContext.app,
    e,
    t,
    n
  );
}
let ie = null, Ri = null;
function Hn(e) {
  const t = ie;
  return ie = e, Ri = e && e.type.__scopeId || null, t;
}
function Ie(e, t = ie, n) {
  if (!t || e._n)
    return e;
  const o = (...s) => {
    o._d && Ps(-1);
    const i = Hn(t);
    let r;
    try {
      r = e(...s);
    } finally {
      Hn(i), o._d && Ps(1);
    }
    return process.env.NODE_ENV !== "production" && Pi(t), r;
  };
  return o._n = !0, o._c = !0, o._d = !0, o;
}
function Fi(e) {
  Sr(e) && x("Do not use built-in directive ids as custom directive id: " + e);
}
function Ns(e, t) {
  if (ie === null)
    return process.env.NODE_ENV !== "production" && x("withDirectives can only be used inside render functions."), e;
  const n = ro(ie), o = e.dirs || (e.dirs = []);
  for (let s = 0; s < t.length; s++) {
    let [i, r, l, c = z] = t[s];
    i && (k(i) && (i = {
      mounted: i,
      updated: i
    }), i.deep && Qe(r), o.push({
      dir: i,
      instance: n,
      value: r,
      oldValue: void 0,
      arg: l,
      modifiers: c
    }));
  }
  return e;
}
function ht(e, t, n, o) {
  const s = e.dirs, i = t && t.dirs;
  for (let r = 0; r < s.length; r++) {
    const l = s[r];
    i && (l.oldValue = i[r].value);
    let c = l.dir[o];
    c && (Ae(), ze(c, n, 8, [
      e.el,
      l,
      e,
      t
    ]), Pe());
  }
}
const Rl = Symbol("_vte"), Fl = (e) => e.__isTeleport, Ll = Symbol("_leaveCb");
function ts(e, t) {
  e.shapeFlag & 6 && e.component ? (e.transition = t, ts(e.component.subTree, t)) : e.shapeFlag & 128 ? (e.ssContent.transition = t.clone(e.ssContent), e.ssFallback.transition = t.clone(e.ssFallback)) : e.transition = t;
}
// @__NO_SIDE_EFFECTS__
function nt(e, t) {
  return k(e) ? (
    // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    ne({ name: e.name }, t, { setup: e })
  ) : e;
}
function Li(e) {
  e.ids = [e.ids[0] + e.ids[2]++ + "-", 0, 0];
}
const xs = /* @__PURE__ */ new WeakSet(), Kn = /* @__PURE__ */ new WeakMap();
function tn(e, t, n, o, s = !1) {
  if (C(e)) {
    e.forEach(
      (S, V) => tn(
        S,
        t && (C(t) ? t[V] : t),
        n,
        o,
        s
      )
    );
    return;
  }
  if (jt(o) && !s) {
    o.shapeFlag & 512 && o.type.__asyncResolved && o.component.subTree.component && tn(e, t, n, o.component.subTree);
    return;
  }
  const i = o.shapeFlag & 4 ? ro(o.component) : o.el, r = s ? null : i, { i: l, r: c } = e;
  if (process.env.NODE_ENV !== "production" && !l) {
    x(
      "Missing ref owner context. ref cannot be used on hoisted vnodes. A vnode with ref must be created inside the render function."
    );
    return;
  }
  const p = t && t.r, u = l.refs === z ? l.refs = {} : l.refs, f = l.setupState, g = P(f), w = f === z ? ii : (S) => process.env.NODE_ENV !== "production" && (K(g, S) && !te(g[S]) && x(
    `Template ref "${S}" used on a non-ref value. It will not work in the production build.`
  ), xs.has(g[S])) ? !1 : K(g, S), M = (S) => process.env.NODE_ENV === "production" || !xs.has(S);
  if (p != null && p !== c) {
    if (ws(t), Q(p))
      u[p] = null, w(p) && (f[p] = null);
    else if (te(p)) {
      M(p) && (p.value = null);
      const S = t;
      S.k && (u[S.k] = null);
    }
  }
  if (k(c))
    Kt(c, l, 12, [r, u]);
  else {
    const S = Q(c), V = te(c);
    if (S || V) {
      const G = () => {
        if (e.f) {
          const R = S ? w(c) ? f[c] : u[c] : M(c) || !e.k ? c.value : u[e.k];
          if (s)
            C(R) && Ko(R, i);
          else if (C(R))
            R.includes(i) || R.push(i);
          else if (S)
            u[c] = [i], w(c) && (f[c] = u[c]);
          else {
            const j = [i];
            M(c) && (c.value = j), e.k && (u[e.k] = j);
          }
        } else S ? (u[c] = r, w(c) && (f[c] = r)) : V ? (M(c) && (c.value = r), e.k && (u[e.k] = r)) : process.env.NODE_ENV !== "production" && x("Invalid template ref type:", c, `(${typeof c})`);
      };
      if (r) {
        const R = () => {
          G(), Kn.delete(e);
        };
        R.id = -1, Kn.set(e, R), Ne(R, n);
      } else
        ws(e), G();
    } else process.env.NODE_ENV !== "production" && x("Invalid template ref type:", c, `(${typeof c})`);
  }
}
function ws(e) {
  const t = Kn.get(e);
  t && (t.flags |= 8, Kn.delete(e));
}
dn().requestIdleCallback;
dn().cancelIdleCallback;
const jt = (e) => !!e.type.__asyncLoader, ns = (e) => e.type.__isKeepAlive;
function Hl(e, t) {
  Hi(e, "a", t);
}
function Kl(e, t) {
  Hi(e, "da", t);
}
function Hi(e, t, n = ce) {
  const o = e.__wdc || (e.__wdc = () => {
    let s = n;
    for (; s; ) {
      if (s.isDeactivated)
        return;
      s = s.parent;
    }
    return e();
  });
  if (so(t, o, n), n) {
    let s = n.parent;
    for (; s && s.parent; )
      ns(s.parent.vnode) && Ul(o, t, n, s), s = s.parent;
  }
}
function Ul(e, t, n, o) {
  const s = so(
    t,
    e,
    o,
    !0
    /* prepend */
  );
  Ki(() => {
    Ko(o[t], s);
  }, n);
}
function so(e, t, n = ce, o = !1) {
  if (n) {
    const s = n[e] || (n[e] = []), i = t.__weh || (t.__weh = (...r) => {
      Ae();
      const l = vn(n), c = ze(t, n, e, r);
      return l(), Pe(), c;
    });
    return o ? s.unshift(i) : s.push(i), i;
  } else if (process.env.NODE_ENV !== "production") {
    const s = vt(Zo[e].replace(/ hook$/, ""));
    x(
      `${s} is called when there is no active component instance to be associated with. Lifecycle injection APIs can only be used during execution of setup(). If you are using async setup(), make sure to register lifecycle hooks before the first await statement.`
    );
  }
}
const ot = (e) => (t, n = ce) => {
  (!an || e === "sp") && so(e, (...o) => t(...o), n);
}, Bl = ot("bm"), Dt = ot("m"), Wl = ot(
  "bu"
), ql = ot("u"), zl = ot(
  "bum"
), Ki = ot("um"), Gl = ot(
  "sp"
), Jl = ot("rtg"), Yl = ot("rtc");
function Zl(e, t = ce) {
  so("ec", e, t);
}
const Ql = Symbol.for("v-ndc");
function os(e, t, n, o) {
  let s;
  const i = n, r = C(e);
  if (r || Q(e)) {
    const l = r && Nt(e);
    let c = !1, p = !1;
    l && (c = !ge(e), p = qe(e), e = Xn(e)), s = new Array(e.length);
    for (let u = 0, f = e.length; u < f; u++)
      s[u] = t(
        c ? p ? jn(le(e[u])) : le(e[u]) : e[u],
        u,
        void 0,
        i
      );
  } else if (typeof e == "number") {
    process.env.NODE_ENV !== "production" && !Number.isInteger(e) && x(`The v-for range expect an integer value but got ${e}.`), s = new Array(e);
    for (let l = 0; l < e; l++)
      s[l] = t(l + 1, l, void 0, i);
  } else if (W(e))
    if (e[Symbol.iterator])
      s = Array.from(
        e,
        (l, c) => t(l, c, void 0, i)
      );
    else {
      const l = Object.keys(e);
      s = new Array(l.length);
      for (let c = 0, p = l.length; c < p; c++) {
        const u = l[c];
        s[c] = t(e[u], u, c, i);
      }
    }
  else
    s = [];
  return s;
}
function Ui(e, t, n = {}, o, s) {
  if (ie.ce || ie.parent && jt(ie.parent) && ie.parent.ce) {
    const p = Object.keys(n).length > 0;
    return B(), Xe(
      ue,
      null,
      [ee("slot", n, o)],
      p ? -2 : 64
    );
  }
  let i = e[t];
  process.env.NODE_ENV !== "production" && i && i.length > 1 && (x(
    "SSR-optimized slot function detected in a non-SSR-optimized render function. You need to mark this component with $dynamic-slots in the parent template."
  ), i = () => []), i && i._c && (i._d = !1), B();
  const r = i && Bi(i(n)), l = n.key || // slot content array of a dynamic conditional slot may have a branch
  // key attached in the `createSlots` helper, respect that
  r && r.key, c = Xe(
    ue,
    {
      key: (l && !ke(l) ? l : `_${t}`) + // #7256 force differentiate fallback content from actual content
      (!r && o ? "_fb" : "")
    },
    r || [],
    r && e._ === 1 ? 64 : -2
  );
  return c.scopeId && (c.slotScopeIds = [c.scopeId + "-s"]), i && i._c && (i._d = !0), c;
}
function Bi(e) {
  return e.some((t) => mn(t) ? !(t.type === Ee || t.type === ue && !Bi(t.children)) : !0) ? e : null;
}
const To = (e) => e ? gr(e) ? ro(e) : To(e.parent) : null, wt = (
  // Move PURE marker to new line to workaround compiler discarding it
  // due to type annotation
  /* @__PURE__ */ ne(/* @__PURE__ */ Object.create(null), {
    $: (e) => e,
    $el: (e) => e.vnode.el,
    $data: (e) => e.data,
    $props: (e) => process.env.NODE_ENV !== "production" ? Be(e.props) : e.props,
    $attrs: (e) => process.env.NODE_ENV !== "production" ? Be(e.attrs) : e.attrs,
    $slots: (e) => process.env.NODE_ENV !== "production" ? Be(e.slots) : e.slots,
    $refs: (e) => process.env.NODE_ENV !== "production" ? Be(e.refs) : e.refs,
    $parent: (e) => To(e.parent),
    $root: (e) => To(e.root),
    $host: (e) => e.ce,
    $emit: (e) => e.emit,
    $options: (e) => zi(e),
    $forceUpdate: (e) => e.f || (e.f = () => {
      oo(e.update);
    }),
    $nextTick: (e) => e.n || (e.n = wl.bind(e.proxy)),
    $watch: (e) => Tc.bind(e)
  })
), ss = (e) => e === "_" || e === "$", yo = (e, t) => e !== z && !e.__isScriptSetup && K(e, t), Wi = {
  get({ _: e }, t) {
    if (t === "__v_skip")
      return !0;
    const { ctx: n, setupState: o, data: s, props: i, accessCache: r, type: l, appContext: c } = e;
    if (process.env.NODE_ENV !== "production" && t === "__isVue")
      return !0;
    let p;
    if (t[0] !== "$") {
      const w = r[t];
      if (w !== void 0)
        switch (w) {
          case 1:
            return o[t];
          case 2:
            return s[t];
          case 4:
            return n[t];
          case 3:
            return i[t];
        }
      else {
        if (yo(o, t))
          return r[t] = 1, o[t];
        if (s !== z && K(s, t))
          return r[t] = 2, s[t];
        if (
          // only cache other properties when instance has declared (thus stable)
          // props
          (p = e.propsOptions[0]) && K(p, t)
        )
          return r[t] = 3, i[t];
        if (n !== z && K(n, t))
          return r[t] = 4, n[t];
        Io && (r[t] = 0);
      }
    }
    const u = wt[t];
    let f, g;
    if (u)
      return t === "$attrs" ? (oe(e.attrs, "get", ""), process.env.NODE_ENV !== "production" && Wn()) : process.env.NODE_ENV !== "production" && t === "$slots" && oe(e, "get", t), u(e);
    if (
      // css module (injected by vue-loader)
      (f = l.__cssModules) && (f = f[t])
    )
      return f;
    if (n !== z && K(n, t))
      return r[t] = 4, n[t];
    if (
      // global properties
      g = c.config.globalProperties, K(g, t)
    )
      return g[t];
    process.env.NODE_ENV !== "production" && ie && (!Q(t) || // #1091 avoid internal isRef/isVNode checks on component instance leading
    // to infinite warning loop
    t.indexOf("__v") !== 0) && (s !== z && ss(t[0]) && K(s, t) ? x(
      `Property ${JSON.stringify(
        t
      )} must be accessed via $data because it starts with a reserved character ("$" or "_") and is not proxied on the render context.`
    ) : e === ie && x(
      `Property ${JSON.stringify(t)} was accessed during render but is not defined on instance.`
    ));
  },
  set({ _: e }, t, n) {
    const { data: o, setupState: s, ctx: i } = e;
    return yo(s, t) ? (s[t] = n, !0) : process.env.NODE_ENV !== "production" && s.__isScriptSetup && K(s, t) ? (x(`Cannot mutate <script setup> binding "${t}" from Options API.`), !1) : o !== z && K(o, t) ? (o[t] = n, !0) : K(e.props, t) ? (process.env.NODE_ENV !== "production" && x(`Attempting to mutate prop "${t}". Props are readonly.`), !1) : t[0] === "$" && t.slice(1) in e ? (process.env.NODE_ENV !== "production" && x(
      `Attempting to mutate public property "${t}". Properties starting with $ are reserved and readonly.`
    ), !1) : (process.env.NODE_ENV !== "production" && t in e.appContext.config.globalProperties ? Object.defineProperty(i, t, {
      enumerable: !0,
      configurable: !0,
      value: n
    }) : i[t] = n, !0);
  },
  has({
    _: { data: e, setupState: t, accessCache: n, ctx: o, appContext: s, propsOptions: i, type: r }
  }, l) {
    let c, p;
    return !!(n[l] || e !== z && l[0] !== "$" && K(e, l) || yo(t, l) || (c = i[0]) && K(c, l) || K(o, l) || K(wt, l) || K(s.config.globalProperties, l) || (p = r.__cssModules) && p[l]);
  },
  defineProperty(e, t, n) {
    return n.get != null ? e._.accessCache[t] = 0 : K(n, "value") && this.set(e, t, n.value, null), Reflect.defineProperty(e, t, n);
  }
};
process.env.NODE_ENV !== "production" && (Wi.ownKeys = (e) => (x(
  "Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead."
), Reflect.ownKeys(e)));
function Xl(e) {
  const t = {};
  return Object.defineProperty(t, "_", {
    configurable: !0,
    enumerable: !1,
    get: () => e
  }), Object.keys(wt).forEach((n) => {
    Object.defineProperty(t, n, {
      configurable: !0,
      enumerable: !1,
      get: () => wt[n](e),
      // intercepted by the proxy so no need for implementation,
      // but needed to prevent set errors
      set: se
    });
  }), t;
}
function ec(e) {
  const {
    ctx: t,
    propsOptions: [n]
  } = e;
  n && Object.keys(n).forEach((o) => {
    Object.defineProperty(t, o, {
      enumerable: !0,
      configurable: !0,
      get: () => e.props[o],
      set: se
    });
  });
}
function tc(e) {
  const { ctx: t, setupState: n } = e;
  Object.keys(P(n)).forEach((o) => {
    if (!n.__isScriptSetup) {
      if (ss(o[0])) {
        x(
          `setup() return property ${JSON.stringify(
            o
          )} should not start with "$" or "_" which are reserved prefixes for Vue internals.`
        );
        return;
      }
      Object.defineProperty(t, o, {
        enumerable: !0,
        configurable: !0,
        get: () => n[o],
        set: se
      });
    }
  });
}
function Os(e) {
  return C(e) ? e.reduce(
    (t, n) => (t[n] = null, t),
    {}
  ) : e;
}
function nc() {
  const e = /* @__PURE__ */ Object.create(null);
  return (t, n) => {
    e[n] ? x(`${t} property "${n}" is already defined in ${e[n]}.`) : e[n] = t;
  };
}
let Io = !0;
function oc(e) {
  const t = zi(e), n = e.proxy, o = e.ctx;
  Io = !1, t.beforeCreate && Ds(t.beforeCreate, e, "bc");
  const {
    // state
    data: s,
    computed: i,
    methods: r,
    watch: l,
    provide: c,
    inject: p,
    // lifecycle
    created: u,
    beforeMount: f,
    mounted: g,
    beforeUpdate: w,
    updated: M,
    activated: S,
    deactivated: V,
    beforeDestroy: G,
    beforeUnmount: R,
    destroyed: j,
    unmounted: fe,
    render: T,
    renderTracked: re,
    renderTriggered: Oe,
    errorCaptured: ae,
    serverPrefetch: me,
    // public API
    expose: Ge,
    inheritAttrs: st,
    // assets
    components: Se,
    directives: bn,
    filters: us
  } = t, it = process.env.NODE_ENV !== "production" ? nc() : null;
  if (process.env.NODE_ENV !== "production") {
    const [L] = e.propsOptions;
    if (L)
      for (const F in L)
        it("Props", F);
  }
  if (p && sc(p, o, it), r)
    for (const L in r) {
      const F = r[L];
      k(F) ? (process.env.NODE_ENV !== "production" ? Object.defineProperty(o, L, {
        value: F.bind(n),
        configurable: !0,
        enumerable: !0,
        writable: !0
      }) : o[L] = F.bind(n), process.env.NODE_ENV !== "production" && it("Methods", L)) : process.env.NODE_ENV !== "production" && x(
        `Method "${L}" has type "${typeof F}" in the component definition. Did you reference the function correctly?`
      );
    }
  if (s) {
    process.env.NODE_ENV !== "production" && !k(s) && x(
      "The data option must be a function. Plain object usage is no longer supported."
    );
    const L = s.call(n, n);
    if (process.env.NODE_ENV !== "production" && Uo(L) && x(
      "data() returned a Promise - note data() cannot be async; If you intend to perform data fetching before component renders, use async setup() + <Suspense>."
    ), !W(L))
      process.env.NODE_ENV !== "production" && x("data() should return an object.");
    else if (e.data = to(L), process.env.NODE_ENV !== "production")
      for (const F in L)
        it("Data", F), ss(F[0]) || Object.defineProperty(o, F, {
          configurable: !0,
          enumerable: !0,
          get: () => L[F],
          set: se
        });
  }
  if (Io = !0, i)
    for (const L in i) {
      const F = i[L], je = k(F) ? F.bind(n, n) : k(F.get) ? F.get.bind(n, n) : se;
      process.env.NODE_ENV !== "production" && je === se && x(`Computed property "${L}" has no getter.`);
      const ao = !k(F) && k(F.set) ? F.set.bind(n) : process.env.NODE_ENV !== "production" ? () => {
        x(
          `Write operation failed: computed property "${L}" is readonly.`
        );
      } : se, Ut = In({
        get: je,
        set: ao
      });
      Object.defineProperty(o, L, {
        enumerable: !0,
        configurable: !0,
        get: () => Ut.value,
        set: (St) => Ut.value = St
      }), process.env.NODE_ENV !== "production" && it("Computed", L);
    }
  if (l)
    for (const L in l)
      qi(l[L], o, n, L);
  if (c) {
    const L = k(c) ? c.call(n) : c;
    Reflect.ownKeys(L).forEach((F) => {
      uc(F, L[F]);
    });
  }
  u && Ds(u, e, "c");
  function ve(L, F) {
    C(F) ? F.forEach((je) => L(je.bind(n))) : F && L(F.bind(n));
  }
  if (ve(Bl, f), ve(Dt, g), ve(Wl, w), ve(ql, M), ve(Hl, S), ve(Kl, V), ve(Zl, ae), ve(Yl, re), ve(Jl, Oe), ve(zl, R), ve(Ki, fe), ve(Gl, me), C(Ge))
    if (Ge.length) {
      const L = e.exposed || (e.exposed = {});
      Ge.forEach((F) => {
        Object.defineProperty(L, F, {
          get: () => n[F],
          set: (je) => n[F] = je,
          enumerable: !0
        });
      });
    } else e.exposed || (e.exposed = {});
  T && e.render === se && (e.render = T), st != null && (e.inheritAttrs = st), Se && (e.components = Se), bn && (e.directives = bn), me && Li(e);
}
function sc(e, t, n = se) {
  C(e) && (e = ko(e));
  for (const o in e) {
    const s = e[o];
    let i;
    W(s) ? "default" in s ? i = Vn(
      s.from || o,
      s.default,
      !0
    ) : i = Vn(s.from || o) : i = Vn(s), te(i) ? Object.defineProperty(t, o, {
      enumerable: !0,
      configurable: !0,
      get: () => i.value,
      set: (r) => i.value = r
    }) : t[o] = i, process.env.NODE_ENV !== "production" && n("Inject", o);
  }
}
function Ds(e, t, n) {
  ze(
    C(e) ? e.map((o) => o.bind(t.proxy)) : e.bind(t.proxy),
    t,
    n
  );
}
function qi(e, t, n, o) {
  let s = o.includes(".") ? ir(n, o) : () => n[o];
  if (Q(e)) {
    const i = t[e];
    k(i) ? $n(s, i) : process.env.NODE_ENV !== "production" && x(`Invalid watch handler specified by key "${e}"`, i);
  } else if (k(e))
    $n(s, e.bind(n));
  else if (W(e))
    if (C(e))
      e.forEach((i) => qi(i, t, n, o));
    else {
      const i = k(e.handler) ? e.handler.bind(n) : t[e.handler];
      k(i) ? $n(s, i, e) : process.env.NODE_ENV !== "production" && x(`Invalid watch handler specified by key "${e.handler}"`, i);
    }
  else process.env.NODE_ENV !== "production" && x(`Invalid watch option: "${o}"`, e);
}
function zi(e) {
  const t = e.type, { mixins: n, extends: o } = t, {
    mixins: s,
    optionsCache: i,
    config: { optionMergeStrategies: r }
  } = e.appContext, l = i.get(t);
  let c;
  return l ? c = l : !s.length && !n && !o ? c = t : (c = {}, s.length && s.forEach(
    (p) => Un(c, p, r, !0)
  ), Un(c, t, r)), W(t) && i.set(t, c), c;
}
function Un(e, t, n, o = !1) {
  const { mixins: s, extends: i } = t;
  i && Un(e, i, n, !0), s && s.forEach(
    (r) => Un(e, r, n, !0)
  );
  for (const r in t)
    if (o && r === "expose")
      process.env.NODE_ENV !== "production" && x(
        '"expose" option is ignored when declared in mixins or extends. It should only be declared in the base component itself.'
      );
    else {
      const l = ic[r] || n && n[r];
      e[r] = l ? l(e[r], t[r]) : t[r];
    }
  return e;
}
const ic = {
  data: Ss,
  props: Vs,
  emits: Vs,
  // objects
  methods: Zt,
  computed: Zt,
  // lifecycle
  beforeCreate: pe,
  created: pe,
  beforeMount: pe,
  mounted: pe,
  beforeUpdate: pe,
  updated: pe,
  beforeDestroy: pe,
  beforeUnmount: pe,
  destroyed: pe,
  unmounted: pe,
  activated: pe,
  deactivated: pe,
  errorCaptured: pe,
  serverPrefetch: pe,
  // assets
  components: Zt,
  directives: Zt,
  // watch
  watch: lc,
  // provide / inject
  provide: Ss,
  inject: rc
};
function Ss(e, t) {
  return t ? e ? function() {
    return ne(
      k(e) ? e.call(this, this) : e,
      k(t) ? t.call(this, this) : t
    );
  } : t : e;
}
function rc(e, t) {
  return Zt(ko(e), ko(t));
}
function ko(e) {
  if (C(e)) {
    const t = {};
    for (let n = 0; n < e.length; n++)
      t[e[n]] = e[n];
    return t;
  }
  return e;
}
function pe(e, t) {
  return e ? [...new Set([].concat(e, t))] : t;
}
function Zt(e, t) {
  return e ? ne(/* @__PURE__ */ Object.create(null), e, t) : t;
}
function Vs(e, t) {
  return e ? C(e) && C(t) ? [.../* @__PURE__ */ new Set([...e, ...t])] : ne(
    /* @__PURE__ */ Object.create(null),
    Os(e),
    Os(t ?? {})
  ) : t;
}
function lc(e, t) {
  if (!e) return t;
  if (!t) return e;
  const n = ne(/* @__PURE__ */ Object.create(null), e);
  for (const o in t)
    n[o] = pe(e[o], t[o]);
  return n;
}
function Gi() {
  return {
    app: null,
    config: {
      isNativeTag: ii,
      performance: !1,
      globalProperties: {},
      optionMergeStrategies: {},
      errorHandler: void 0,
      warnHandler: void 0,
      compilerOptions: {}
    },
    mixins: [],
    components: {},
    directives: {},
    provides: /* @__PURE__ */ Object.create(null),
    optionsCache: /* @__PURE__ */ new WeakMap(),
    propsCache: /* @__PURE__ */ new WeakMap(),
    emitsCache: /* @__PURE__ */ new WeakMap()
  };
}
let cc = 0;
function ac(e, t) {
  return function(o, s = null) {
    k(o) || (o = ne({}, o)), s != null && !W(s) && (process.env.NODE_ENV !== "production" && x("root props passed to app.mount() must be an object."), s = null);
    const i = Gi(), r = /* @__PURE__ */ new WeakSet(), l = [];
    let c = !1;
    const p = i.app = {
      _uid: cc++,
      _component: o,
      _props: s,
      _container: null,
      _context: i,
      _instance: null,
      version: Hs,
      get config() {
        return i.config;
      },
      set config(u) {
        process.env.NODE_ENV !== "production" && x(
          "app.config cannot be replaced. Modify individual options instead."
        );
      },
      use(u, ...f) {
        return r.has(u) ? process.env.NODE_ENV !== "production" && x("Plugin has already been applied to target app.") : u && k(u.install) ? (r.add(u), u.install(p, ...f)) : k(u) ? (r.add(u), u(p, ...f)) : process.env.NODE_ENV !== "production" && x(
          'A plugin must either be a function or an object with an "install" function.'
        ), p;
      },
      mixin(u) {
        return i.mixins.includes(u) ? process.env.NODE_ENV !== "production" && x(
          "Mixin has already been applied to target app" + (u.name ? `: ${u.name}` : "")
        ) : i.mixins.push(u), p;
      },
      component(u, f) {
        return process.env.NODE_ENV !== "production" && Ro(u, i.config), f ? (process.env.NODE_ENV !== "production" && i.components[u] && x(`Component "${u}" has already been registered in target app.`), i.components[u] = f, p) : i.components[u];
      },
      directive(u, f) {
        return process.env.NODE_ENV !== "production" && Fi(u), f ? (process.env.NODE_ENV !== "production" && i.directives[u] && x(`Directive "${u}" has already been registered in target app.`), i.directives[u] = f, p) : i.directives[u];
      },
      mount(u, f, g) {
        if (c)
          process.env.NODE_ENV !== "production" && x(
            "App has already been mounted.\nIf you want to remount the same app, move your app creation logic into a factory function and create fresh app instances for each mount - e.g. `const createMyApp = () => createApp(App)`"
          );
        else {
          process.env.NODE_ENV !== "production" && u.__vue_app__ && x(
            "There is already an app instance mounted on the host container.\n If you want to mount another app on the same host container, you need to unmount the previous app by calling `app.unmount()` first."
          );
          const w = p._ceVNode || ee(o, s);
          return w.appContext = i, g === !0 ? g = "svg" : g === !1 && (g = void 0), process.env.NODE_ENV !== "production" && (i.reload = () => {
            const M = pt(w);
            M.el = null, e(M, u, g);
          }), e(w, u, g), c = !0, p._container = u, u.__vue_app__ = p, process.env.NODE_ENV !== "production" && (p._instance = w.component, $l(p, Hs)), ro(w.component);
        }
      },
      onUnmount(u) {
        process.env.NODE_ENV !== "production" && typeof u != "function" && x(
          `Expected function as first argument to app.onUnmount(), but got ${typeof u}`
        ), l.push(u);
      },
      unmount() {
        c ? (ze(
          l,
          p._instance,
          16
        ), e(null, p._container), process.env.NODE_ENV !== "production" && (p._instance = null, Tl(p)), delete p._container.__vue_app__) : process.env.NODE_ENV !== "production" && x("Cannot unmount an app that is not mounted.");
      },
      provide(u, f) {
        return process.env.NODE_ENV !== "production" && u in i.provides && (K(i.provides, u) ? x(
          `App already provides property with key "${String(u)}". It will be overwritten with the new value.`
        ) : x(
          `App already provides property with key "${String(u)}" inherited from its parent element. It will be overwritten with the new value.`
        )), i.provides[u] = f, p;
      },
      runWithContext(u) {
        const f = Rt;
        Rt = p;
        try {
          return u();
        } finally {
          Rt = f;
        }
      }
    };
    return p;
  };
}
let Rt = null;
function uc(e, t) {
  if (!ce)
    process.env.NODE_ENV !== "production" && x("provide() can only be used inside setup().");
  else {
    let n = ce.provides;
    const o = ce.parent && ce.parent.provides;
    o === n && (n = ce.provides = Object.create(o)), n[e] = t;
  }
}
function Vn(e, t, n = !1) {
  const o = hr();
  if (o || Rt) {
    let s = Rt ? Rt._context.provides : o ? o.parent == null || o.ce ? o.vnode.appContext && o.vnode.appContext.provides : o.parent.provides : void 0;
    if (s && e in s)
      return s[e];
    if (arguments.length > 1)
      return n && k(t) ? t.call(o && o.proxy) : t;
    process.env.NODE_ENV !== "production" && x(`injection "${String(e)}" not found.`);
  } else process.env.NODE_ENV !== "production" && x("inject() can only be used inside setup() or functional components.");
}
const Ji = {}, Yi = () => Object.create(Ji), Zi = (e) => Object.getPrototypeOf(e) === Ji;
function fc(e, t, n, o = !1) {
  const s = {}, i = Yi();
  e.propsDefaults = /* @__PURE__ */ Object.create(null), Qi(e, t, s, i);
  for (const r in e.propsOptions[0])
    r in s || (s[r] = void 0);
  process.env.NODE_ENV !== "production" && er(t || {}, s, e), n ? e.props = o ? s : al(s) : e.type.props ? e.props = s : e.props = i, e.attrs = i;
}
function dc(e) {
  for (; e; ) {
    if (e.type.__hmrId) return !0;
    e = e.parent;
  }
}
function pc(e, t, n, o) {
  const {
    props: s,
    attrs: i,
    vnode: { patchFlag: r }
  } = e, l = P(s), [c] = e.propsOptions;
  let p = !1;
  if (
    // always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    !(process.env.NODE_ENV !== "production" && dc(e)) && (o || r > 0) && !(r & 16)
  ) {
    if (r & 8) {
      const u = e.vnode.dynamicProps;
      for (let f = 0; f < u.length; f++) {
        let g = u[f];
        if (io(e.emitsOptions, g))
          continue;
        const w = t[g];
        if (c)
          if (K(i, g))
            w !== i[g] && (i[g] = w, p = !0);
          else {
            const M = $e(g);
            s[M] = Mo(
              c,
              l,
              M,
              w,
              e,
              !1
            );
          }
        else
          w !== i[g] && (i[g] = w, p = !0);
      }
    }
  } else {
    Qi(e, t, s, i) && (p = !0);
    let u;
    for (const f in l)
      (!t || // for camelCase
      !K(t, f) && // it's possible the original props was passed in as kebab-case
      // and converted to camelCase (#955)
      ((u = dt(f)) === f || !K(t, u))) && (c ? n && // for camelCase
      (n[f] !== void 0 || // for kebab-case
      n[u] !== void 0) && (s[f] = Mo(
        c,
        l,
        f,
        void 0,
        e,
        !0
      )) : delete s[f]);
    if (i !== l)
      for (const f in i)
        (!t || !K(t, f)) && (delete i[f], p = !0);
  }
  p && Ue(e.attrs, "set", ""), process.env.NODE_ENV !== "production" && er(t || {}, s, e);
}
function Qi(e, t, n, o) {
  const [s, i] = e.propsOptions;
  let r = !1, l;
  if (t)
    for (let c in t) {
      if (Qt(c))
        continue;
      const p = t[c];
      let u;
      s && K(s, u = $e(c)) ? !i || !i.includes(u) ? n[u] = p : (l || (l = {}))[u] = p : io(e.emitsOptions, c) || (!(c in o) || p !== o[c]) && (o[c] = p, r = !0);
    }
  if (i) {
    const c = P(n), p = l || z;
    for (let u = 0; u < i.length; u++) {
      const f = i[u];
      n[f] = Mo(
        s,
        c,
        f,
        p[f],
        e,
        !K(p, f)
      );
    }
  }
  return r;
}
function Mo(e, t, n, o, s, i) {
  const r = e[n];
  if (r != null) {
    const l = K(r, "default");
    if (l && o === void 0) {
      const c = r.default;
      if (r.type !== Function && !r.skipFactory && k(c)) {
        const { propsDefaults: p } = s;
        if (n in p)
          o = p[n];
        else {
          const u = vn(s);
          o = p[n] = c.call(
            null,
            t
          ), u();
        }
      } else
        o = c;
      s.ce && s.ce._setProp(n, o);
    }
    r[
      0
      /* shouldCast */
    ] && (i && !l ? o = !1 : r[
      1
      /* shouldCastTrue */
    ] && (o === "" || o === dt(n)) && (o = !0));
  }
  return o;
}
const hc = /* @__PURE__ */ new WeakMap();
function Xi(e, t, n = !1) {
  const o = n ? hc : t.propsCache, s = o.get(e);
  if (s)
    return s;
  const i = e.props, r = {}, l = [];
  let c = !1;
  if (!k(e)) {
    const u = (f) => {
      c = !0;
      const [g, w] = Xi(f, t, !0);
      ne(r, g), w && l.push(...w);
    };
    !n && t.mixins.length && t.mixins.forEach(u), e.extends && u(e.extends), e.mixins && e.mixins.forEach(u);
  }
  if (!i && !c)
    return W(e) && o.set(e, At), At;
  if (C(i))
    for (let u = 0; u < i.length; u++) {
      process.env.NODE_ENV !== "production" && !Q(i[u]) && x("props must be strings when using array syntax.", i[u]);
      const f = $e(i[u]);
      Cs(f) && (r[f] = z);
    }
  else if (i) {
    process.env.NODE_ENV !== "production" && !W(i) && x("invalid props options", i);
    for (const u in i) {
      const f = $e(u);
      if (Cs(f)) {
        const g = i[u], w = r[f] = C(g) || k(g) ? { type: g } : ne({}, g), M = w.type;
        let S = !1, V = !0;
        if (C(M))
          for (let G = 0; G < M.length; ++G) {
            const R = M[G], j = k(R) && R.name;
            if (j === "Boolean") {
              S = !0;
              break;
            } else j === "String" && (V = !1);
          }
        else
          S = k(M) && M.name === "Boolean";
        w[
          0
          /* shouldCast */
        ] = S, w[
          1
          /* shouldCastTrue */
        ] = V, (S || K(w, "default")) && l.push(f);
      }
    }
  }
  const p = [r, l];
  return W(e) && o.set(e, p), p;
}
function Cs(e) {
  return e[0] !== "$" && !Qt(e) ? !0 : (process.env.NODE_ENV !== "production" && x(`Invalid prop name: "${e}" is a reserved property.`), !1);
}
function gc(e) {
  return e === null ? "null" : typeof e == "function" ? e.name || "" : typeof e == "object" && e.constructor && e.constructor.name || "";
}
function er(e, t, n) {
  const o = P(t), s = n.propsOptions[0], i = Object.keys(e).map((r) => $e(r));
  for (const r in s) {
    let l = s[r];
    l != null && mc(
      r,
      o[r],
      l,
      process.env.NODE_ENV !== "production" ? Be(o) : o,
      !i.includes(r)
    );
  }
}
function mc(e, t, n, o, s) {
  const { type: i, required: r, validator: l, skipCheck: c } = n;
  if (r && s) {
    x('Missing required prop: "' + e + '"');
    return;
  }
  if (!(t == null && !r)) {
    if (i != null && i !== !0 && !c) {
      let p = !1;
      const u = C(i) ? i : [i], f = [];
      for (let g = 0; g < u.length && !p; g++) {
        const { valid: w, expectedType: M } = _c(t, u[g]);
        f.push(M || ""), p = w;
      }
      if (!p) {
        x(bc(e, t, f));
        return;
      }
    }
    l && !l(t, o) && x('Invalid prop: custom validator check failed for prop "' + e + '".');
  }
}
const vc = /* @__PURE__ */ tt(
  "String,Number,Boolean,Function,Symbol,BigInt"
);
function _c(e, t) {
  let n;
  const o = gc(t);
  if (o === "null")
    n = e === null;
  else if (vc(o)) {
    const s = typeof e;
    n = s === o.toLowerCase(), !n && s === "object" && (n = e instanceof t);
  } else o === "Object" ? n = W(e) : o === "Array" ? n = C(e) : n = e instanceof t;
  return {
    valid: n,
    expectedType: o
  };
}
function bc(e, t, n) {
  if (n.length === 0)
    return `Prop type [] for prop "${e}" won't match anything. Did you mean to use type Array instead?`;
  let o = `Invalid prop: type check failed for prop "${e}". Expected ${n.map(Yn).join(" | ")}`;
  const s = n[0], i = Bo(t), r = $s(t, s), l = $s(t, i);
  return n.length === 1 && Ts(s) && !yc(s, i) && (o += ` with value ${r}`), o += `, got ${i} `, Ts(i) && (o += `with value ${l}.`), o;
}
function $s(e, t) {
  return t === "String" ? `"${e}"` : t === "Number" ? `${Number(e)}` : `${e}`;
}
function Ts(e) {
  return ["string", "number", "boolean"].some((n) => e.toLowerCase() === n);
}
function yc(...e) {
  return e.some((t) => t.toLowerCase() === "boolean");
}
const is = (e) => e === "_" || e === "_ctx" || e === "$stable", rs = (e) => C(e) ? e.map(Ve) : [Ve(e)], Ec = (e, t, n) => {
  if (t._n)
    return t;
  const o = Ie((...s) => (process.env.NODE_ENV !== "production" && ce && !(n === null && ie) && !(n && n.root !== ce.root) && x(
    `Slot "${e}" invoked outside of the render function: this will not track dependencies used in the slot. Invoke the slot function inside the render function instead.`
  ), rs(t(...s))), n);
  return o._c = !1, o;
}, tr = (e, t, n) => {
  const o = e._ctx;
  for (const s in e) {
    if (is(s)) continue;
    const i = e[s];
    if (k(i))
      t[s] = Ec(s, i, o);
    else if (i != null) {
      process.env.NODE_ENV !== "production" && x(
        `Non-function value encountered for slot "${s}". Prefer function slots for better performance.`
      );
      const r = rs(i);
      t[s] = () => r;
    }
  }
}, nr = (e, t) => {
  process.env.NODE_ENV !== "production" && !ns(e.vnode) && x(
    "Non-function value encountered for default slot. Prefer function slots for better performance."
  );
  const n = rs(t);
  e.slots.default = () => n;
}, Ao = (e, t, n) => {
  for (const o in t)
    (n || !is(o)) && (e[o] = t[o]);
}, Nc = (e, t, n) => {
  const o = e.slots = Yi();
  if (e.vnode.shapeFlag & 32) {
    const s = t._;
    s ? (Ao(o, t, n), n && An(o, "_", s, !0)) : tr(t, o);
  } else t && nr(e, t);
}, xc = (e, t, n) => {
  const { vnode: o, slots: s } = e;
  let i = !0, r = z;
  if (o.shapeFlag & 32) {
    const l = t._;
    l ? process.env.NODE_ENV !== "production" && We ? (Ao(s, t, n), Ue(e, "set", "$slots")) : n && l === 1 ? i = !1 : Ao(s, t, n) : (i = !t.$stable, tr(t, s)), r = t;
  } else t && (nr(e, t), r = { default: 1 });
  if (i)
    for (const l in s)
      !is(l) && r[l] == null && delete s[l];
};
let Gt, Ze;
function Ct(e, t) {
  e.appContext.config.performance && Bn() && Ze.mark(`vue-${t}-${e.uid}`), process.env.NODE_ENV !== "production" && Al(e, t, Bn() ? Ze.now() : Date.now());
}
function $t(e, t) {
  if (e.appContext.config.performance && Bn()) {
    const n = `vue-${t}-${e.uid}`, o = n + ":end", s = `<${lo(e, e.type)}> ${t}`;
    Ze.mark(o), Ze.measure(s, n, o), Ze.clearMeasures(s), Ze.clearMarks(n), Ze.clearMarks(o);
  }
  process.env.NODE_ENV !== "production" && Pl(e, t, Bn() ? Ze.now() : Date.now());
}
function Bn() {
  return Gt !== void 0 || (typeof window < "u" && window.performance ? (Gt = !0, Ze = window.performance) : Gt = !1), Gt;
}
function wc() {
  const e = [];
  if (process.env.NODE_ENV !== "production" && e.length) {
    const t = e.length > 1;
    console.warn(
      `Feature flag${t ? "s" : ""} ${e.join(", ")} ${t ? "are" : "is"} not explicitly defined. You are running the esm-bundler build of Vue, which expects these compile-time feature flags to be globally injected via the bundler config in order to get better tree-shaking in the production bundle.

For more details, see https://link.vuejs.org/feature-flags.`
    );
  }
}
const Ne = Fc;
function Oc(e) {
  return Dc(e);
}
function Dc(e, t) {
  wc();
  const n = dn();
  n.__VUE__ = !0, process.env.NODE_ENV !== "production" && Xo(n.__VUE_DEVTOOLS_GLOBAL_HOOK__, n);
  const {
    insert: o,
    remove: s,
    patchProp: i,
    createElement: r,
    createText: l,
    createComment: c,
    setText: p,
    setElementText: u,
    parentNode: f,
    nextSibling: g,
    setScopeId: w = se,
    insertStaticContent: M
  } = e, S = (a, d, h, y = null, v = null, _ = null, O = void 0, N = null, E = process.env.NODE_ENV !== "production" && We ? !1 : !!d.dynamicChildren) => {
    if (a === d)
      return;
    a && !Jt(a, d) && (y = yn(a), rt(a, v, _, !0), a = null), d.patchFlag === -2 && (E = !1, d.dynamicChildren = null);
    const { type: b, ref: I, shapeFlag: D } = d;
    switch (b) {
      case gn:
        V(a, d, h, y);
        break;
      case Ee:
        G(a, d, h, y);
        break;
      case nn:
        a == null ? R(d, h, y, O) : process.env.NODE_ENV !== "production" && j(a, d, h, O);
        break;
      case ue:
        bn(
          a,
          d,
          h,
          y,
          v,
          _,
          O,
          N,
          E
        );
        break;
      default:
        D & 1 ? re(
          a,
          d,
          h,
          y,
          v,
          _,
          O,
          N,
          E
        ) : D & 6 ? us(
          a,
          d,
          h,
          y,
          v,
          _,
          O,
          N,
          E
        ) : D & 64 || D & 128 ? b.process(
          a,
          d,
          h,
          y,
          v,
          _,
          O,
          N,
          E,
          Wt
        ) : process.env.NODE_ENV !== "production" && x("Invalid VNode type:", b, `(${typeof b})`);
    }
    I != null && v ? tn(I, a && a.ref, _, d || a, !d) : I == null && a && a.ref != null && tn(a.ref, null, _, a, !0);
  }, V = (a, d, h, y) => {
    if (a == null)
      o(
        d.el = l(d.children),
        h,
        y
      );
    else {
      const v = d.el = a.el;
      d.children !== a.children && p(v, d.children);
    }
  }, G = (a, d, h, y) => {
    a == null ? o(
      d.el = c(d.children || ""),
      h,
      y
    ) : d.el = a.el;
  }, R = (a, d, h, y) => {
    [a.el, a.anchor] = M(
      a.children,
      d,
      h,
      y,
      a.el,
      a.anchor
    );
  }, j = (a, d, h, y) => {
    if (d.children !== a.children) {
      const v = g(a.anchor);
      T(a), [d.el, d.anchor] = M(
        d.children,
        h,
        v,
        y
      );
    } else
      d.el = a.el, d.anchor = a.anchor;
  }, fe = ({ el: a, anchor: d }, h, y) => {
    let v;
    for (; a && a !== d; )
      v = g(a), o(a, h, y), a = v;
    o(d, h, y);
  }, T = ({ el: a, anchor: d }) => {
    let h;
    for (; a && a !== d; )
      h = g(a), s(a), a = h;
    s(d);
  }, re = (a, d, h, y, v, _, O, N, E) => {
    if (d.type === "svg" ? O = "svg" : d.type === "math" && (O = "mathml"), a == null)
      Oe(
        d,
        h,
        y,
        v,
        _,
        O,
        N,
        E
      );
    else {
      const b = a.el && a.el._isVueCE ? a.el : null;
      try {
        b && b._beginPatch(), Ge(
          a,
          d,
          v,
          _,
          O,
          N,
          E
        );
      } finally {
        b && b._endPatch();
      }
    }
  }, Oe = (a, d, h, y, v, _, O, N) => {
    let E, b;
    const { props: I, shapeFlag: D, transition: $, dirs: A } = a;
    if (E = a.el = r(
      a.type,
      _,
      I && I.is,
      I
    ), D & 8 ? u(E, a.children) : D & 16 && me(
      a.children,
      E,
      null,
      y,
      v,
      Eo(a, _),
      O,
      N
    ), A && ht(a, null, y, "created"), ae(E, a, a.scopeId, O, y), I) {
      for (const Y in I)
        Y !== "value" && !Qt(Y) && i(E, Y, null, I[Y], _, y);
      "value" in I && i(E, "value", null, I.value, _), (b = I.onVnodeBeforeMount) && He(b, y, a);
    }
    process.env.NODE_ENV !== "production" && (An(E, "__vnode", a, !0), An(E, "__vueParentComponent", y, !0)), A && ht(a, null, y, "beforeMount");
    const H = Sc(v, $);
    H && $.beforeEnter(E), o(E, d, h), ((b = I && I.onVnodeMounted) || H || A) && Ne(() => {
      b && He(b, y, a), H && $.enter(E), A && ht(a, null, y, "mounted");
    }, v);
  }, ae = (a, d, h, y, v) => {
    if (h && w(a, h), y)
      for (let _ = 0; _ < y.length; _++)
        w(a, y[_]);
    if (v) {
      let _ = v.subTree;
      if (process.env.NODE_ENV !== "production" && _.patchFlag > 0 && _.patchFlag & 2048 && (_ = ls(_.children) || _), d === _ || cr(_.type) && (_.ssContent === d || _.ssFallback === d)) {
        const O = v.vnode;
        ae(
          a,
          O,
          O.scopeId,
          O.slotScopeIds,
          v.parent
        );
      }
    }
  }, me = (a, d, h, y, v, _, O, N, E = 0) => {
    for (let b = E; b < a.length; b++) {
      const I = a[b] = N ? ct(a[b]) : Ve(a[b]);
      S(
        null,
        I,
        d,
        h,
        y,
        v,
        _,
        O,
        N
      );
    }
  }, Ge = (a, d, h, y, v, _, O) => {
    const N = d.el = a.el;
    process.env.NODE_ENV !== "production" && (N.__vnode = d);
    let { patchFlag: E, dynamicChildren: b, dirs: I } = d;
    E |= a.patchFlag & 16;
    const D = a.props || z, $ = d.props || z;
    let A;
    if (h && gt(h, !1), (A = $.onVnodeBeforeUpdate) && He(A, h, d, a), I && ht(d, a, h, "beforeUpdate"), h && gt(h, !0), process.env.NODE_ENV !== "production" && We && (E = 0, O = !1, b = null), (D.innerHTML && $.innerHTML == null || D.textContent && $.textContent == null) && u(N, ""), b ? (st(
      a.dynamicChildren,
      b,
      N,
      h,
      y,
      Eo(d, v),
      _
    ), process.env.NODE_ENV !== "production" && Cn(a, d)) : O || je(
      a,
      d,
      N,
      null,
      h,
      y,
      Eo(d, v),
      _,
      !1
    ), E > 0) {
      if (E & 16)
        Se(N, D, $, h, v);
      else if (E & 2 && D.class !== $.class && i(N, "class", null, $.class, v), E & 4 && i(N, "style", D.style, $.style, v), E & 8) {
        const H = d.dynamicProps;
        for (let Y = 0; Y < H.length; Y++) {
          const J = H[Y], _e = D[J], be = $[J];
          (be !== _e || J === "value") && i(N, J, _e, be, v, h);
        }
      }
      E & 1 && a.children !== d.children && u(N, d.children);
    } else !O && b == null && Se(N, D, $, h, v);
    ((A = $.onVnodeUpdated) || I) && Ne(() => {
      A && He(A, h, d, a), I && ht(d, a, h, "updated");
    }, y);
  }, st = (a, d, h, y, v, _, O) => {
    for (let N = 0; N < d.length; N++) {
      const E = a[N], b = d[N], I = (
        // oldVNode may be an errored async setup() component inside Suspense
        // which will not have a mounted element
        E.el && // - In the case of a Fragment, we need to provide the actual parent
        // of the Fragment itself so it can move its children.
        (E.type === ue || // - In the case of different nodes, there is going to be a replacement
        // which also requires the correct parent container
        !Jt(E, b) || // - In the case of a component, it could contain anything.
        E.shapeFlag & 198) ? f(E.el) : (
          // In other cases, the parent container is not actually used so we
          // just pass the block element here to avoid a DOM parentNode call.
          h
        )
      );
      S(
        E,
        b,
        I,
        null,
        y,
        v,
        _,
        O,
        !0
      );
    }
  }, Se = (a, d, h, y, v) => {
    if (d !== h) {
      if (d !== z)
        for (const _ in d)
          !Qt(_) && !(_ in h) && i(
            a,
            _,
            d[_],
            null,
            v,
            y
          );
      for (const _ in h) {
        if (Qt(_)) continue;
        const O = h[_], N = d[_];
        O !== N && _ !== "value" && i(a, _, N, O, v, y);
      }
      "value" in h && i(a, "value", d.value, h.value, v);
    }
  }, bn = (a, d, h, y, v, _, O, N, E) => {
    const b = d.el = a ? a.el : l(""), I = d.anchor = a ? a.anchor : l("");
    let { patchFlag: D, dynamicChildren: $, slotScopeIds: A } = d;
    process.env.NODE_ENV !== "production" && // #5523 dev root fragment may inherit directives
    (We || D & 2048) && (D = 0, E = !1, $ = null), A && (N = N ? N.concat(A) : A), a == null ? (o(b, h, y), o(I, h, y), me(
      // #10007
      // such fragment like `<></>` will be compiled into
      // a fragment which doesn't have a children.
      // In this case fallback to an empty array
      d.children || [],
      h,
      I,
      v,
      _,
      O,
      N,
      E
    )) : D > 0 && D & 64 && $ && // #2715 the previous fragment could've been a BAILed one as a result
    // of renderSlot() with no valid children
    a.dynamicChildren ? (st(
      a.dynamicChildren,
      $,
      h,
      v,
      _,
      O,
      N
    ), process.env.NODE_ENV !== "production" ? Cn(a, d) : (
      // #2080 if the stable fragment has a key, it's a <template v-for> that may
      //  get moved around. Make sure all root level vnodes inherit el.
      // #2134 or if it's a component root, it may also get moved around
      // as the component is being moved.
      (d.key != null || v && d === v.subTree) && Cn(
        a,
        d,
        !0
        /* shallow */
      )
    )) : je(
      a,
      d,
      h,
      I,
      v,
      _,
      O,
      N,
      E
    );
  }, us = (a, d, h, y, v, _, O, N, E) => {
    d.slotScopeIds = N, a == null ? d.shapeFlag & 512 ? v.ctx.activate(
      d,
      h,
      y,
      O,
      E
    ) : it(
      d,
      h,
      y,
      v,
      _,
      O,
      E
    ) : ve(a, d, E);
  }, it = (a, d, h, y, v, _, O) => {
    const N = a.component = Wc(
      a,
      y,
      v
    );
    if (process.env.NODE_ENV !== "production" && N.type.__hmrId && Dl(N), process.env.NODE_ENV !== "production" && (On(a), Ct(N, "mount")), ns(a) && (N.ctx.renderer = Wt), process.env.NODE_ENV !== "production" && Ct(N, "init"), zc(N, !1, O), process.env.NODE_ENV !== "production" && $t(N, "init"), process.env.NODE_ENV !== "production" && We && (a.el = null), N.asyncDep) {
      if (v && v.registerDep(N, L, O), !a.el) {
        const E = N.subTree = ee(Ee);
        G(null, E, d, h), a.placeholder = E.el;
      }
    } else
      L(
        N,
        a,
        d,
        h,
        v,
        _,
        O
      );
    process.env.NODE_ENV !== "production" && (Dn(), $t(N, "mount"));
  }, ve = (a, d, h) => {
    const y = d.component = a.component;
    if (jc(a, d, h))
      if (y.asyncDep && !y.asyncResolved) {
        process.env.NODE_ENV !== "production" && On(d), F(y, d, h), process.env.NODE_ENV !== "production" && Dn();
        return;
      } else
        y.next = d, y.update();
    else
      d.el = a.el, y.vnode = d;
  }, L = (a, d, h, y, v, _, O) => {
    const N = () => {
      if (a.isMounted) {
        let { next: D, bu: $, u: A, parent: H, vnode: Y } = a;
        {
          const Fe = or(a);
          if (Fe) {
            D && (D.el = Y.el, F(a, D, O)), Fe.asyncDep.then(() => {
              a.isUnmounted || N();
            });
            return;
          }
        }
        let J = D, _e;
        process.env.NODE_ENV !== "production" && On(D || a.vnode), gt(a, !1), D ? (D.el = Y.el, F(a, D, O)) : D = Y, $ && It($), (_e = D.props && D.props.onVnodeBeforeUpdate) && He(_e, H, D, Y), gt(a, !0), process.env.NODE_ENV !== "production" && Ct(a, "render");
        const be = ks(a);
        process.env.NODE_ENV !== "production" && $t(a, "render");
        const Re = a.subTree;
        a.subTree = be, process.env.NODE_ENV !== "production" && Ct(a, "patch"), S(
          Re,
          be,
          // parent may have changed if it's in a teleport
          f(Re.el),
          // anchor may have changed if it's in a fragment
          yn(Re),
          a,
          v,
          _
        ), process.env.NODE_ENV !== "production" && $t(a, "patch"), D.el = be.el, J === null && Rc(a, be.el), A && Ne(A, v), (_e = D.props && D.props.onVnodeUpdated) && Ne(
          () => He(_e, H, D, Y),
          v
        ), process.env.NODE_ENV !== "production" && Pi(a), process.env.NODE_ENV !== "production" && Dn();
      } else {
        let D;
        const { el: $, props: A } = d, { bm: H, m: Y, parent: J, root: _e, type: be } = a, Re = jt(d);
        gt(a, !1), H && It(H), !Re && (D = A && A.onVnodeBeforeMount) && He(D, J, d), gt(a, !0);
        {
          _e.ce && // @ts-expect-error _def is private
          _e.ce._def.shadowRoot !== !1 && _e.ce._injectChildStyle(be), process.env.NODE_ENV !== "production" && Ct(a, "render");
          const Fe = a.subTree = ks(a);
          process.env.NODE_ENV !== "production" && $t(a, "render"), process.env.NODE_ENV !== "production" && Ct(a, "patch"), S(
            null,
            Fe,
            h,
            y,
            a,
            v,
            _
          ), process.env.NODE_ENV !== "production" && $t(a, "patch"), d.el = Fe.el;
        }
        if (Y && Ne(Y, v), !Re && (D = A && A.onVnodeMounted)) {
          const Fe = d;
          Ne(
            () => He(D, J, Fe),
            v
          );
        }
        (d.shapeFlag & 256 || J && jt(J.vnode) && J.vnode.shapeFlag & 256) && a.a && Ne(a.a, v), a.isMounted = !0, process.env.NODE_ENV !== "production" && Il(a), d = h = y = null;
      }
    };
    a.scope.on();
    const E = a.effect = new di(N);
    a.scope.off();
    const b = a.update = E.run.bind(E), I = a.job = E.runIfDirty.bind(E);
    I.i = a, I.id = a.uid, E.scheduler = () => oo(I), gt(a, !0), process.env.NODE_ENV !== "production" && (E.onTrack = a.rtc ? (D) => It(a.rtc, D) : void 0, E.onTrigger = a.rtg ? (D) => It(a.rtg, D) : void 0), b();
  }, F = (a, d, h) => {
    d.component = a;
    const y = a.vnode.props;
    a.vnode = d, a.next = null, pc(a, d.props, y, h), xc(a, d.children, h), Ae(), ys(a), Pe();
  }, je = (a, d, h, y, v, _, O, N, E = !1) => {
    const b = a && a.children, I = a ? a.shapeFlag : 0, D = d.children, { patchFlag: $, shapeFlag: A } = d;
    if ($ > 0) {
      if ($ & 128) {
        Ut(
          b,
          D,
          h,
          y,
          v,
          _,
          O,
          N,
          E
        );
        return;
      } else if ($ & 256) {
        ao(
          b,
          D,
          h,
          y,
          v,
          _,
          O,
          N,
          E
        );
        return;
      }
    }
    A & 8 ? (I & 16 && Bt(b, v, _), D !== b && u(h, D)) : I & 16 ? A & 16 ? Ut(
      b,
      D,
      h,
      y,
      v,
      _,
      O,
      N,
      E
    ) : Bt(b, v, _, !0) : (I & 8 && u(h, ""), A & 16 && me(
      D,
      h,
      y,
      v,
      _,
      O,
      N,
      E
    ));
  }, ao = (a, d, h, y, v, _, O, N, E) => {
    a = a || At, d = d || At;
    const b = a.length, I = d.length, D = Math.min(b, I);
    let $;
    for ($ = 0; $ < D; $++) {
      const A = d[$] = E ? ct(d[$]) : Ve(d[$]);
      S(
        a[$],
        A,
        h,
        null,
        v,
        _,
        O,
        N,
        E
      );
    }
    b > I ? Bt(
      a,
      v,
      _,
      !0,
      !1,
      D
    ) : me(
      d,
      h,
      y,
      v,
      _,
      O,
      N,
      E,
      D
    );
  }, Ut = (a, d, h, y, v, _, O, N, E) => {
    let b = 0;
    const I = d.length;
    let D = a.length - 1, $ = I - 1;
    for (; b <= D && b <= $; ) {
      const A = a[b], H = d[b] = E ? ct(d[b]) : Ve(d[b]);
      if (Jt(A, H))
        S(
          A,
          H,
          h,
          null,
          v,
          _,
          O,
          N,
          E
        );
      else
        break;
      b++;
    }
    for (; b <= D && b <= $; ) {
      const A = a[D], H = d[$] = E ? ct(d[$]) : Ve(d[$]);
      if (Jt(A, H))
        S(
          A,
          H,
          h,
          null,
          v,
          _,
          O,
          N,
          E
        );
      else
        break;
      D--, $--;
    }
    if (b > D) {
      if (b <= $) {
        const A = $ + 1, H = A < I ? d[A].el : y;
        for (; b <= $; )
          S(
            null,
            d[b] = E ? ct(d[b]) : Ve(d[b]),
            h,
            H,
            v,
            _,
            O,
            N,
            E
          ), b++;
      }
    } else if (b > $)
      for (; b <= D; )
        rt(a[b], v, _, !0), b++;
    else {
      const A = b, H = b, Y = /* @__PURE__ */ new Map();
      for (b = H; b <= $; b++) {
        const de = d[b] = E ? ct(d[b]) : Ve(d[b]);
        de.key != null && (process.env.NODE_ENV !== "production" && Y.has(de.key) && x(
          "Duplicate keys found during update:",
          JSON.stringify(de.key),
          "Make sure keys are unique."
        ), Y.set(de.key, b));
      }
      let J, _e = 0;
      const be = $ - H + 1;
      let Re = !1, Fe = 0;
      const qt = new Array(be);
      for (b = 0; b < be; b++) qt[b] = 0;
      for (b = A; b <= D; b++) {
        const de = a[b];
        if (_e >= be) {
          rt(de, v, _, !0);
          continue;
        }
        let Le;
        if (de.key != null)
          Le = Y.get(de.key);
        else
          for (J = H; J <= $; J++)
            if (qt[J - H] === 0 && Jt(de, d[J])) {
              Le = J;
              break;
            }
        Le === void 0 ? rt(de, v, _, !0) : (qt[Le - H] = b + 1, Le >= Fe ? Fe = Le : Re = !0, S(
          de,
          d[Le],
          h,
          null,
          v,
          _,
          O,
          N,
          E
        ), _e++);
      }
      const ds = Re ? Vc(qt) : At;
      for (J = ds.length - 1, b = be - 1; b >= 0; b--) {
        const de = H + b, Le = d[de], ps = d[de + 1], hs = de + 1 < I ? (
          // #13559, fallback to el placeholder for unresolved async component
          ps.el || ps.placeholder
        ) : y;
        qt[b] === 0 ? S(
          null,
          Le,
          h,
          hs,
          v,
          _,
          O,
          N,
          E
        ) : Re && (J < 0 || b !== ds[J] ? St(Le, h, hs, 2) : J--);
      }
    }
  }, St = (a, d, h, y, v = null) => {
    const { el: _, type: O, transition: N, children: E, shapeFlag: b } = a;
    if (b & 6) {
      St(a.component.subTree, d, h, y);
      return;
    }
    if (b & 128) {
      a.suspense.move(d, h, y);
      return;
    }
    if (b & 64) {
      O.move(a, d, h, Wt);
      return;
    }
    if (O === ue) {
      o(_, d, h);
      for (let D = 0; D < E.length; D++)
        St(E[D], d, h, y);
      o(a.anchor, d, h);
      return;
    }
    if (O === nn) {
      fe(a, d, h);
      return;
    }
    if (y !== 2 && b & 1 && N)
      if (y === 0)
        N.beforeEnter(_), o(_, d, h), Ne(() => N.enter(_), v);
      else {
        const { leave: D, delayLeave: $, afterLeave: A } = N, H = () => {
          a.ctx.isUnmounted ? s(_) : o(_, d, h);
        }, Y = () => {
          _._isLeaving && _[Ll](
            !0
            /* cancelled */
          ), D(_, () => {
            H(), A && A();
          });
        };
        $ ? $(_, H, Y) : Y();
      }
    else
      o(_, d, h);
  }, rt = (a, d, h, y = !1, v = !1) => {
    const {
      type: _,
      props: O,
      ref: N,
      children: E,
      dynamicChildren: b,
      shapeFlag: I,
      patchFlag: D,
      dirs: $,
      cacheIndex: A
    } = a;
    if (D === -2 && (v = !1), N != null && (Ae(), tn(N, null, h, a, !0), Pe()), A != null && (d.renderCache[A] = void 0), I & 256) {
      d.ctx.deactivate(a);
      return;
    }
    const H = I & 1 && $, Y = !jt(a);
    let J;
    if (Y && (J = O && O.onVnodeBeforeUnmount) && He(J, d, a), I & 6)
      xr(a.component, h, y);
    else {
      if (I & 128) {
        a.suspense.unmount(h, y);
        return;
      }
      H && ht(a, null, d, "beforeUnmount"), I & 64 ? a.type.remove(
        a,
        d,
        h,
        Wt,
        y
      ) : b && // #5154
      // when v-once is used inside a block, setBlockTracking(-1) marks the
      // parent block with hasOnce: true
      // so that it doesn't take the fast path during unmount - otherwise
      // components nested in v-once are never unmounted.
      !b.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
      (_ !== ue || D > 0 && D & 64) ? Bt(
        b,
        d,
        h,
        !1,
        !0
      ) : (_ === ue && D & 384 || !v && I & 16) && Bt(E, d, h), y && uo(a);
    }
    (Y && (J = O && O.onVnodeUnmounted) || H) && Ne(() => {
      J && He(J, d, a), H && ht(a, null, d, "unmounted");
    }, h);
  }, uo = (a) => {
    const { type: d, el: h, anchor: y, transition: v } = a;
    if (d === ue) {
      process.env.NODE_ENV !== "production" && a.patchFlag > 0 && a.patchFlag & 2048 && v && !v.persisted ? a.children.forEach((O) => {
        O.type === Ee ? s(O.el) : uo(O);
      }) : Nr(h, y);
      return;
    }
    if (d === nn) {
      T(a);
      return;
    }
    const _ = () => {
      s(h), v && !v.persisted && v.afterLeave && v.afterLeave();
    };
    if (a.shapeFlag & 1 && v && !v.persisted) {
      const { leave: O, delayLeave: N } = v, E = () => O(h, _);
      N ? N(a.el, _, E) : E();
    } else
      _();
  }, Nr = (a, d) => {
    let h;
    for (; a !== d; )
      h = g(a), s(a), a = h;
    s(d);
  }, xr = (a, d, h) => {
    process.env.NODE_ENV !== "production" && a.type.__hmrId && Sl(a);
    const { bum: y, scope: v, job: _, subTree: O, um: N, m: E, a: b } = a;
    Is(E), Is(b), y && It(y), v.stop(), _ && (_.flags |= 8, rt(O, a, d, h)), N && Ne(N, d), Ne(() => {
      a.isUnmounted = !0;
    }, d), process.env.NODE_ENV !== "production" && Ml(a);
  }, Bt = (a, d, h, y = !1, v = !1, _ = 0) => {
    for (let O = _; O < a.length; O++)
      rt(a[O], d, h, y, v);
  }, yn = (a) => {
    if (a.shapeFlag & 6)
      return yn(a.component.subTree);
    if (a.shapeFlag & 128)
      return a.suspense.next();
    const d = g(a.anchor || a.el), h = d && d[Rl];
    return h ? g(h) : d;
  };
  let fo = !1;
  const fs = (a, d, h) => {
    a == null ? d._vnode && rt(d._vnode, null, null, !0) : S(
      d._vnode || null,
      a,
      d,
      null,
      null,
      null,
      h
    ), d._vnode = a, fo || (fo = !0, ys(), ki(), fo = !1);
  }, Wt = {
    p: S,
    um: rt,
    m: St,
    r: uo,
    mt: it,
    mc: me,
    pc: je,
    pbc: st,
    n: yn,
    o: e
  };
  return {
    render: fs,
    hydrate: void 0,
    createApp: ac(fs)
  };
}
function Eo({ type: e, props: t }, n) {
  return n === "svg" && e === "foreignObject" || n === "mathml" && e === "annotation-xml" && t && t.encoding && t.encoding.includes("html") ? void 0 : n;
}
function gt({ effect: e, job: t }, n) {
  n ? (e.flags |= 32, t.flags |= 4) : (e.flags &= -33, t.flags &= -5);
}
function Sc(e, t) {
  return (!e || e && !e.pendingBranch) && t && !t.persisted;
}
function Cn(e, t, n = !1) {
  const o = e.children, s = t.children;
  if (C(o) && C(s))
    for (let i = 0; i < o.length; i++) {
      const r = o[i];
      let l = s[i];
      l.shapeFlag & 1 && !l.dynamicChildren && ((l.patchFlag <= 0 || l.patchFlag === 32) && (l = s[i] = ct(s[i]), l.el = r.el), !n && l.patchFlag !== -2 && Cn(r, l)), l.type === gn && // avoid cached text nodes retaining detached dom nodes
      l.patchFlag !== -1 && (l.el = r.el), l.type === Ee && !l.el && (l.el = r.el), process.env.NODE_ENV !== "production" && l.el && (l.el.__vnode = l);
    }
}
function Vc(e) {
  const t = e.slice(), n = [0];
  let o, s, i, r, l;
  const c = e.length;
  for (o = 0; o < c; o++) {
    const p = e[o];
    if (p !== 0) {
      if (s = n[n.length - 1], e[s] < p) {
        t[o] = s, n.push(o);
        continue;
      }
      for (i = 0, r = n.length - 1; i < r; )
        l = i + r >> 1, e[n[l]] < p ? i = l + 1 : r = l;
      p < e[n[i]] && (i > 0 && (t[o] = n[i - 1]), n[i] = o);
    }
  }
  for (i = n.length, r = n[i - 1]; i-- > 0; )
    n[i] = r, r = t[r];
  return n;
}
function or(e) {
  const t = e.subTree.component;
  if (t)
    return t.asyncDep && !t.asyncResolved ? t : or(t);
}
function Is(e) {
  if (e)
    for (let t = 0; t < e.length; t++)
      e[t].flags |= 8;
}
const Cc = Symbol.for("v-scx"), $c = () => {
  {
    const e = Vn(Cc);
    return e || process.env.NODE_ENV !== "production" && x(
      "Server rendering context not provided. Make sure to only call useSSRContext() conditionally in the server build."
    ), e;
  }
};
function $n(e, t, n) {
  return process.env.NODE_ENV !== "production" && !k(t) && x(
    "`watch(fn, options?)` signature has been moved to a separate API. Use `watchEffect(fn, options?)` instead. `watch` now only supports `watch(source, cb, options?) signature."
  ), sr(e, t, n);
}
function sr(e, t, n = z) {
  const { immediate: o, deep: s, flush: i, once: r } = n;
  process.env.NODE_ENV !== "production" && !t && (o !== void 0 && x(
    'watch() "immediate" option is only respected when using the watch(source, callback, options?) signature.'
  ), s !== void 0 && x(
    'watch() "deep" option is only respected when using the watch(source, callback, options?) signature.'
  ), r !== void 0 && x(
    'watch() "once" option is only respected when using the watch(source, callback, options?) signature.'
  ));
  const l = ne({}, n);
  process.env.NODE_ENV !== "production" && (l.onWarn = x);
  const c = t && o || !t && i !== "post";
  let p;
  if (an) {
    if (i === "sync") {
      const w = $c();
      p = w.__watcherHandles || (w.__watcherHandles = []);
    } else if (!c) {
      const w = () => {
      };
      return w.stop = se, w.resume = se, w.pause = se, w;
    }
  }
  const u = ce;
  l.call = (w, M, S) => ze(w, u, M, S);
  let f = !1;
  i === "post" ? l.scheduler = (w) => {
    Ne(w, u && u.suspense);
  } : i !== "sync" && (f = !0, l.scheduler = (w, M) => {
    M ? w() : oo(w);
  }), l.augmentJob = (w) => {
    t && (w.flags |= 4), f && (w.flags |= 2, u && (w.id = u.uid, w.i = u));
  };
  const g = vl(e, t, l);
  return an && (p ? p.push(g) : c && g()), g;
}
function Tc(e, t, n) {
  const o = this.proxy, s = Q(e) ? e.includes(".") ? ir(o, e) : () => o[e] : e.bind(o, o);
  let i;
  k(t) ? i = t : (i = t.handler, n = t);
  const r = vn(this), l = sr(s, i.bind(o), n);
  return r(), l;
}
function ir(e, t) {
  const n = t.split(".");
  return () => {
    let o = e;
    for (let s = 0; s < n.length && o; s++)
      o = o[n[s]];
    return o;
  };
}
const Ic = (e, t) => t === "modelValue" || t === "model-value" ? e.modelModifiers : e[`${t}Modifiers`] || e[`${$e(t)}Modifiers`] || e[`${dt(t)}Modifiers`];
function kc(e, t, ...n) {
  if (e.isUnmounted) return;
  const o = e.vnode.props || z;
  if (process.env.NODE_ENV !== "production") {
    const {
      emitsOptions: u,
      propsOptions: [f]
    } = e;
    if (u)
      if (!(t in u))
        (!f || !(vt($e(t)) in f)) && x(
          `Component emitted event "${t}" but it is neither declared in the emits option nor as an "${vt($e(t))}" prop.`
        );
      else {
        const g = u[t];
        k(g) && (g(...n) || x(
          `Invalid event arguments: event validation failed for event "${t}".`
        ));
      }
  }
  let s = n;
  const i = t.startsWith("update:"), r = i && Ic(o, t.slice(7));
  if (r && (r.trim && (s = n.map((u) => Q(u) ? u.trim() : u)), r.number && (s = n.map(qo))), process.env.NODE_ENV !== "production" && jl(e, t, s), process.env.NODE_ENV !== "production") {
    const u = t.toLowerCase();
    u !== t && o[vt(u)] && x(
      `Event "${u}" is emitted in component ${lo(
        e,
        e.type
      )} but the handler is registered for "${t}". Note that HTML attributes are case-insensitive and you cannot use v-on to listen to camelCase events when using in-DOM templates. You should probably use "${dt(
        t
      )}" instead of "${t}".`
    );
  }
  let l, c = o[l = vt(t)] || // also try camelCase event handler (#2249)
  o[l = vt($e(t))];
  !c && i && (c = o[l = vt(dt(t))]), c && ze(
    c,
    e,
    6,
    s
  );
  const p = o[l + "Once"];
  if (p) {
    if (!e.emitted)
      e.emitted = {};
    else if (e.emitted[l])
      return;
    e.emitted[l] = !0, ze(
      p,
      e,
      6,
      s
    );
  }
}
const Mc = /* @__PURE__ */ new WeakMap();
function rr(e, t, n = !1) {
  const o = n ? Mc : t.emitsCache, s = o.get(e);
  if (s !== void 0)
    return s;
  const i = e.emits;
  let r = {}, l = !1;
  if (!k(e)) {
    const c = (p) => {
      const u = rr(p, t, !0);
      u && (l = !0, ne(r, u));
    };
    !n && t.mixins.length && t.mixins.forEach(c), e.extends && c(e.extends), e.mixins && e.mixins.forEach(c);
  }
  return !i && !l ? (W(e) && o.set(e, null), null) : (C(i) ? i.forEach((c) => r[c] = null) : ne(r, i), W(e) && o.set(e, r), r);
}
function io(e, t) {
  return !e || !un(t) ? !1 : (t = t.slice(2).replace(/Once$/, ""), K(e, t[0].toLowerCase() + t.slice(1)) || K(e, dt(t)) || K(e, t));
}
let Po = !1;
function Wn() {
  Po = !0;
}
function ks(e) {
  const {
    type: t,
    vnode: n,
    proxy: o,
    withProxy: s,
    propsOptions: [i],
    slots: r,
    attrs: l,
    emit: c,
    render: p,
    renderCache: u,
    props: f,
    data: g,
    setupState: w,
    ctx: M,
    inheritAttrs: S
  } = e, V = Hn(e);
  let G, R;
  process.env.NODE_ENV !== "production" && (Po = !1);
  try {
    if (n.shapeFlag & 4) {
      const T = s || o, re = process.env.NODE_ENV !== "production" && w.__isScriptSetup ? new Proxy(T, {
        get(Oe, ae, me) {
          return x(
            `Property '${String(
              ae
            )}' was accessed via 'this'. Avoid using 'this' in templates.`
          ), Reflect.get(Oe, ae, me);
        }
      }) : T;
      G = Ve(
        p.call(
          re,
          T,
          u,
          process.env.NODE_ENV !== "production" ? Be(f) : f,
          w,
          g,
          M
        )
      ), R = l;
    } else {
      const T = t;
      process.env.NODE_ENV !== "production" && l === f && Wn(), G = Ve(
        T.length > 1 ? T(
          process.env.NODE_ENV !== "production" ? Be(f) : f,
          process.env.NODE_ENV !== "production" ? {
            get attrs() {
              return Wn(), Be(l);
            },
            slots: r,
            emit: c
          } : { attrs: l, slots: r, emit: c }
        ) : T(
          process.env.NODE_ENV !== "production" ? Be(f) : f,
          null
        )
      ), R = t.props ? l : Ac(l);
    }
  } catch (T) {
    on.length = 0, pn(T, e, 1), G = ee(Ee);
  }
  let j = G, fe;
  if (process.env.NODE_ENV !== "production" && G.patchFlag > 0 && G.patchFlag & 2048 && ([j, fe] = lr(G)), R && S !== !1) {
    const T = Object.keys(R), { shapeFlag: re } = j;
    if (T.length) {
      if (re & 7)
        i && T.some(Mn) && (R = Pc(
          R,
          i
        )), j = pt(j, R, !1, !0);
      else if (process.env.NODE_ENV !== "production" && !Po && j.type !== Ee) {
        const Oe = Object.keys(l), ae = [], me = [];
        for (let Ge = 0, st = Oe.length; Ge < st; Ge++) {
          const Se = Oe[Ge];
          un(Se) ? Mn(Se) || ae.push(Se[2].toLowerCase() + Se.slice(3)) : me.push(Se);
        }
        me.length && x(
          `Extraneous non-props attributes (${me.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text or teleport root nodes.`
        ), ae.length && x(
          `Extraneous non-emits event listeners (${ae.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text root nodes. If the listener is intended to be a component custom event listener only, declare it using the "emits" option.`
        );
      }
    }
  }
  return n.dirs && (process.env.NODE_ENV !== "production" && !Ms(j) && x(
    "Runtime directive used on component with non-element root node. The directives will not function as intended."
  ), j = pt(j, null, !1, !0), j.dirs = j.dirs ? j.dirs.concat(n.dirs) : n.dirs), n.transition && (process.env.NODE_ENV !== "production" && !Ms(j) && x(
    "Component inside <Transition> renders non-element root node that cannot be animated."
  ), ts(j, n.transition)), process.env.NODE_ENV !== "production" && fe ? fe(j) : G = j, Hn(V), G;
}
const lr = (e) => {
  const t = e.children, n = e.dynamicChildren, o = ls(t, !1);
  if (o) {
    if (process.env.NODE_ENV !== "production" && o.patchFlag > 0 && o.patchFlag & 2048)
      return lr(o);
  } else return [e, void 0];
  const s = t.indexOf(o), i = n ? n.indexOf(o) : -1, r = (l) => {
    t[s] = l, n && (i > -1 ? n[i] = l : l.patchFlag > 0 && (e.dynamicChildren = [...n, l]));
  };
  return [Ve(o), r];
};
function ls(e, t = !0) {
  let n;
  for (let o = 0; o < e.length; o++) {
    const s = e[o];
    if (mn(s)) {
      if (s.type !== Ee || s.children === "v-if") {
        if (n)
          return;
        if (n = s, process.env.NODE_ENV !== "production" && t && n.patchFlag > 0 && n.patchFlag & 2048)
          return ls(n.children);
      }
    } else
      return;
  }
  return n;
}
const Ac = (e) => {
  let t;
  for (const n in e)
    (n === "class" || n === "style" || un(n)) && ((t || (t = {}))[n] = e[n]);
  return t;
}, Pc = (e, t) => {
  const n = {};
  for (const o in e)
    (!Mn(o) || !(o.slice(9) in t)) && (n[o] = e[o]);
  return n;
}, Ms = (e) => e.shapeFlag & 7 || e.type === Ee;
function jc(e, t, n) {
  const { props: o, children: s, component: i } = e, { props: r, children: l, patchFlag: c } = t, p = i.emitsOptions;
  if (process.env.NODE_ENV !== "production" && (s || l) && We || t.dirs || t.transition)
    return !0;
  if (n && c >= 0) {
    if (c & 1024)
      return !0;
    if (c & 16)
      return o ? As(o, r, p) : !!r;
    if (c & 8) {
      const u = t.dynamicProps;
      for (let f = 0; f < u.length; f++) {
        const g = u[f];
        if (r[g] !== o[g] && !io(p, g))
          return !0;
      }
    }
  } else
    return (s || l) && (!l || !l.$stable) ? !0 : o === r ? !1 : o ? r ? As(o, r, p) : !0 : !!r;
  return !1;
}
function As(e, t, n) {
  const o = Object.keys(t);
  if (o.length !== Object.keys(e).length)
    return !0;
  for (let s = 0; s < o.length; s++) {
    const i = o[s];
    if (t[i] !== e[i] && !io(n, i))
      return !0;
  }
  return !1;
}
function Rc({ vnode: e, parent: t }, n) {
  for (; t; ) {
    const o = t.subTree;
    if (o.suspense && o.suspense.activeBranch === e && (o.el = e.el), o === e)
      (e = t.vnode).el = n, t = t.parent;
    else
      break;
  }
}
const cr = (e) => e.__isSuspense;
function Fc(e, t) {
  t && t.pendingBranch ? C(e) ? t.effects.push(...e) : t.effects.push(e) : Ii(e);
}
const ue = Symbol.for("v-fgt"), gn = Symbol.for("v-txt"), Ee = Symbol.for("v-cmt"), nn = Symbol.for("v-stc"), on = [];
let we = null;
function B(e = !1) {
  on.push(we = e ? null : []);
}
function Lc() {
  on.pop(), we = on[on.length - 1] || null;
}
let cn = 1;
function Ps(e, t = !1) {
  cn += e, e < 0 && we && t && (we.hasOnce = !0);
}
function ar(e) {
  return e.dynamicChildren = cn > 0 ? we || At : null, Lc(), cn > 0 && we && we.push(e), e;
}
function X(e, t, n, o, s, i) {
  return ar(
    m(
      e,
      t,
      n,
      o,
      s,
      i,
      !0
    )
  );
}
function Xe(e, t, n, o, s) {
  return ar(
    ee(
      e,
      t,
      n,
      o,
      s,
      !0
    )
  );
}
function mn(e) {
  return e ? e.__v_isVNode === !0 : !1;
}
function Jt(e, t) {
  if (process.env.NODE_ENV !== "production" && t.shapeFlag & 6 && e.component) {
    const n = Sn.get(t.type);
    if (n && n.has(e.component))
      return e.shapeFlag &= -257, t.shapeFlag &= -513, !1;
  }
  return e.type === t.type && e.key === t.key;
}
const Hc = (...e) => fr(
  ...e
), ur = ({ key: e }) => e ?? null, Tn = ({
  ref: e,
  ref_key: t,
  ref_for: n
}) => (typeof e == "number" && (e = "" + e), e != null ? Q(e) || te(e) || k(e) ? { i: ie, r: e, k: t, f: !!n } : e : null);
function m(e, t = null, n = null, o = 0, s = null, i = e === ue ? 0 : 1, r = !1, l = !1) {
  const c = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e,
    props: t,
    key: t && ur(t),
    ref: t && Tn(t),
    scopeId: Ri,
    slotScopeIds: null,
    children: n,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetStart: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag: i,
    patchFlag: o,
    dynamicProps: s,
    dynamicChildren: null,
    appContext: null,
    ctx: ie
  };
  return l ? (cs(c, n), i & 128 && e.normalize(c)) : n && (c.shapeFlag |= Q(n) ? 8 : 16), process.env.NODE_ENV !== "production" && c.key !== c.key && x("VNode created with invalid key (NaN). VNode type:", c.type), cn > 0 && // avoid a block node from tracking itself
  !r && // has current parent block
  we && // presence of a patch flag indicates this node needs patching on updates.
  // component nodes also should always be patched, because even if the
  // component doesn't need to update, it needs to persist the instance on to
  // the next vnode so that it can be properly unmounted later.
  (c.patchFlag > 0 || i & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
  // vnode should not be considered dynamic due to handler caching.
  c.patchFlag !== 32 && we.push(c), c;
}
const ee = process.env.NODE_ENV !== "production" ? Hc : fr;
function fr(e, t = null, n = null, o = 0, s = null, i = !1) {
  if ((!e || e === Ql) && (process.env.NODE_ENV !== "production" && !e && x(`Invalid vnode type when creating vnode: ${e}.`), e = Ee), mn(e)) {
    const l = pt(
      e,
      t,
      !0
      /* mergeRef: true */
    );
    return n && cs(l, n), cn > 0 && !i && we && (l.shapeFlag & 6 ? we[we.indexOf(e)] = l : we.push(l)), l.patchFlag = -2, l;
  }
  if (_r(e) && (e = e.__vccOpts), t) {
    t = Kc(t);
    let { class: l, style: c } = t;
    l && !Q(l) && (t.class = Lt(l)), W(c) && (Pn(c) && !C(c) && (c = ne({}, c)), t.style = Zn(c));
  }
  const r = Q(e) ? 1 : cr(e) ? 128 : Fl(e) ? 64 : W(e) ? 4 : k(e) ? 2 : 0;
  return process.env.NODE_ENV !== "production" && r & 4 && Pn(e) && (e = P(e), x(
    "Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.",
    `
Component that was made reactive: `,
    e
  )), m(
    e,
    t,
    n,
    o,
    s,
    r,
    i,
    !0
  );
}
function Kc(e) {
  return e ? Pn(e) || Zi(e) ? ne({}, e) : e : null;
}
function pt(e, t, n = !1, o = !1) {
  const { props: s, ref: i, patchFlag: r, children: l, transition: c } = e, p = t ? pr(s || {}, t) : s, u = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e.type,
    props: p,
    key: p && ur(p),
    ref: t && t.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      n && i ? C(i) ? i.concat(Tn(t)) : [i, Tn(t)] : Tn(t)
    ) : i,
    scopeId: e.scopeId,
    slotScopeIds: e.slotScopeIds,
    children: process.env.NODE_ENV !== "production" && r === -1 && C(l) ? l.map(dr) : l,
    target: e.target,
    targetStart: e.targetStart,
    targetAnchor: e.targetAnchor,
    staticCount: e.staticCount,
    shapeFlag: e.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: t && e.type !== ue ? r === -1 ? 16 : r | 16 : r,
    dynamicProps: e.dynamicProps,
    dynamicChildren: e.dynamicChildren,
    appContext: e.appContext,
    dirs: e.dirs,
    transition: c,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: e.component,
    suspense: e.suspense,
    ssContent: e.ssContent && pt(e.ssContent),
    ssFallback: e.ssFallback && pt(e.ssFallback),
    placeholder: e.placeholder,
    el: e.el,
    anchor: e.anchor,
    ctx: e.ctx,
    ce: e.ce
  };
  return c && o && ts(
    u,
    c.clone(u)
  ), u;
}
function dr(e) {
  const t = pt(e);
  return C(e.children) && (t.children = e.children.map(dr)), t;
}
function De(e = " ", t = 0) {
  return ee(gn, null, e, t);
}
function js(e, t) {
  const n = ee(nn, null, e);
  return n.staticCount = t, n;
}
function Ht(e = "", t = !1) {
  return t ? (B(), Xe(Ee, null, e)) : ee(Ee, null, e);
}
function Ve(e) {
  return e == null || typeof e == "boolean" ? ee(Ee) : C(e) ? ee(
    ue,
    null,
    // #3666, avoid reference pollution when reusing vnode
    e.slice()
  ) : mn(e) ? ct(e) : ee(gn, null, String(e));
}
function ct(e) {
  return e.el === null && e.patchFlag !== -1 || e.memo ? e : pt(e);
}
function cs(e, t) {
  let n = 0;
  const { shapeFlag: o } = e;
  if (t == null)
    t = null;
  else if (C(t))
    n = 16;
  else if (typeof t == "object")
    if (o & 65) {
      const s = t.default;
      s && (s._c && (s._d = !1), cs(e, s()), s._c && (s._d = !0));
      return;
    } else {
      n = 32;
      const s = t._;
      !s && !Zi(t) ? t._ctx = ie : s === 3 && ie && (ie.slots._ === 1 ? t._ = 1 : (t._ = 2, e.patchFlag |= 1024));
    }
  else k(t) ? (t = { default: t, _ctx: ie }, n = 32) : (t = String(t), o & 64 ? (n = 16, t = [De(t)]) : n = 8);
  e.children = t, e.shapeFlag |= n;
}
function pr(...e) {
  const t = {};
  for (let n = 0; n < e.length; n++) {
    const o = e[n];
    for (const s in o)
      if (s === "class")
        t.class !== o.class && (t.class = Lt([t.class, o.class]));
      else if (s === "style")
        t.style = Zn([t.style, o.style]);
      else if (un(s)) {
        const i = t[s], r = o[s];
        r && i !== r && !(C(i) && i.includes(r)) && (t[s] = i ? [].concat(i, r) : r);
      } else s !== "" && (t[s] = o[s]);
  }
  return t;
}
function He(e, t, n, o = null) {
  ze(e, t, 7, [
    n,
    o
  ]);
}
const Uc = Gi();
let Bc = 0;
function Wc(e, t, n) {
  const o = e.type, s = (t ? t.appContext : e.appContext) || Uc, i = {
    uid: Bc++,
    vnode: e,
    type: o,
    parent: t,
    appContext: s,
    root: null,
    // to be immediately set
    next: null,
    subTree: null,
    // will be set synchronously right after creation
    effect: null,
    update: null,
    // will be set synchronously right after creation
    job: null,
    scope: new Ur(
      !0
      /* detached */
    ),
    render: null,
    proxy: null,
    exposed: null,
    exposeProxy: null,
    withProxy: null,
    provides: t ? t.provides : Object.create(s.provides),
    ids: t ? t.ids : ["", 0, 0],
    accessCache: null,
    renderCache: [],
    // local resolved assets
    components: null,
    directives: null,
    // resolved props and emits options
    propsOptions: Xi(o, s),
    emitsOptions: rr(o, s),
    // emit
    emit: null,
    // to be set immediately
    emitted: null,
    // props default value
    propsDefaults: z,
    // inheritAttrs
    inheritAttrs: o.inheritAttrs,
    // state
    ctx: z,
    data: z,
    props: z,
    attrs: z,
    slots: z,
    refs: z,
    setupState: z,
    setupContext: null,
    // suspense related
    suspense: n,
    suspenseId: n ? n.pendingId : 0,
    asyncDep: null,
    asyncResolved: !1,
    // lifecycle hooks
    // not using enums here because it results in computed properties
    isMounted: !1,
    isUnmounted: !1,
    isDeactivated: !1,
    bc: null,
    c: null,
    bm: null,
    m: null,
    bu: null,
    u: null,
    um: null,
    bum: null,
    da: null,
    a: null,
    rtg: null,
    rtc: null,
    ec: null,
    sp: null
  };
  return process.env.NODE_ENV !== "production" ? i.ctx = Xl(i) : i.ctx = { _: i }, i.root = t ? t.root : i, i.emit = kc.bind(null, i), e.ce && e.ce(i), i;
}
let ce = null;
const hr = () => ce || ie;
let qn, jo;
{
  const e = dn(), t = (n, o) => {
    let s;
    return (s = e[n]) || (s = e[n] = []), s.push(o), (i) => {
      s.length > 1 ? s.forEach((r) => r(i)) : s[0](i);
    };
  };
  qn = t(
    "__VUE_INSTANCE_SETTERS__",
    (n) => ce = n
  ), jo = t(
    "__VUE_SSR_SETTERS__",
    (n) => an = n
  );
}
const vn = (e) => {
  const t = ce;
  return qn(e), e.scope.on(), () => {
    e.scope.off(), qn(t);
  };
}, Rs = () => {
  ce && ce.scope.off(), qn(null);
}, qc = /* @__PURE__ */ tt("slot,component");
function Ro(e, { isNativeTag: t }) {
  (qc(e) || t(e)) && x(
    "Do not use built-in or reserved HTML elements as component id: " + e
  );
}
function gr(e) {
  return e.vnode.shapeFlag & 4;
}
let an = !1;
function zc(e, t = !1, n = !1) {
  t && jo(t);
  const { props: o, children: s } = e.vnode, i = gr(e);
  fc(e, o, i, t), Nc(e, s, n || t);
  const r = i ? Gc(e, t) : void 0;
  return t && jo(!1), r;
}
function Gc(e, t) {
  var n;
  const o = e.type;
  if (process.env.NODE_ENV !== "production") {
    if (o.name && Ro(o.name, e.appContext.config), o.components) {
      const i = Object.keys(o.components);
      for (let r = 0; r < i.length; r++)
        Ro(i[r], e.appContext.config);
    }
    if (o.directives) {
      const i = Object.keys(o.directives);
      for (let r = 0; r < i.length; r++)
        Fi(i[r]);
    }
    o.compilerOptions && Jc() && x(
      '"compilerOptions" is only supported when using a build of Vue that includes the runtime compiler. Since you are using a runtime-only build, the options should be passed via your build tool config instead.'
    );
  }
  e.accessCache = /* @__PURE__ */ Object.create(null), e.proxy = new Proxy(e.ctx, Wi), process.env.NODE_ENV !== "production" && ec(e);
  const { setup: s } = o;
  if (s) {
    Ae();
    const i = e.setupContext = s.length > 1 ? Zc(e) : null, r = vn(e), l = Kt(
      s,
      e,
      0,
      [
        process.env.NODE_ENV !== "production" ? Be(e.props) : e.props,
        i
      ]
    ), c = Uo(l);
    if (Pe(), r(), (c || e.sp) && !jt(e) && Li(e), c) {
      if (l.then(Rs, Rs), t)
        return l.then((p) => {
          Fs(e, p, t);
        }).catch((p) => {
          pn(p, e, 0);
        });
      if (e.asyncDep = l, process.env.NODE_ENV !== "production" && !e.suspense) {
        const p = (n = o.name) != null ? n : "Anonymous";
        x(
          `Component <${p}>: setup function returned a promise, but no <Suspense> boundary was found in the parent component tree. A component with async setup() must be nested in a <Suspense> in order to be rendered.`
        );
      }
    } else
      Fs(e, l, t);
  } else
    mr(e, t);
}
function Fs(e, t, n) {
  k(t) ? e.type.__ssrInlineRender ? e.ssrRender = t : e.render = t : W(t) ? (process.env.NODE_ENV !== "production" && mn(t) && x(
    "setup() should not return VNodes directly - return a render function instead."
  ), process.env.NODE_ENV !== "production" && (e.devtoolsRawSetupState = t), e.setupState = Vi(t), process.env.NODE_ENV !== "production" && tc(e)) : process.env.NODE_ENV !== "production" && t !== void 0 && x(
    `setup() should return an object. Received: ${t === null ? "null" : typeof t}`
  ), mr(e, n);
}
const Jc = () => !0;
function mr(e, t, n) {
  const o = e.type;
  e.render || (e.render = o.render || se);
  {
    const s = vn(e);
    Ae();
    try {
      oc(e);
    } finally {
      Pe(), s();
    }
  }
  process.env.NODE_ENV !== "production" && !o.render && e.render === se && !t && (o.template ? x(
    'Component provided template option but runtime compilation is not supported in this build of Vue. Configure your bundler to alias "vue" to "vue/dist/vue.esm-bundler.js".'
  ) : x("Component is missing template or render function: ", o));
}
const Ls = process.env.NODE_ENV !== "production" ? {
  get(e, t) {
    return Wn(), oe(e, "get", ""), e[t];
  },
  set() {
    return x("setupContext.attrs is readonly."), !1;
  },
  deleteProperty() {
    return x("setupContext.attrs is readonly."), !1;
  }
} : {
  get(e, t) {
    return oe(e, "get", ""), e[t];
  }
};
function Yc(e) {
  return new Proxy(e.slots, {
    get(t, n) {
      return oe(e, "get", "$slots"), t[n];
    }
  });
}
function Zc(e) {
  const t = (n) => {
    if (process.env.NODE_ENV !== "production" && (e.exposed && x("expose() should be called only once per setup()."), n != null)) {
      let o = typeof n;
      o === "object" && (C(n) ? o = "array" : te(n) && (o = "ref")), o !== "object" && x(
        `expose() should be passed a plain object, received ${o}.`
      );
    }
    e.exposed = n || {};
  };
  if (process.env.NODE_ENV !== "production") {
    let n, o;
    return Object.freeze({
      get attrs() {
        return n || (n = new Proxy(e.attrs, Ls));
      },
      get slots() {
        return o || (o = Yc(e));
      },
      get emit() {
        return (s, ...i) => e.emit(s, ...i);
      },
      expose: t
    });
  } else
    return {
      attrs: new Proxy(e.attrs, Ls),
      slots: e.slots,
      emit: e.emit,
      expose: t
    };
}
function ro(e) {
  return e.exposed ? e.exposeProxy || (e.exposeProxy = new Proxy(Vi(ul(e.exposed)), {
    get(t, n) {
      if (n in t)
        return t[n];
      if (n in wt)
        return wt[n](e);
    },
    has(t, n) {
      return n in t || n in wt;
    }
  })) : e.proxy;
}
const Qc = /(?:^|[-_])\w/g, Xc = (e) => e.replace(Qc, (t) => t.toUpperCase()).replace(/[-_]/g, "");
function vr(e, t = !0) {
  return k(e) ? e.displayName || e.name : e.name || t && e.__name;
}
function lo(e, t, n = !1) {
  let o = vr(t);
  if (!o && t.__file) {
    const s = t.__file.match(/([^/\\]+)\.\w+$/);
    s && (o = s[1]);
  }
  if (!o && e && e.parent) {
    const s = (i) => {
      for (const r in i)
        if (i[r] === t)
          return r;
    };
    o = s(
      e.components || e.parent.type.components
    ) || s(e.appContext.components);
  }
  return o ? Xc(o) : n ? "App" : "Anonymous";
}
function _r(e) {
  return k(e) && "__vccOpts" in e;
}
const In = (e, t) => {
  const n = gl(e, t, an);
  if (process.env.NODE_ENV !== "production") {
    const o = hr();
    o && o.appContext.config.warnRecursiveComputed && (n._warnRecursive = !0);
  }
  return n;
};
function ea() {
  if (process.env.NODE_ENV === "production" || typeof window > "u")
    return;
  const e = { style: "color:#3ba776" }, t = { style: "color:#1677ff" }, n = { style: "color:#f5222d" }, o = { style: "color:#eb2f96" }, s = {
    __vue_custom_formatter: !0,
    header(f) {
      if (!W(f))
        return null;
      if (f.__isVue)
        return ["div", e, "VueInstance"];
      if (te(f)) {
        Ae();
        const g = f.value;
        return Pe(), [
          "div",
          {},
          ["span", e, u(f)],
          "<",
          l(g),
          ">"
        ];
      } else {
        if (Nt(f))
          return [
            "div",
            {},
            ["span", e, ge(f) ? "ShallowReactive" : "Reactive"],
            "<",
            l(f),
            `>${qe(f) ? " (readonly)" : ""}`
          ];
        if (qe(f))
          return [
            "div",
            {},
            ["span", e, ge(f) ? "ShallowReadonly" : "Readonly"],
            "<",
            l(f),
            ">"
          ];
      }
      return null;
    },
    hasBody(f) {
      return f && f.__isVue;
    },
    body(f) {
      if (f && f.__isVue)
        return [
          "div",
          {},
          ...i(f.$)
        ];
    }
  };
  function i(f) {
    const g = [];
    f.type.props && f.props && g.push(r("props", P(f.props))), f.setupState !== z && g.push(r("setup", f.setupState)), f.data !== z && g.push(r("data", P(f.data)));
    const w = c(f, "computed");
    w && g.push(r("computed", w));
    const M = c(f, "inject");
    return M && g.push(r("injected", M)), g.push([
      "div",
      {},
      [
        "span",
        {
          style: o.style + ";opacity:0.66"
        },
        "$ (internal): "
      ],
      ["object", { object: f }]
    ]), g;
  }
  function r(f, g) {
    return g = ne({}, g), Object.keys(g).length ? [
      "div",
      { style: "line-height:1.25em;margin-bottom:0.6em" },
      [
        "div",
        {
          style: "color:#476582"
        },
        f
      ],
      [
        "div",
        {
          style: "padding-left:1.25em"
        },
        ...Object.keys(g).map((w) => [
          "div",
          {},
          ["span", o, w + ": "],
          l(g[w], !1)
        ])
      ]
    ] : ["span", {}];
  }
  function l(f, g = !0) {
    return typeof f == "number" ? ["span", t, f] : typeof f == "string" ? ["span", n, JSON.stringify(f)] : typeof f == "boolean" ? ["span", o, f] : W(f) ? ["object", { object: g ? P(f) : f }] : ["span", n, String(f)];
  }
  function c(f, g) {
    const w = f.type;
    if (k(w))
      return;
    const M = {};
    for (const S in f.ctx)
      p(w, S, g) && (M[S] = f.ctx[S]);
    return M;
  }
  function p(f, g, w) {
    const M = f[w];
    if (C(M) && M.includes(g) || W(M) && g in M || f.extends && p(f.extends, g, w) || f.mixins && f.mixins.some((S) => p(S, g, w)))
      return !0;
  }
  function u(f) {
    return ge(f) ? "ShallowRef" : f.effect ? "ComputedRef" : "Ref";
  }
  window.devtoolsFormatters ? window.devtoolsFormatters.push(s) : window.devtoolsFormatters = [s];
}
const Hs = "3.5.24", et = process.env.NODE_ENV !== "production" ? x : se;
process.env.NODE_ENV;
process.env.NODE_ENV;
/**
* @vue/runtime-dom v3.5.24
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
let Fo;
const Ks = typeof window < "u" && window.trustedTypes;
if (Ks)
  try {
    Fo = /* @__PURE__ */ Ks.createPolicy("vue", {
      createHTML: (e) => e
    });
  } catch (e) {
    process.env.NODE_ENV !== "production" && et(`Error creating trusted types policy: ${e}`);
  }
const br = Fo ? (e) => Fo.createHTML(e) : (e) => e, ta = "http://www.w3.org/2000/svg", na = "http://www.w3.org/1998/Math/MathML", Ye = typeof document < "u" ? document : null, Us = Ye && /* @__PURE__ */ Ye.createElement("template"), oa = {
  insert: (e, t, n) => {
    t.insertBefore(e, n || null);
  },
  remove: (e) => {
    const t = e.parentNode;
    t && t.removeChild(e);
  },
  createElement: (e, t, n, o) => {
    const s = t === "svg" ? Ye.createElementNS(ta, e) : t === "mathml" ? Ye.createElementNS(na, e) : n ? Ye.createElement(e, { is: n }) : Ye.createElement(e);
    return e === "select" && o && o.multiple != null && s.setAttribute("multiple", o.multiple), s;
  },
  createText: (e) => Ye.createTextNode(e),
  createComment: (e) => Ye.createComment(e),
  setText: (e, t) => {
    e.nodeValue = t;
  },
  setElementText: (e, t) => {
    e.textContent = t;
  },
  parentNode: (e) => e.parentNode,
  nextSibling: (e) => e.nextSibling,
  querySelector: (e) => Ye.querySelector(e),
  setScopeId(e, t) {
    e.setAttribute(t, "");
  },
  // __UNSAFE__
  // Reason: innerHTML.
  // Static content here can only come from compiled templates.
  // As long as the user only uses trusted templates, this is safe.
  insertStaticContent(e, t, n, o, s, i) {
    const r = n ? n.previousSibling : t.lastChild;
    if (s && (s === i || s.nextSibling))
      for (; t.insertBefore(s.cloneNode(!0), n), !(s === i || !(s = s.nextSibling)); )
        ;
    else {
      Us.innerHTML = br(
        o === "svg" ? `<svg>${e}</svg>` : o === "mathml" ? `<math>${e}</math>` : e
      );
      const l = Us.content;
      if (o === "svg" || o === "mathml") {
        const c = l.firstChild;
        for (; c.firstChild; )
          l.appendChild(c.firstChild);
        l.removeChild(c);
      }
      t.insertBefore(l, n);
    }
    return [
      // first
      r ? r.nextSibling : t.firstChild,
      // last
      n ? n.previousSibling : t.lastChild
    ];
  }
}, sa = Symbol("_vtc");
function ia(e, t, n) {
  const o = e[sa];
  o && (t = (t ? [t, ...o] : [...o]).join(" ")), t == null ? e.removeAttribute("class") : n ? e.setAttribute("class", t) : e.className = t;
}
const Bs = Symbol("_vod"), ra = Symbol("_vsh"), la = Symbol(process.env.NODE_ENV !== "production" ? "CSS_VAR_TEXT" : ""), ca = /(?:^|;)\s*display\s*:/;
function aa(e, t, n) {
  const o = e.style, s = Q(n);
  let i = !1;
  if (n && !s) {
    if (t)
      if (Q(t))
        for (const r of t.split(";")) {
          const l = r.slice(0, r.indexOf(":")).trim();
          n[l] == null && kn(o, l, "");
        }
      else
        for (const r in t)
          n[r] == null && kn(o, r, "");
    for (const r in n)
      r === "display" && (i = !0), kn(o, r, n[r]);
  } else if (s) {
    if (t !== n) {
      const r = o[la];
      r && (n += ";" + r), o.cssText = n, i = ca.test(n);
    }
  } else t && e.removeAttribute("style");
  Bs in e && (e[Bs] = i ? o.display : "", e[ra] && (o.display = "none"));
}
const ua = /[^\\];\s*$/, Ws = /\s*!important$/;
function kn(e, t, n) {
  if (C(n))
    n.forEach((o) => kn(e, t, o));
  else if (n == null && (n = ""), process.env.NODE_ENV !== "production" && ua.test(n) && et(
    `Unexpected semicolon at the end of '${t}' style value: '${n}'`
  ), t.startsWith("--"))
    e.setProperty(t, n);
  else {
    const o = fa(e, t);
    Ws.test(n) ? e.setProperty(
      dt(o),
      n.replace(Ws, ""),
      "important"
    ) : e[o] = n;
  }
}
const qs = ["Webkit", "Moz", "ms"], No = {};
function fa(e, t) {
  const n = No[t];
  if (n)
    return n;
  let o = $e(t);
  if (o !== "filter" && o in e)
    return No[t] = o;
  o = Yn(o);
  for (let s = 0; s < qs.length; s++) {
    const i = qs[s] + o;
    if (i in e)
      return No[t] = i;
  }
  return t;
}
const zs = "http://www.w3.org/1999/xlink";
function Gs(e, t, n, o, s, i = Hr(t)) {
  o && t.startsWith("xlink:") ? n == null ? e.removeAttributeNS(zs, t.slice(6, t.length)) : e.setAttributeNS(zs, t, n) : n == null || i && !ci(n) ? e.removeAttribute(t) : e.setAttribute(
    t,
    i ? "" : ke(n) ? String(n) : n
  );
}
function Js(e, t, n, o, s) {
  if (t === "innerHTML" || t === "textContent") {
    n != null && (e[t] = t === "innerHTML" ? br(n) : n);
    return;
  }
  const i = e.tagName;
  if (t === "value" && i !== "PROGRESS" && // custom elements may use _value internally
  !i.includes("-")) {
    const l = i === "OPTION" ? e.getAttribute("value") || "" : e.value, c = n == null ? (
      // #11647: value should be set as empty string for null and undefined,
      // but <input type="checkbox"> should be set as 'on'.
      e.type === "checkbox" ? "on" : ""
    ) : String(n);
    (l !== c || !("_value" in e)) && (e.value = c), n == null && e.removeAttribute(t), e._value = n;
    return;
  }
  let r = !1;
  if (n === "" || n == null) {
    const l = typeof e[t];
    l === "boolean" ? n = ci(n) : n == null && l === "string" ? (n = "", r = !0) : l === "number" && (n = 0, r = !0);
  }
  try {
    e[t] = n;
  } catch (l) {
    process.env.NODE_ENV !== "production" && !r && et(
      `Failed setting prop "${t}" on <${i.toLowerCase()}>: value ${n} is invalid.`,
      l
    );
  }
  r && e.removeAttribute(s || t);
}
function bt(e, t, n, o) {
  e.addEventListener(t, n, o);
}
function da(e, t, n, o) {
  e.removeEventListener(t, n, o);
}
const Ys = Symbol("_vei");
function pa(e, t, n, o, s = null) {
  const i = e[Ys] || (e[Ys] = {}), r = i[t];
  if (o && r)
    r.value = process.env.NODE_ENV !== "production" ? Qs(o, t) : o;
  else {
    const [l, c] = ha(t);
    if (o) {
      const p = i[t] = va(
        process.env.NODE_ENV !== "production" ? Qs(o, t) : o,
        s
      );
      bt(e, l, p, c);
    } else r && (da(e, l, r, c), i[t] = void 0);
  }
}
const Zs = /(?:Once|Passive|Capture)$/;
function ha(e) {
  let t;
  if (Zs.test(e)) {
    t = {};
    let o;
    for (; o = e.match(Zs); )
      e = e.slice(0, e.length - o[0].length), t[o[0].toLowerCase()] = !0;
  }
  return [e[2] === ":" ? e.slice(3) : dt(e.slice(2)), t];
}
let xo = 0;
const ga = /* @__PURE__ */ Promise.resolve(), ma = () => xo || (ga.then(() => xo = 0), xo = Date.now());
function va(e, t) {
  const n = (o) => {
    if (!o._vts)
      o._vts = Date.now();
    else if (o._vts <= n.attached)
      return;
    ze(
      _a(o, n.value),
      t,
      5,
      [o]
    );
  };
  return n.value = e, n.attached = ma(), n;
}
function Qs(e, t) {
  return k(e) || C(e) ? e : (et(
    `Wrong type passed as event handler to ${t} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof e}.`
  ), se);
}
function _a(e, t) {
  if (C(t)) {
    const n = e.stopImmediatePropagation;
    return e.stopImmediatePropagation = () => {
      n.call(e), e._stopped = !0;
    }, t.map(
      (o) => (s) => !s._stopped && o && o(s)
    );
  } else
    return t;
}
const Xs = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // lowercase letter
e.charCodeAt(2) > 96 && e.charCodeAt(2) < 123, ba = (e, t, n, o, s, i) => {
  const r = s === "svg";
  t === "class" ? ia(e, o, r) : t === "style" ? aa(e, n, o) : un(t) ? Mn(t) || pa(e, t, n, o, i) : (t[0] === "." ? (t = t.slice(1), !0) : t[0] === "^" ? (t = t.slice(1), !1) : ya(e, t, o, r)) ? (Js(e, t, o), !e.tagName.includes("-") && (t === "value" || t === "checked" || t === "selected") && Gs(e, t, o, r, i, t !== "value")) : /* #11081 force set props for possible async custom element */ e._isVueCE && (/[A-Z]/.test(t) || !Q(o)) ? Js(e, $e(t), o, i, t) : (t === "true-value" ? e._trueValue = o : t === "false-value" && (e._falseValue = o), Gs(e, t, o, r));
};
function ya(e, t, n, o) {
  if (o)
    return !!(t === "innerHTML" || t === "textContent" || t in e && Xs(t) && k(n));
  if (t === "spellcheck" || t === "draggable" || t === "translate" || t === "autocorrect" || t === "sandbox" && e.tagName === "IFRAME" || t === "form" || t === "list" && e.tagName === "INPUT" || t === "type" && e.tagName === "TEXTAREA")
    return !1;
  if (t === "width" || t === "height") {
    const s = e.tagName;
    if (s === "IMG" || s === "VIDEO" || s === "CANVAS" || s === "SOURCE")
      return !1;
  }
  return Xs(t) && Q(n) ? !1 : t in e;
}
const zn = (e) => {
  const t = e.props["onUpdate:modelValue"] || !1;
  return C(t) ? (n) => It(t, n) : t;
};
function Ea(e) {
  e.target.composing = !0;
}
function ei(e) {
  const t = e.target;
  t.composing && (t.composing = !1, t.dispatchEvent(new Event("input")));
}
const Ft = Symbol("_assign");
function ti(e, t, n) {
  return t && (e = e.trim()), n && (e = qo(e)), e;
}
const Na = {
  created(e, { modifiers: { lazy: t, trim: n, number: o } }, s) {
    e[Ft] = zn(s);
    const i = o || s.props && s.props.type === "number";
    bt(e, t ? "change" : "input", (r) => {
      r.target.composing || e[Ft](ti(e.value, n, i));
    }), (n || i) && bt(e, "change", () => {
      e.value = ti(e.value, n, i);
    }), t || (bt(e, "compositionstart", Ea), bt(e, "compositionend", ei), bt(e, "change", ei));
  },
  // set value on mounted so it's after min/max for type="range"
  mounted(e, { value: t }) {
    e.value = t ?? "";
  },
  beforeUpdate(e, { value: t, oldValue: n, modifiers: { lazy: o, trim: s, number: i } }, r) {
    if (e[Ft] = zn(r), e.composing) return;
    const l = (i || e.type === "number") && !/^0\d/.test(e.value) ? qo(e.value) : e.value, c = t ?? "";
    l !== c && (document.activeElement === e && e.type !== "range" && (o && t === n || s && e.value.trim() === c) || (e.value = c));
  }
}, xa = {
  // #4096 array checkboxes need to be deep traversed
  deep: !0,
  created(e, t, n) {
    e[Ft] = zn(n), bt(e, "change", () => {
      const o = e._modelValue, s = wa(e), i = e.checked, r = e[Ft];
      if (C(o)) {
        const l = ai(o, s), c = l !== -1;
        if (i && !c)
          r(o.concat(s));
        else if (!i && c) {
          const p = [...o];
          p.splice(l, 1), r(p);
        }
      } else if (Gn(o)) {
        const l = new Set(o);
        i ? l.add(s) : l.delete(s), r(l);
      } else
        r(yr(e, i));
    });
  },
  // set initial checked on mount to wait for true-value/false-value
  mounted: ni,
  beforeUpdate(e, t, n) {
    e[Ft] = zn(n), ni(e, t, n);
  }
};
function ni(e, { value: t, oldValue: n }, o) {
  e._modelValue = t;
  let s;
  if (C(t))
    s = ai(t, o.props.value) > -1;
  else if (Gn(t))
    s = t.has(o.props.value);
  else {
    if (t === n) return;
    s = Qn(t, yr(e, !0));
  }
  e.checked !== s && (e.checked = s);
}
function wa(e) {
  return "_value" in e ? e._value : e.value;
}
function yr(e, t) {
  const n = t ? "_trueValue" : "_falseValue";
  return n in e ? e[n] : t;
}
const Oa = ["ctrl", "shift", "alt", "meta"], Da = {
  stop: (e) => e.stopPropagation(),
  prevent: (e) => e.preventDefault(),
  self: (e) => e.target !== e.currentTarget,
  ctrl: (e) => !e.ctrlKey,
  shift: (e) => !e.shiftKey,
  alt: (e) => !e.altKey,
  meta: (e) => !e.metaKey,
  left: (e) => "button" in e && e.button !== 0,
  middle: (e) => "button" in e && e.button !== 1,
  right: (e) => "button" in e && e.button !== 2,
  exact: (e, t) => Oa.some((n) => e[`${n}Key`] && !t.includes(n))
}, Sa = (e, t) => {
  const n = e._withMods || (e._withMods = {}), o = t.join(".");
  return n[o] || (n[o] = (s, ...i) => {
    for (let r = 0; r < t.length; r++) {
      const l = Da[t[r]];
      if (l && l(s, t)) return;
    }
    return e(s, ...i);
  });
}, Va = /* @__PURE__ */ ne({ patchProp: ba }, oa);
let oi;
function Ca() {
  return oi || (oi = Oc(Va));
}
const $a = (...e) => {
  const t = Ca().createApp(...e);
  process.env.NODE_ENV !== "production" && (Ia(t), ka(t));
  const { mount: n } = t;
  return t.mount = (o) => {
    const s = Ma(o);
    if (!s) return;
    const i = t._component;
    !k(i) && !i.render && !i.template && (i.template = s.innerHTML), s.nodeType === 1 && (s.textContent = "");
    const r = n(s, !1, Ta(s));
    return s instanceof Element && (s.removeAttribute("v-cloak"), s.setAttribute("data-v-app", "")), r;
  }, t;
};
function Ta(e) {
  if (e instanceof SVGElement)
    return "svg";
  if (typeof MathMLElement == "function" && e instanceof MathMLElement)
    return "mathml";
}
function Ia(e) {
  Object.defineProperty(e.config, "isNativeTag", {
    value: (t) => jr(t) || Rr(t) || Fr(t),
    writable: !1
  });
}
function ka(e) {
  {
    const t = e.config.isCustomElement;
    Object.defineProperty(e.config, "isCustomElement", {
      get() {
        return t;
      },
      set() {
        et(
          "The `isCustomElement` config option is deprecated. Use `compilerOptions.isCustomElement` instead."
        );
      }
    });
    const n = e.config.compilerOptions, o = 'The `compilerOptions` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, `compilerOptions` must be passed to `@vue/compiler-dom` in the build setup instead.\n- For vue-loader: pass it via vue-loader\'s `compilerOptions` loader option.\n- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader\n- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc';
    Object.defineProperty(e.config, "compilerOptions", {
      get() {
        return et(o), n;
      },
      set() {
        et(o);
      }
    });
  }
}
function Ma(e) {
  if (Q(e)) {
    const t = document.querySelector(e);
    return process.env.NODE_ENV !== "production" && !t && et(
      `Failed to mount app: mount target selector "${e}" returned null.`
    ), t;
  }
  return process.env.NODE_ENV !== "production" && window.ShadowRoot && e instanceof window.ShadowRoot && e.mode === "closed" && et(
    'mounting on a ShadowRoot with `{mode: "closed"}` may lead to unpredictable bugs'
  ), e;
}
/**
* vue v3.5.24
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function Aa() {
  ea();
}
process.env.NODE_ENV !== "production" && Aa();
function co() {
  const e = at(null), t = at(!0), n = at(null), o = async () => {
    try {
      const s = window.__HICON_CONFIG__, i = (s == null ? void 0 : s.pricingConfigUrl) || "/config/pricing.json", r = await fetch(i);
      if (!r.ok)
        throw new Error("Kunne ikke indlæse priskonfiguration");
      const l = await r.json();
      e.value = l;
    } catch (s) {
      n.value = s instanceof Error ? s.message : "Ukendt fejl";
    } finally {
      t.value = !1;
    }
  };
  return Dt(() => {
    o();
  }), { config: e, loading: t, error: n };
}
const si = to({
  quantity: 10,
  sizeId: "",
  railingId: ""
}), Tt = at(1);
function _n() {
  return {
    selection: si,
    currentStep: Tt,
    updateSelection: (s) => {
      Object.assign(si, s);
    },
    setCurrentStep: (s) => {
      Tt.value = s;
    },
    nextStep: () => {
      Tt.value = Math.min(Tt.value + 1, 4);
    },
    prevStep: () => {
      Tt.value = Math.max(Tt.value - 1, 1);
    }
  };
}
let wo = null;
function Pa() {
  return wo || (wo = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)), wo;
}
function mt(e, t = {}) {
  const n = {
    event: e,
    timestamp: Date.now(),
    sessionId: Pa(),
    locale: "da-DK",
    ...t
  };
  typeof window < "u" && (window.dispatchEvent(new CustomEvent("hicon.analytics", { detail: n })), window.dataLayer && window.dataLayer.push(n));
}
const xe = {
  calculatorViewed: () => mt("calculator_viewed"),
  stepViewed: (e) => mt("step_viewed", { step: e }),
  selectionMade: (e, t) => mt("selection_made", { field: e, value: t }),
  estimateShown: (e) => mt("estimate_shown", e),
  ctaClicked: (e) => mt("cta_clicked", { cta: e }),
  emailSubmitted: (e) => mt("email_submitted", { has_marketing_consent: e }),
  abandon: (e) => mt("abandon", { last_step: e })
};
if (typeof window < "u") {
  let e = "antal";
  window.addEventListener("beforeunload", () => {
    xe.abandon(e);
  }), window.addEventListener("hicon.step-change", (t) => {
    e = t.detail.step;
  });
}
const ja = { class: "w-full max-w-md mx-auto mb-8" }, Ra = { class: "flex justify-between mb-2" }, Fa = { class: "text-xs font-medium" }, La = { class: "w-full bg-gray-200 rounded-full h-2" }, Ha = /* @__PURE__ */ nt({
  __name: "ProgressIndicator",
  props: {
    currentStep: {},
    totalSteps: {}
  },
  setup(e) {
    const t = e, n = ["Antal", "Størrelse", "Værn", "Estimat"], o = (i) => i === t.currentStep, s = (i) => i < t.currentStep;
    return (i, r) => (B(), X("div", ja, [
      m("div", Ra, [
        (B(), X(ue, null, os(n, (l, c) => m("div", {
          key: c + 1,
          class: Lt([
            "flex flex-col items-center",
            o(c + 1) || s(c + 1) ? "text-[var(--hicon-primary)]" : "text-gray-400"
          ])
        }, [
          m("div", {
            class: Lt([
              "w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium mb-1",
              s(c + 1) || o(c + 1) ? "bg-[var(--hicon-primary)] text-white" : "bg-gray-200 text-gray-400"
            ])
          }, Z(c + 1), 3),
          m("span", Fa, Z(l), 1)
        ], 2)), 64))
      ]),
      m("div", La, [
        m("div", {
          class: "bg-[var(--hicon-primary)] h-2 rounded-full transition-all duration-300",
          style: Zn({ width: `${(e.currentStep - 1) / (e.totalSteps - 1) * 100}%` })
        }, null, 4)
      ])
    ]));
  }
}), Ka = { class: "bg-red-50 border border-red-200 rounded-lg p-4 mb-6" }, Ua = { class: "flex items-center" }, Ba = { class: "text-red-700 text-sm" }, Wa = /* @__PURE__ */ nt({
  __name: "ErrorBanner",
  props: {
    message: {}
  },
  setup(e) {
    return (t, n) => (B(), X("div", Ka, [
      m("div", Ua, [
        n[2] || (n[2] = m("span", { class: "h-5 w-5 text-red-500 mr-2" }, "⚠", -1)),
        m("div", null, [
          n[0] || (n[0] = m("h4", { class: "text-red-800 font-medium" }, "Konfigurationsfejl", -1)),
          m("p", Ba, Z(e.message), 1),
          n[1] || (n[1] = m("p", { class: "text-red-700 text-sm mt-1" }, " Prøv at genindlæse siden eller kontakt Hi-Con for hjælp. ", -1))
        ])
      ])
    ]));
  }
}), qa = ["disabled"], za = {
  key: 0,
  class: "w-4 h-4 mr-2 animate-spin"
}, ft = /* @__PURE__ */ nt({
  __name: "Button",
  props: {
    variant: { default: "primary" },
    size: { default: "md" },
    loading: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    className: { default: "" }
  },
  setup(e) {
    const t = e, { onClick: n } = t, o = {
      primary: "hicon-button-primary",
      secondary: "hicon-button-secondary",
      outline: "border border-[var(--hicon-primary)] text-[var(--hicon-primary)] hover:bg-[var(--hicon-primary)] hover:text-white"
    }, s = {
      sm: "h-9 px-3 text-sm",
      md: "h-11 px-4 py-2",
      lg: "h-12 px-8 text-lg"
    };
    return (i, r) => (B(), X("button", pr({
      class: [
        "inline-flex items-center justify-center font-medium rounded-lg transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hicon-focus-ring",
        o[e.variant],
        s[e.size],
        e.className
      ],
      disabled: e.disabled || e.loading
    }, i.$attrs), [
      e.loading ? (B(), X("span", za, "⟳")) : Ht("", !0),
      Ui(i.$slots, "default")
    ], 16, qa));
  }
}), Ga = { class: "max-w-2xl mx-auto text-center" }, Ja = { class: "bg-white rounded-xl p-8 shadow-sm border" }, Ya = { class: "mb-6" }, Za = ["value"], Qa = { class: "flex items-center justify-center gap-4 mb-6" }, Xa = ["value"], eu = {
  key: 0,
  class: "bg-orange-50 border border-orange-200 rounded-lg p-4 mb-6"
}, tu = /* @__PURE__ */ nt({
  __name: "Step1",
  setup(e) {
    const { selection: t, updateSelection: n, nextStep: o } = _n(), s = (p) => Math.max(10, Math.min(500, p));
    Dt(() => {
      xe.stepViewed("antal"), t.quantity < 10 && n({ quantity: 10 });
    });
    const i = (p) => {
      const u = s(p);
      n({ quantity: u }), xe.selectionMade("antal", u);
    }, r = (p) => {
      const u = p.target;
      i(s(parseInt(u.value)));
    }, l = (p) => {
      const u = p.target, f = parseInt(u.value) || 1;
      i(s(f));
    }, c = () => {
      t.quantity >= 10 && o();
    };
    return (p, u) => (B(), X("div", Ga, [
      u[6] || (u[6] = m("h2", { class: "text-3xl font-bold hicon-heading mb-4" }, " Hvor mange altaner? ", -1)),
      u[7] || (u[7] = m("p", { class: "text-gray-600 mb-8 hicon-body" }, " Jo flere altaner, jo lavere pris pr. altan. ", -1)),
      m("div", Ja, [
        m("div", Ya, [
          m("input", {
            class: "hicon-range",
            type: "range",
            min: "10",
            max: "500",
            value: U(t).quantity,
            onInput: r,
            "aria-label": "Antal altaner"
          }, null, 40, Za),
          u[0] || (u[0] = m("div", { class: "flex justify-between text-sm text-gray-500 mt-1" }, [
            m("span", null, "10"),
            m("span", null, "500")
          ], -1))
        ]),
        m("div", Qa, [
          u[1] || (u[1] = m("label", {
            for: "quantity-input",
            class: "text-lg font-medium text-gray-700 hicon-body"
          }, " Antal: ", -1)),
          m("input", {
            id: "quantity-input",
            type: "number",
            min: "10",
            max: "500",
            value: U(t).quantity,
            onInput: l,
            class: "w-20 px-3 py-2 text-center text-lg font-bold border border-gray-300 rounded-lg focus:ring-2 focus:ring-[var(--hicon-primary)] focus:border-transparent hicon-focus-ring"
          }, null, 40, Xa),
          u[2] || (u[2] = m("span", { class: "text-gray-500 hicon-body" }, "altaner", -1))
        ]),
        U(t).quantity > 200 ? (B(), X("div", eu, [...u[3] || (u[3] = [
          m("p", { class: "text-orange-800 text-sm hicon-body" }, " 💡 Ved store projekter anbefaler vi at kontakte os tidligt om design og projektering. ", -1)
        ])])) : Ht("", !0),
        u[5] || (u[5] = m("div", { class: "mb-6" }, [
          m("p", { class: "text-sm text-gray-600 hicon-body" }, [
            De(" Vidste du, at en undersøgelse viser, at produktionen af Hi-Cons konceptaltaner udleder 22,8 % mindre CO₂ end en stålaltan? "),
            m("a", {
              href: "https://www.hi-con.dk/videnscenter/altaner-i-ultra-hoejstyrkebeton-vs-staalaltaner/",
              target: "_blank",
              rel: "noopener",
              class: "underline"
            }, " Læs mere her ")
          ])
        ], -1)),
        ee(ft, {
          onClick: c,
          size: "lg",
          class: "w-full"
        }, {
          default: Ie(() => [...u[4] || (u[4] = [
            De(" Næste: Vælg størrelse ", -1)
          ])]),
          _: 1
        })
      ])
    ]));
  }
}), nu = (e) => Math.round(e / 1e3) * 1e3, ou = (e) => `${e.toLocaleString("da-DK", { maximumFractionDigits: 0 })} DKK`, su = ["role", "tabindex"], Er = /* @__PURE__ */ nt({
  __name: "Card",
  props: {
    className: { default: "" },
    selected: { type: Boolean, default: !1 },
    onClick: {}
  },
  setup(e) {
    const t = e, n = (o) => {
      t.onClick && o.key === "Enter" && t.onClick();
    };
    return (o, s) => (B(), X("div", {
      class: Lt([
        "bg-white rounded-lg border transition-all duration-200",
        e.onClick ? "cursor-pointer hover:shadow-md" : "",
        e.selected ? "hicon-card-selected" : "border-gray-200 hover:border-gray-300",
        e.className
      ]),
      onClick: s[0] || (s[0] = //@ts-ignore
      (...i) => e.onClick && e.onClick(...i)),
      role: e.onClick ? "button" : void 0,
      tabindex: e.onClick ? 0 : void 0,
      onKeydown: n
    }, [
      Ui(o.$slots, "default")
    ], 42, su));
  }
}), iu = { class: "max-w-4xl mx-auto text-center" }, ru = { class: "grid md:grid-cols-3 gap-6 mb-8" }, lu = { class: "aspect-video bg-gray-100 rounded-lg mb-4 flex items-center justify-center" }, cu = { class: "text-2xl font-bold text-gray-400 hicon-body" }, au = { class: "text-xl font-bold text-[var(--hicon-primary)] mb-2 hicon-body" }, uu = { class: "text-sm text-gray-600 mb-2 hicon-body" }, fu = { class: "text-sm text-[var(--hicon-primary)] font-medium hicon-body" }, du = { class: "flex gap-4 justify-center" }, pu = /* @__PURE__ */ nt({
  __name: "Step2",
  setup(e) {
    const { selection: t, updateSelection: n, nextStep: o, prevStep: s } = _n(), { config: i } = co();
    Dt(() => {
      xe.stepViewed("storrelse");
    });
    const r = (c) => {
      n({ sizeId: c }), xe.selectionMade("storrelse", c);
    }, l = () => {
      t.sizeId && o();
    };
    return (c, p) => {
      var u;
      return B(), X("div", iu, [
        p[2] || (p[2] = m("h2", { class: "text-3xl font-bold hicon-heading mb-4" }, " Vælg størrelse ", -1)),
        p[3] || (p[3] = m("p", { class: "text-gray-600 mb-8 hicon-body" }, " Alle størrelser har samme høje kvalitet og levetid. ", -1)),
        m("div", ru, [
          (B(!0), X(ue, null, os((u = U(i)) == null ? void 0 : u.sizes, (f) => (B(), Xe(Er, {
            key: f.id,
            selected: U(t).sizeId === f.id,
            onClick: () => r(f.id),
            class: "p-6 h-full"
          }, {
            default: Ie(() => [
              m("div", lu, [
                m("div", cu, Z(f.name), 1)
              ]),
              m("h3", au, Z(f.name), 1),
              m("p", uu, " Forkanttykkelse: " + Z(f.edge_thickness), 1),
              m("div", fu, " Fra " + Z(U(ou)(U(nu)(f.slab_unit_price))), 1)
            ]),
            _: 2
          }, 1032, ["selected", "onClick"]))), 128))
        ]),
        p[4] || (p[4] = m("div", { class: "text-center mb-8" }, [
          m("p", { class: "text-gray-600 text-sm hicon-body" }, " Konceptaltanen kan også fås i andre dimensioner. Kontakt os for at høre mere. ")
        ], -1)),
        m("div", du, [
          ee(ft, {
            variant: "outline",
            onClick: U(s)
          }, {
            default: Ie(() => [...p[0] || (p[0] = [
              De(" Tilbage ", -1)
            ])]),
            _: 1
          }, 8, ["onClick"]),
          ee(ft, {
            onClick: l,
            disabled: !U(t).sizeId,
            size: "lg"
          }, {
            default: Ie(() => [...p[1] || (p[1] = [
              De(" Næste: Vælg værn ", -1)
            ])]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]);
    };
  }
}), hu = {
  R1: "Fra 1.200 DKK/lbm",
  R2: "Fra 1.300 DKK/lbm",
  R3: "Fra 1.600 DKK/lbm"
}, gu = {
  S: "1,6 × 2,6 m",
  M: "1,8 × 3,6 m",
  L: "2,0 × 5,0 m"
}, mu = {
  R1: "Rundstålsbalustreværn",
  R2: "Fladstålsbalustreværn",
  R3: "Glasværn"
}, vu = { class: "max-w-4xl mx-auto text-center" }, _u = { class: "grid md:grid-cols-3 gap-6 mb-8" }, bu = {
  class: "bg-gray-100 rounded-lg mb-4 overflow-hidden",
  style: { height: "140px" }
}, yu = ["src", "alt"], Eu = { class: "text-xl font-bold text-[var(--hicon-primary)] mb-2 hicon-body" }, Nu = { class: "text-gray-700 mb-4 hicon-body" }, xu = { class: "text-sm text-[var(--hicon-primary)] font-medium hicon-body" }, wu = { class: "flex gap-4 justify-center" }, Ou = /* @__PURE__ */ nt({
  __name: "Step3",
  setup(e) {
    const { selection: t, updateSelection: n, nextStep: o, prevStep: s } = _n(), { config: i } = co(), r = {
      R1: "/assets/images/vaern/rundstal.jpg",
      R2: "/assets/images/vaern/fladstal.jpg",
      R3: "/assets/images/vaern/glas.jpg"
    };
    Dt(() => {
      xe.stepViewed("vaern");
    });
    const l = (p) => {
      n({ railingId: p }), xe.selectionMade("vaern", p);
    }, c = () => {
      t.railingId && o();
    };
    return (p, u) => {
      var f;
      return B(), X("div", vu, [
        u[2] || (u[2] = m("h2", { class: "text-3xl font-bold hicon-heading mb-4" }, " Vælg værn-design ", -1)),
        m("div", _u, [
          (B(!0), X(ue, null, os((f = U(i)) == null ? void 0 : f.railings, (g) => (B(), Xe(Er, {
            key: g.id,
            selected: U(t).railingId === g.id,
            onClick: () => l(g.id),
            class: "p-6 h-full"
          }, {
            default: Ie(() => [
              m("div", bu, [
                m("img", {
                  src: r[g.id],
                  alt: g.name,
                  class: "railing-image w-full h-full object-cover",
                  loading: "lazy",
                  style: { display: "block", "border-radius": "8px" }
                }, null, 8, yu)
              ]),
              m("h3", Eu, Z(g.name), 1),
              m("p", Nu, Z(g.description), 1),
              m("div", xu, Z(U(hu)[g.id]), 1)
            ]),
            _: 2
          }, 1032, ["selected", "onClick"]))), 128))
        ]),
        u[3] || (u[3] = m("div", { class: "bg-green-50 border border-green-200 rounded-lg p-4 mb-8" }, [
          m("p", { class: "text-green-800 text-sm hicon-body" }, [
            De(" ✅ "),
            m("strong", null, "Brugt i førende boligprojekter"),
            De(" – designet til lang levetid ")
          ])
        ], -1)),
        m("div", wu, [
          ee(ft, {
            variant: "outline",
            onClick: U(s)
          }, {
            default: Ie(() => [...u[0] || (u[0] = [
              De(" Tilbage ", -1)
            ])]),
            _: 1
          }, 8, ["onClick"]),
          ee(ft, {
            onClick: c,
            disabled: !U(t).railingId,
            size: "lg"
          }, {
            default: Ie(() => [...u[1] || (u[1] = [
              De(" Se dit estimat ", -1)
            ])]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]);
    };
  }
});
function as(e) {
  return Math.ceil(e / 1e3) * 1e3;
}
function Du(e, t, n) {
  const o = e * t + n;
  return as(o);
}
function Su(e, t, n, o, s) {
  const i = e * t / o * n + s;
  return as(i);
}
function Vu(e, t) {
  let n = 0;
  if (e < 100) {
    const { a: o, b: s, c: i, d: r, base: l } = t.lt100;
    n = e * o / Math.pow(s, i - e / 10) + e * r + l;
  } else e >= 100 && (n = e * t.ge100_per_unit + t.base);
  return as(n);
}
function Cu(e, t) {
  const n = t.sizes.find((f) => f.id === e.sizeId), o = t.railings.find((f) => f.id === e.railingId), { slab_fixed: s, railing_fixed: i, brackets: r } = t.formula_constants, l = Du(e.qty, n.slab_unit_price, s), c = Su(e.qty, n.slab_unit_price, o.unit_price, n.railing_divisor, i), p = Vu(e.qty, r), u = l + c + p;
  return {
    slab_total: l,
    railing_total: c,
    bracket_total: p,
    grand_total: u
  };
}
function $u(e, t) {
  const n = t.find((o) => e >= o.min && e <= o.max);
  return n ? { multiplier: n.multiplier, label: n.label } : { multiplier: 1, label: "Basis" };
}
function Tu(e, t) {
  const { quantity: n, sizeId: o, railingId: s } = e, i = t.sizes.find((f) => f.id === o), r = t.railings.find((f) => f.id === s);
  if (!i || !r)
    throw new Error("Ugyldig størrelse eller værn-valg");
  if (t.formula_constants) {
    const f = Cu(
      { qty: n, sizeId: o, railingId: s },
      t
    );
    return {
      slab: {
        name: "Altanplader",
        unitPrice: i.slab_unit_price,
        quantity: n,
        multiplier: 1,
        total: f.slab_total
      },
      railing: {
        name: "Værn",
        unitPrice: r.unit_price,
        quantity: n,
        multiplier: 1,
        total: f.railing_total
      },
      bracket: {
        name: "Beslag",
        unitPrice: 0,
        // Not used in new formula
        quantity: n,
        multiplier: 1,
        total: f.bracket_total
      },
      discountLabel: "Basis",
      subtotal: f.grand_total,
      grandTotal: f.grand_total
    };
  }
  const l = $u(n, t.quantity_discounts), c = i.slab_unit_price * n * l.multiplier, p = r.unit_price * n * l.multiplier, u = i.bracket_unit_price * n * l.multiplier;
  return {
    slab: {
      name: "Altanplader",
      unitPrice: i.slab_unit_price,
      quantity: n,
      multiplier: l.multiplier,
      total: c
    },
    railing: {
      name: "Værn",
      unitPrice: r.unit_price,
      quantity: n,
      multiplier: l.multiplier,
      total: p
    },
    bracket: {
      name: "Beslag",
      unitPrice: i.bracket_unit_price,
      quantity: n,
      multiplier: l.multiplier,
      total: u
    },
    discountLabel: l.label,
    subtotal: c + p + u,
    grandTotal: c + p + u
  };
}
function wn(e, t = "DKK") {
  return `${Math.round(e).toLocaleString("da-DK", { useGrouping: !0 })} ${t}`;
}
async function Iu(e, t) {
  await fetch(t, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json"
    },
    mode: "no-cors",
    body: JSON.stringify(e)
  });
}
const ku = { class: "max-w-4xl mx-auto" }, Mu = { class: "grid lg:grid-cols-2 gap-8" }, Au = { class: "bg-white rounded-xl p-6 shadow-sm border" }, Pu = { class: "space-y-4" }, ju = { class: "flex justify-between items-center py-2 border-b border-gray-100" }, Ru = { class: "font-medium hicon-body" }, Fu = { class: "flex justify-between items-center py-2 border-b border-gray-100" }, Lu = { class: "font-medium hicon-body" }, Hu = { class: "flex justify-between items-center py-2 border-b border-gray-100" }, Ku = { class: "font-medium hicon-body" }, Uu = {
  key: 0,
  class: "flex justify-between items-center py-2 bg-green-50 px-3 rounded"
}, Bu = { class: "font-medium text-green-700 hicon-body" }, Wu = { class: "bg-white rounded-xl p-6 shadow-sm border" }, qu = {
  key: 0,
  class: "space-y-3 mb-6"
}, zu = { class: "flex justify-between items-center" }, Gu = { class: "font-medium hicon-body" }, Ju = { class: "flex justify-between items-center" }, Yu = { class: "text-gray-600 hicon-body" }, Zu = { class: "font-medium hicon-body" }, Qu = { class: "flex justify-between items-center" }, Xu = { class: "text-gray-600 hicon-body" }, ef = { class: "font-medium hicon-body" }, tf = { class: "flex justify-between items-center text-lg font-bold text-[var(--hicon-primary)]" }, nf = { class: "hicon-body" }, of = { class: "mt-8 space-y-6" }, sf = { class: "bg-white rounded-xl p-6 shadow-sm border" }, rf = { class: "flex items-start space-x-2" }, lf = {
  key: 1,
  class: "text-center py-4"
}, cf = { class: "text-gray-600 hicon-body" }, af = { class: "grid md:grid-cols-2 gap-4" }, uf = { class: "text-center" }, ff = /* @__PURE__ */ nt({
  __name: "Step4",
  setup(e) {
    const { selection: t, prevStep: n } = _n(), { config: o } = co(), s = at(""), i = at(!1), r = at(!1), l = at(!1), c = In(() => !o.value || !t.sizeId || !t.railingId ? null : Tu(t, o.value)), p = In(() => {
      var S;
      return (S = o.value) == null ? void 0 : S.sizes.find((V) => V.id === t.sizeId);
    }), u = In(() => {
      var S;
      return (S = o.value) == null ? void 0 : S.railings.find((V) => V.id === t.railingId);
    });
    Dt(() => {
      xe.stepViewed("estimat"), o.value && t.sizeId && t.railingId && c.value && xe.estimateShown({
        ...c.value,
        version: o.value.version
      });
    });
    const f = (S) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(S), g = (S) => new Intl.NumberFormat("da-DK", { style: "currency", currency: "DKK", maximumFractionDigits: 0 }).format(S), w = () => {
      xe.ctaClicked("kontakt"), window.open("https://www.hi-con.dk/kontakt/", "_blank");
    }, M = async () => {
      if (xe.ctaClicked("email"), !f(s.value)) {
        alert("Indtast en gyldig e-mail.");
        return;
      }
      if (!i.value) {
        alert("Du skal give samtykke for at fortsætte.");
        return;
      }
      r.value = !0;
      try {
        const S = window.__HICON_CONFIG__, V = S == null ? void 0 : S.zapierHookUrl;
        if (!V)
          throw new Error("Zapier webhook URL ikke konfigureret");
        if (!c.value || !o.value)
          throw new Error("Estimat ikke tilgængeligt");
        const G = gu[t.sizeId], R = mu[t.railingId], j = `${location.origin}/altan-prisberegner?qty=${t.quantity}&size=${t.sizeId}&railing=${t.railingId}`, fe = {
          email: s.value,
          consentMarketing: !0,
          selections: { qty: t.quantity, sizeId: t.sizeId, railingId: t.railingId },
          labels: { size: G, railing: R },
          estimate: {
            slab_total: c.value.slab.total,
            railing_total: c.value.railing.total,
            bracket_total: c.value.bracket.total,
            grand_total: c.value.grandTotal,
            formatted: {
              slab: g(c.value.slab.total),
              railing: g(c.value.railing.total),
              brackets: g(c.value.bracket.total),
              total: g(c.value.grandTotal)
            }
          },
          pricingVersion: o.value.version || "2.0.0",
          openUrl: j
        };
        await Iu(fe, V), l.value = !0, xe.emailSubmitted(!0);
      } catch (S) {
        alert(S.message ?? "Der skete en fejl.");
      } finally {
        r.value = !1;
      }
    };
    return (S, V) => {
      var G, R;
      return B(), X("div", ku, [
        V[18] || (V[18] = m("div", { class: "text-center mb-8" }, [
          m("h2", { class: "text-3xl font-bold hicon-heading mb-4" }, " Dit estimat "),
          m("p", { class: "text-gray-600 hicon-body" }, " Baseret på dine valg - klar til budgetlægning ")
        ], -1)),
        m("div", Mu, [
          m("div", Au, [
            V[6] || (V[6] = m("h3", { class: "text-xl font-bold text-[var(--hicon-primary)] mb-4 hicon-body" }, "Dine valg", -1)),
            m("div", Pu, [
              m("div", ju, [
                V[2] || (V[2] = m("span", { class: "text-gray-600 hicon-body" }, "Antal altaner:", -1)),
                m("span", Ru, Z(U(t).quantity), 1)
              ]),
              m("div", Fu, [
                V[3] || (V[3] = m("span", { class: "text-gray-600 hicon-body" }, "Størrelse:", -1)),
                m("span", Lu, Z((G = p.value) == null ? void 0 : G.name), 1)
              ]),
              m("div", Hu, [
                V[4] || (V[4] = m("span", { class: "text-gray-600 hicon-body" }, "Værn:", -1)),
                m("span", Ku, Z((R = u.value) == null ? void 0 : R.name), 1)
              ]),
              c.value && c.value.discountLabel !== "Basis" ? (B(), X("div", Uu, [
                V[5] || (V[5] = m("span", { class: "text-green-700 font-medium hicon-body" }, "Mængderabat:", -1)),
                m("span", Bu, Z(c.value.discountLabel), 1)
              ])) : Ht("", !0)
            ])
          ]),
          m("div", Wu, [
            V[10] || (V[10] = m("h3", { class: "text-xl font-bold text-[var(--hicon-primary)] mb-4 hicon-body" }, "Prisestimat", -1)),
            c.value ? (B(), X("div", qu, [
              m("div", zu, [
                V[7] || (V[7] = m("span", { class: "text-gray-600 hicon-body" }, "Altanplader:", -1)),
                m("span", Gu, Z(U(wn)(c.value.slab.total)), 1)
              ]),
              m("div", Ju, [
                m("span", Yu, Z(c.value.railing.name) + ":", 1),
                m("span", Zu, Z(U(wn)(c.value.railing.total)), 1)
              ]),
              m("div", Qu, [
                m("span", Xu, Z(c.value.bracket.name) + ":", 1),
                m("span", ef, Z(U(wn)(c.value.bracket.total)), 1)
              ]),
              V[9] || (V[9] = m("hr", { class: "border-gray-200" }, null, -1)),
              m("div", tf, [
                V[8] || (V[8] = m("span", { class: "hicon-body" }, "Samlet estimeret pris:", -1)),
                m("span", nf, Z(U(wn)(c.value.grandTotal)), 1)
              ])
            ])) : Ht("", !0),
            V[11] || (V[11] = m("div", { class: "text-xs text-gray-500 bg-gray-50 p-3 rounded mb-4" }, [
              m("p", { class: "mb-2 hicon-body" }, "OBS! Prisen er eksklusiv montage. Den er vejledende og baseret på konceptuelle forudsætninger."),
              m("p", { class: "hicon-body" }, "PS: Statisk dokumentation iht. SBI271 er altid inkluderet i prisen, så du kan føle dig tryg i dit valg af materiale og samarbejdspartner.")
            ], -1))
          ])
        ]),
        m("div", of, [
          m("div", sf, [
            V[15] || (V[15] = m("h4", { class: "text-lg font-bold text-[var(--hicon-primary)] mb-4 hicon-body" }, "Få estimatet tilsendt på mail", -1)),
            l.value ? (B(), X("div", lf, [
              V[14] || (V[14] = m("div", { class: "text-green-600 font-medium mb-2 hicon-body" }, "✅ Estimat sendt!", -1)),
              m("p", cf, "Vi har sendt dit estimat til " + Z(s.value), 1)
            ])) : (B(), X("form", {
              key: 0,
              onSubmit: Sa(M, ["prevent"]),
              class: "space-y-4"
            }, [
              m("div", null, [
                Ns(m("input", {
                  type: "email",
                  "onUpdate:modelValue": V[0] || (V[0] = (j) => s.value = j),
                  placeholder: "Din e-mailadresse",
                  class: "w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[var(--hicon-primary)] focus:border-transparent hicon-focus-ring hicon-body",
                  required: ""
                }, null, 512), [
                  [Na, s.value]
                ])
              ]),
              m("div", rf, [
                Ns(m("input", {
                  type: "checkbox",
                  id: "marketing-consent",
                  "onUpdate:modelValue": V[1] || (V[1] = (j) => i.value = j),
                  class: "mt-1",
                  required: ""
                }, null, 512), [
                  [xa, i.value]
                ]),
                V[12] || (V[12] = m("label", {
                  for: "marketing-consent",
                  class: "text-sm text-gray-600 hicon-body"
                }, " Jeg giver samtykke til at modtage marketing fra Hi-Con ApS og accepterer Hi-Cons privatlivspolitik. ", -1))
              ]),
              ee(ft, {
                type: "submit",
                class: "w-full",
                size: "lg",
                disabled: !i.value || !s.value || r.value,
                loading: r.value
              }, {
                default: Ie(() => [
                  V[13] || (V[13] = m("span", { class: "mr-2" }, "✉", -1)),
                  De(" " + Z(r.value ? "Sender..." : "Send estimat"), 1)
                ]),
                _: 1
              }, 8, ["disabled", "loading"])
            ], 32))
          ]),
          m("div", af, [
            ee(ft, {
              onClick: w,
              size: "lg",
              class: "w-full mx-auto max-w-md",
              variant: "secondary"
            }, {
              default: Ie(() => [...V[16] || (V[16] = [
                m("span", { class: "mr-2" }, "📞", -1),
                De(" Tal med en specialist ", -1)
              ])]),
              _: 1
            })
          ]),
          m("div", uf, [
            ee(ft, {
              variant: "outline",
              onClick: U(n)
            }, {
              default: Ie(() => [...V[17] || (V[17] = [
                De(" Tilbage og rediger valg ", -1)
              ])]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]);
    };
  }
}), df = { class: "bg-gray-50" }, pf = {
  key: 0,
  class: "bg-gray-50 flex items-center justify-center py-24"
}, hf = {
  key: 1,
  class: "bg-gray-50 py-12 px-4"
}, gf = { class: "max-w-4xl mx-auto" }, mf = {
  key: 2,
  class: "max-w-6xl mx-auto px-4 py-12"
}, vf = { class: "mt-12" }, _f = {
  key: 3,
  class: "bg-white border-t"
}, bf = /* @__PURE__ */ nt({
  __name: "App",
  setup(e) {
    const { config: t, loading: n, error: o } = co(), { currentStep: s } = _n();
    return Dt(() => {
      xe.calculatorViewed();
    }), $n(s, (i) => {
      window.dispatchEvent(new CustomEvent("hicon.step-change", { detail: { step: i } }));
    }), (i, r) => (B(), X("div", df, [
      r[2] || (r[2] = js('<header class="bg-white border-b relative"><div class="relative z-10 mx-auto w-full max-w-7xl px-4 md:px-6 py-4 md:py-6"><section class="hicon-hero"><h1 class="hicon-hero-title m-0 text-black leading-tight break-words text-[clamp(22px,3.2vw,40px)] font-bold hicon-heading mb-2"> Beregn pris på konceptaltaner </h1><p class="hicon-hero-sub text-gray-600 text-lg hicon-body"> Få et hurtigt budgetestimat – åben pris og fuld transparens. </p></section></div></header>', 1)),
      U(n) ? (B(), X("div", pf, [...r[0] || (r[0] = [
        m("div", { class: "text-center" }, [
          m("div", { class: "w-8 h-8 animate-spin text-[var(--hicon-primary)] mx-auto mb-4" }, "⟳"),
          m("p", { class: "text-gray-600 hicon-body" }, "Indlæser prisberegner...")
        ], -1)
      ])])) : U(o) || !U(t) ? (B(), X("div", hf, [
        m("div", gf, [
          ee(Wa, {
            message: U(o) || "Kunne ikke indlæse priskonfiguration"
          }, null, 8, ["message"])
        ])
      ])) : (B(), X("div", mf, [
        ee(Ha, {
          "current-step": U(s),
          "total-steps": 4
        }, null, 8, ["current-step"]),
        m("div", vf, [
          U(s) === 1 ? (B(), Xe(tu, { key: 0 })) : U(s) === 2 ? (B(), Xe(pu, { key: 1 })) : U(s) === 3 ? (B(), Xe(Ou, { key: 2 })) : U(s) === 4 ? (B(), Xe(ff, { key: 3 })) : Ht("", !0)
        ])
      ])),
      !U(n) && !U(o) && U(t) ? (B(), X("div", _f, [...r[1] || (r[1] = [
        js('<div class="max-w-6xl mx-auto px-4 py-8"><div class="grid md:grid-cols-3 gap-6 text-center"><div class="text-gray-600"><div class="font-medium text-[var(--hicon-primary)] mb-1 hicon-body">Ultra højstyrkebeton</div><div class="text-sm hicon-body">Slanke og stærke elementer</div></div><div class="text-gray-600"><div class="font-medium text-[var(--hicon-primary)] mb-1 hicon-body">Brugt i førende boligprojekter</div><div class="text-sm hicon-body">Brugt af arkitekter og entreprenører</div></div><div class="text-gray-600"><div class="font-medium text-[var(--hicon-primary)] mb-1 hicon-body">100+ års levetid</div><div class="text-sm hicon-body">Holdbare og vedligeholdelsesfrie elementer</div></div></div></div>', 1)
      ])])) : Ht("", !0)
    ]));
  }
});
(function() {
  const t = "hiconCalcSid";
  let n = localStorage.getItem(t);
  n || (n = Math.random().toString(36).slice(2) + Date.now(), localStorage.setItem(t, n)), window.dataLayer = window.dataLayer || [], window.addEventListener("hicon.analytics", (o) => {
    const s = o.detail || {};
    window.dataLayer.push({
      event: "hicon_analytics",
      // GTM trigger name
      sessionId: n,
      ...s
      // e.g., { type:"step_viewed", step:"vaern", qty: 24, ... }
    });
  }), location.hostname === "localhost" && console.info("[hicon] analytics bridge active");
})();
const Mt = class Mt {
  constructor() {
    po(this, "defaults", {
      locale: "da-DK",
      mountOnLoad: !0,
      pricingConfigUrl: "/assets/config/pricing.json",
      logoUrl: "/assets/images/logo-hicon.svg"
    });
    if (Mt.instance)
      return Mt.instance;
    Mt.instance = this;
  }
  mount(t, n) {
    const o = document.querySelector(t);
    if (!o) {
      console.error(`Hi-Con Calculator: Container not found: ${t}`);
      return;
    }
    const s = { ...this.defaults, ...n };
    window.__HICON_CONFIG__ = s, $a(bf).mount(o);
  }
  autoMount() {
    document.querySelectorAll('[id="hicon-calculator"]').forEach((n) => {
      const o = n.getAttribute("data-config");
      let s = {};
      if (o)
        try {
          s = JSON.parse(o);
        } catch {
          console.warn("Hi-Con Calculator: Invalid data-config JSON");
        }
      this.mount(`#${n.id}`, s);
    });
  }
};
po(Mt, "instance");
let Lo = Mt;
const Ho = new Lo();
document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", () => {
  Ho.autoMount();
}) : Ho.autoMount();
window.HiConCalculator = Ho;
export {
  Ho as default
};
